import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
    classifyPolygon,
    classifyEditedPolygon,
    buildPolygonPayload,
    isPointInsideField,
    ClassifiedPolygon,
} from './field-polygon-utils';

// import {
//     ApexAxisChartSeries,
//     ApexChart,
//     ApexDataLabels,
//     ApexFill,
//     ApexGrid,
//     ApexLegend,
//     ApexResponsive,
//     ApexStroke,
//     ApexTitleSubtitle,
//     ApexTooltip,
//     ApexXAxis,
//     ApexYAxis,
//     ChartComponent
// } from 'ng-apexcharts';
import { BehaviorSubject, forkJoin, fromEvent, of, pairwise, Subject, throwError } from 'rxjs';
import { AllPinsDeleteComponent } from '../dialogs/all-pins-delete/all-pins-delete.component';
import { DateRangeComponent } from '../dialogs/date-range/date-range.component';
import { PinClearComponent } from '../dialogs/pin-clear/pin-clear.component';
import { PinDeleteComponent } from '../dialogs/pin-delete/pin-delete.component';
import { PinDescriptionComponent } from '../dialogs/pin-description/pin-description.component';
import { RainMeterSelectionComponent } from '../dialogs/rain-meter-selection/rain-meter-selection.component';
import { FieldInspectionDialogComponent } from '../dialogs/pin-rework-dialogs/field-inspection-dialog/field-inspection-dialog.component';
import { RainfallCaptureComponent } from '../dialogs/rainfall-capture/rainfall-capture.component';
import { SavePinComponent } from '../dialogs/save-pin/save-pin.component';
import { HelperService } from '../helper.service';
import { ChartData, Data, Series } from '../models/chartData';
import { CropType } from '../models/cropType';
import { DynamicPin } from '../models/dynamicPin';
import { Field } from '../models/field';
// import { FieldHistory } from '../models/fieldHistory';
import { FieldLegend } from '../models/fieldLegend';
import { History } from '../models/history';
import { Ndvi } from '../models/ndvi';
import { Pin } from '../models/pin';
import { RainMeters } from '../models/rainMeters';
import { SatelliteHistory } from '../models/satelliteHistory';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

declare var google: any;

import { animate, group, state, style, transition, trigger } from '@angular/animations';

import { GoogleMap, MapInfoWindow } from '@angular/google-maps';
import { ThemePalette } from '@angular/material/core';

import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, UrlSegment, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import _moment from 'moment';

import { default as _rollupMoment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NewAreaComponent } from '../dialogs/new-area/new-area.component';
import { SaveChangesComponent } from '../dialogs/save-changes/save-changes.component';
import { FieldArea } from '../models/fieldArea';
import { MultiPolygon } from '../models/multiPolygon';
import { MultiPolygonField } from '../models/multiPolygonField';
import { Polygon } from '../models/polygon';
import { RemoveArea } from '../models/removeArea';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Database, ref, push, set, serverTimestamp } from '@angular/fire/database';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { FarmManagementService } from '../services/farm-management.service';
import { AnalysisManagementService } from '../services/analysis-management.service';
import { MappingService } from '../services/mapping.service';
import { RainfallService } from '../services/rainfall.service';
import { GeosysManagementService } from '../services/geosys-management.service';
import { BoundaryManagementService } from '../services/boundary-management.service';
import { Base } from '../services/base';
import { MapsTypesAvailabilityDto } from '../dto/MapsTypesAvailabilityDto';
import { MapDataFarmComponent } from '../map-data/map-data-farm/map-data-farm.component';
import { MapDataFieldComponent } from '../map-data/map-data-field/map-data-field.component';
import { AvailableMapsFieldModel } from '../models/availableMapsFieldModel';
import { FieldAvailableMapsDto } from '../dto/FieldAvailableMapsDto';
import { FieldImageryLegendDto } from '../dto/FieldImageryLegendDto';

import dayjs from 'dayjs'
import { MapsTypesAvailabilityModel } from '../models/mapsTypesAvailabilityModel';
import { SelectedFarmMapsItemModel } from '../models/selectedFarmMapsItemModel';
import { NewSavePinComponent } from "../dialogs/pin-rework-dialogs/new-save-pin/new-save-pin.component";
import {NewSaveGridComponent} from "../dialogs/sampling-grid-dialogs/new-save-grid/new-save-grid/new-save-grid.component";
import { SoilPinSamplesComponent } from "../dialogs/pin-rework-dialogs/soil-pin-samples/soil-pin-samples.component";
import { VirtualConsultantPinComponent } from "../dialogs/pin-rework-dialogs/virtual-consultant-pin/virtual-consultant-pin.component";
import { MarkerPinComponent } from "../dialogs/pin-rework-dialogs/marker-pin/marker-pin.component";

import { catchError } from "rxjs/operators";
import { PinManagerService } from "../services/pin-manager.service";
import { DeleteSampleComponent } from '../dialogs/delete-sample/delete-sample.component';
import { ViewSavedPinComponent } from '../dialogs/pin-rework-dialogs/view-saved-pin/view-saved-pin.component';
import { PestPinComponent } from '../dialogs/pin-rework-dialogs/pest-pin/pest-pin.component';
import { WeatherForecastComponent } from '../weather-forecast/weather-forecast.component';
import { WeatherForecastService } from '../weather-forecast/weather-forecast.service';
import { FeatureFlagsService } from '../unleash-feature-flags/feature-flags.service';
import { WaterPinComponent } from '../dialogs/pin-rework-dialogs/water-pin/water-pin.component';
import { DiseasePinComponent } from '../dialogs/pin-rework-dialogs/disease-pin/disease-pin.component';
import { PinType } from '../models/pinType';
import { SoftTissuePinSamplesComponent } from '../dialogs/pin-rework-dialogs/soft-tissue-pin-samples/soft-tissue-pin-samples.component';
import { SeasonMetaDataCombinedModel } from '../models/season-models/season-meta-data-combined-model';
import { SeasonManagerService } from '../services/season-manager.service';
import { SeasonSharedDataService } from '../services/season-shared-data.service';
import { SeasonDetailFieldModel } from '../models/season-models/season-detail-field-model';
import { ExstraDetailModel } from '../models/season-models/exstra-detail-model';
import {FieldDetailsComponent} from "../dialogs/field-details/field-details.component";
import {SeasonDetailFieldModelBE} from "../models/season-models/season-detail-field-model-be";
import { YieldEstimationPinComponent } from '../dialogs/pin-rework-dialogs/yield-estimation-pin/yield-estimation-pin.component';
import { NTesterPinComponent } from '../dialogs/pin-rework-dialogs/n-tester-pin/n-tester-pin.component';
import { NewPin } from '../models/NewPin ';
import {SeasonDropdownModel} from "../models/season-models/season-dropdown-model";
import {GrowthStageModel} from "../models/growth-stage";
import { AnalysisLegendStatsModel } from '../models/analysis-managment-models/analysis-stats-model/analysis-legend-stats-model';
import {EditFieldComponent} from "../dialogs/edit-field/edit-field.component";
import {NewFieldComponent} from "../dialogs/new-field/new-field.component";
import {AddField} from "../models/addField";
import {CirclePolygon} from "../models/circlePolygon";
import {FieldDetailsService} from "../services/field-details.service";
import { environment } from "src/environments/environment";
import type { EChartsOption } from 'echarts';
import { Role } from '../models/role';
import { GridManagerDialogComponent } from '../dialogs/grid-manager-dialog/grid-manager-dialog.component';
import { ConfirmGridCloseComponent } from '../dialogs/confirm-grid-close/confirm-grid-close.component';
import { RetrievePinGriddingComponent } from '../dialogs/pin-rework-dialogs/retrieve-pin-gridding/retrieve-pin-gridding.component';
import { GroupService } from '../services/group.service';
import {StopDrawingComponent} from "../dialogs/stop-drawing/stop-drawing.component";
import { ChemicalCompareSideModel } from '../chemical-compare/chemical-compare-models/chemical-compare-side-model';
import { ChemicalCompareService } from '../chemical-compare/chemical-compare-services/chemical-compare.service';
import { ChemicalCompareMapSyncService } from '../chemical-compare/chemical-compare-services/chemical-compare-map-sync.service';



const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
    parse: {
        dateInput: 'L',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'YYYY-MM-DD',
        dateA11yLabel: 'L',
        monthYearA11yLabel: 'YYYY-MM-DD',
    },
};

// export type ChartOptions = {
//     series: ApexAxisChartSeries;
//     chart: ApexChart;
//     chartSmall: ApexChart;
//     xaxis: ApexXAxis;
//     dataLabels: ApexDataLabels;
//     grid: ApexGrid;
//     stroke: ApexStroke;
//     title: ApexTitleSubtitle;
//     legend: ApexLegend;
//     yaxis: ApexYAxis;
//     responsive: ApexResponsive;
//     redrawOnParentResize: Boolean;
//     redrawOnWindowResize: Boolean;
// };
//
// export type PinChart = {
//     series: ApexAxisChartSeries;
//     chart: ApexChart;
//     xaxis: ApexXAxis;
//     yaxis: ApexYAxis | ApexYAxis[];
//     title: ApexTitleSubtitle;
//     stroke: ApexStroke;
//     dataLabels: ApexDataLabels;
//     fill: ApexFill;
//     tooltip: ApexTooltip;
//     legend: ApexLegend;
// };

 interface  satelliteHistory{
    id: number,
    fieldId: number,
    imageDate: string,
    lastModified: string,
    coverageType: string,
}

interface GridDialogResult {
    gridSpacing: number;
    unitOfMeasurement: string;
    gridRotation: number;
    isSequential: boolean;
    pointName: string;
}

@Component({
    selector: 'app-field',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.css'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('slideInOut', [
            state('in', style({ width: '15px', 'opacity': '1', 'flex': '1 1 1%' })),
            state('out', style({ 'opacity': '1', 'flex': '1 1 100%' }), { params: { inWidth: '450px' } }),
            transition('in => out', [group([
                    animate('100ms ease-in-out', style({
                        'opacity': '1'
                    })),
                    animate('100ms ease-in-out', style({
                        width: '{{ inWidth }}px'
                    })),
                    animate('100ms ease-in-out', style({
                        'flex': '1 1 100%'
                    }))
                ])]),
            transition('out => in', [
                animate('100ms ease-in-out', style({
                    'opacity': '1'
                })),
                animate('100ms ease-in-out', style({
                    width: '15px'
                })),
                animate('100ms ease-in-out', style({
                    'flex': '1 1 1%'
                }))
            ])
        ]),
        trigger('rotate', [
            state('in', style({ transform: 'rotate(0deg)' })),
            state('out', style({ transform: 'rotate(180deg)' })),
            transition('in => out', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(0deg)'
                }))
            ]),
            transition('out => in', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(180deg)'
                }))
            ])
        ]),
        trigger('slideInOut1', [
            state('in', style({ width: '15px', 'opacity': '1', 'flex': '1 1 1%' })),
            state('out', style({ 'opacity': '1', 'flex': '1 1 100%' }), { params: { inWidth: '450px' } }),
            transition('in => out', [group([
                    animate('100ms ease-in-out', style({
                        'opacity': '1'
                    })),
                    animate('100ms ease-in-out', style({
                        width: '{{ inWidth }}px'
                    })),
                    animate('100ms ease-in-out', style({
                        'flex': '1 1 100%'
                    }))
                ])]),
            transition('out => in', [
                animate('100ms ease-in-out', style({
                    'opacity': '1'
                })),
                animate('100ms ease-in-out', style({
                    width: '15px'
                })),
                animate('100ms ease-in-out', style({
                    'flex': '1 1 1%'
                }))
            ])
        ]),
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class FieldComponent implements OnInit, OnDestroy {

    legendStatsMapOne: AnalysisLegendStatsModel = null;
    legendStatsMapTwo: AnalysisLegendStatsModel = null;
    isMapTypeSoilMapOne: boolean = false;
    isMapTypeSoilMapTwo: boolean = false;
    placeholder: string = '-';
    mapTwoIsOpen = false;
    isSequenceViewRoleActive: boolean = false;
    isGriddingViewRoleActive: boolean = false;
    isGriddingControlVisable: boolean = true;

    griddingGroupName: string = '';

    myCustomColor: ThemePalette = 'primary';
    myCustomValue = 50;
    mode: ProgressSpinnerMode = 'indeterminate';
    chartDataCount: number = 0;

    public showField: boolean = true;

    animationState = 'out';
    animationState1 = 'in';
    seasonDetailCallCount: number = 0;

    private fieldGoogleMap: GoogleMap;

    savedPinStartDate = '';
    savedPinEndDate = '';

    fieldWidth: number;
    satelliteWidth: number;

    currentMapNumber: number;

    toggleLegend: boolean = false;
    toggleLegendTwo: boolean = false;
    isSingleTypeSequenceViewActive: boolean = false;
    isCustomSequenceViewActive: boolean = false;
    @ViewChild('map') agmMapOne: GoogleMap;
    @ViewChild('map1') agmMapTwo: GoogleMap;

    // @ViewChild('ndviCharts', { static: false }) ndviCharts: ChartComponent;
    // @ViewChild('pinsChart', { static: false }) pinsChart: ChartComponent;
    public chartOptions;
    public pinChart;

    mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;

    public tenantIdSubject = new BehaviorSubject<number>(null);
    tenantId$ = this.tenantIdSubject.asObservable();

    flex2: number = 100;
    flex3: number = 0;
    flex4: number = 0;

    latitude: number = 30.5595;
    longitude: number = 22.9375;
    markers = [];
    tmpMarkers = [];
    isPinsShowing = false;
    openedWindow: number = 0;
    pinCounter = 1;
    tmpId = 0;
    tmpPins: Pin[] = [];
    showGridLines: boolean = true;
    gridLines: google.maps.Polyline[] = [];
    currentRotation: number = 0;
    originalRotation: number = 0;
    toggleGridManager: boolean = false;
    graphIds: number[] = [];
    tmpData: DynamicPin[] = [];
    muNameList: DynamicPin[] = [];
    topographyChartData: any = null;
    barChartData: DynamicPin[] = [];
    chartData: ChartData[][] = [];
    tmpChartData: ChartData[][] = [];
    newChartData = [];
    chartBarLegend = [];
    public roles: Role[];
    viewChemicalCompare: boolean = false;
    isVrtCreatorRole: boolean = false;

    splitField: boolean = false;
    splitFieldName: string = '';
    busyEditing: string = '';
    map;
    drawing: string = '';
    stillDrawing: boolean = false;
    saveEditedField: boolean = false;
    splitPolygon;

    isDrawingMode: boolean = false;
    drawingType: 'polygon' | 'circle' | null = null;
    drawnPoints: google.maps.LatLngLiteral[] = [];
    drawnMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
    previewLine: google.maps.Polyline = null;
    previewPolyline: google.maps.Polyline = null;
    previewPolygon: google.maps.Polygon = null;
    circleCenter: google.maps.LatLngLiteral = null;
    previewCircle: google.maps.Circle = null;
    circleListeners: google.maps.MapsEventListener[] = [];
    isDraggingCircle: boolean = false;
    originalAreaPoints: google.maps.LatLngLiteral[] = [];
    originalCircleCenter: google.maps.LatLngLiteral;
    originalCircleRadius: number;
    saveEditedArea: boolean = false;

    private fieldMap: google.maps.Map;

    excludeAreaFieldName: string = '';

    tableData: DynamicPin[] = [];
    nonNumerical: boolean = false;

    public geoJsonObject: Object[] = [];
    public geoJsonObject1: Object[] = [];

    public histories: History[] = [];

    filteredListItem: AvailableMapsFieldModel[] = [];

    private seasonMetaDataDetails: SeasonMetaDataCombinedModel;
    existingPin: NewPin;


    seasonFormData: SeasonDetailFieldModel = null;
    seasonFormExtraData: ExstraDetailModel = null;


    private _capturedClassified: ClassifiedPolygon | null = null;

    isInAnotherActiveSeason: boolean = false;
    isControlDisabled: boolean = false;
    isCallDone: boolean = false;
    isViewFieldDetailsActive: boolean = false;
    isPinMarkersVisible: boolean = false;

    tenantId: number;
    userId: number;
    fieldId: number;
    fieldName: string;
    activeHistoryId;
    navigateField: boolean;
    inspectionKey;
    description;
    lat;
    lng;

    newCropTypeId;
    newCultivar;
    newFieldName;
    newpDate;
    newPlantDate;
    newYieldAvg;

    // public fieldHistory: FieldHistory;
    public ndviTmpData: Ndvi[];
    public ndviDate = [];
    public ndviMinSeries = [];
    public ndviMaxSeries = [];
    public ndviMeanSeries = [];

    cultivar: string = '';
    plantDate: string = '';
    fieldS: number = 0;
    cropTypeList: CropType[] = [];
    cropId: number = 0;
    selectedCropId: string = '';
    selectedCrop: string = '';
    yieldAvg: number = 0;
    notificationsCheck: boolean;
    harvestedCheck: boolean;

    selectedPinType: PinType;
    existingMarker = null;

    public historyTitleMapOne: string = '';
    public historyTitleMapTwo: string = '';
    public historySubTitleMapOne: string = '';
    public historySubTitleMapTwo: string = '';
    public historyDateMapOne: string = '';
    public historyDateMapTwo: string = '';

    public titleMapOne: boolean = false;
    public titleMapTwo: boolean = false;
    public mapsClose: boolean = false;
    public mapsAlreadyOpen: boolean = false;

    public showOverlay: boolean = false;
    public isPinLabelsShowing:boolean = false;

    currentMarkers = [];

    // Sampling grid properties
    samplingPoints: any[] = [];
    showSamplingPoints: boolean = false;

    isChemCompareViewActive: boolean = false;
    showChemCompareLegends: boolean = false;
    // chemCompareAllMaps: AvailableMapsFieldModel[] = [];
    // chemCompareAvailableYears: string[] = [];
    // chemCompareSoilType: string = null;
    // chemCompareLeftYear: string = null;
    // chemCompareRightYear: string = null;
    // chemCompareLeftEntries: ChemCompareEntry[] = [];
    // chemCompareRightEntries: ChemCompareEntry[] = [];

    chemCompareLeft: ChemicalCompareSideModel = { soilType: null, availableYears: [], allMaps: [], selectedYear: null, entries: [] };
    chemCompareRight: ChemicalCompareSideModel = { soilType: null, availableYears: [], allMaps: [], selectedYear: null, entries: [] };


    chemCompareChemicalTypes: { type: string, alias: string }[] = [];
    openGridManager: boolean = false;
    openExtraGrid: boolean = false;
    selectedGridPoints = [];
    gridDialogResult: GridDialogResult;
    addNewGridPoint: boolean = false;
    gridPointId: number = 0;
    originalBounds: {north: number, south: number, east: number, west: number};
    isGeneratingGrid: boolean = false;


      public environment = environment;

    public lastModified;

    public aType;
    public ndviChart: boolean;

    fieldForm: any = new FormGroup({
        cropType: new FormControl(''),
        fieldName: new FormControl(''),
        cultivar: new FormControl(''),
        fieldSize: new FormControl(''),
        plantDate: new FormControl(''),
        yieldAvg: new FormControl('')
    });

    seasons: SeasonDropdownModel[] = [];

    public fromDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
    public toDate = moment().format('YYYY-MM-DD');

    maxDate = new Date();
    minDate = '';


    public formattedFrom = moment().subtract(6, 'months').format('DD MMM');
    public formattedTo = moment().format('DD MMM');

    private isTrackingActive = false;
    private trackingMarker;
    private watchId = -1;

    tenantChanged = false;
    private initialTenantId: number = null;
    private tenantSubscription: any;

    private rainMeters: RainMeters[];

    farmName = '';
    farmId = -1;

    startDate = moment().subtract(1, 'months').format('YYYY-MM-DD');
    endDate = moment().format('YYYY-MM-DD');


    fieldLegendsMapOne: FieldLegend[] = [];
    fieldLegendsMapTwo: FieldLegend[] = [];
    unsortedFieldLegends: FieldLegend[] = [];
    unsortedFieldLegends1: FieldLegend[] = [];

    satelliteHistories: SatelliteHistory[] = [];
    showGraphs: boolean = false;
    scrolled: boolean = false;

    bounds;
    mapLat;
    mapLng;
    map1Lat;
    map1Lng;
    fieldBounds;
    unsortedPolygons = [];

    refresed = true;

    selectedMapsItem: SelectedFarmMapsItemModel;
    selectedFarmMapsItem: SelectedFarmMapsItemModel;
    analysisTypesAvailable: MapsTypesAvailabilityModel[] = [];

    center = { lat: this.latitude, lng: this.longitude };
    isWeatherForecastEnabled: boolean = false;
    showWeatherCard: boolean = false;
    weatherForecasts: any[] = [];
    isWeatherLoading: boolean = false;
    fieldBoundaryColor: string = environment.google.mapConfig.polygonStrokeColour;
    fieldBoundaryEditColor: string = environment.google.mapConfig.polygonEditingStrokeColour;

    polygonOptions: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryEditColor,
        strokeWeight: 4,
    };

    drawingManager: google.maps.drawing.DrawingManager;
    editing: boolean = false;
    editingArea: boolean = false;
    editablePolygon: google.maps.Polygon;
    editableCircle: google.maps.Circle;
    addedPolygons = [];
    newPolygon = [];
    saveField: Boolean = false;
    saveArea: boolean = false;

    singlePolygon: google.maps.PolygonOptions = {
        strokeColor: this.fieldBoundaryColor,
        strokeWeight: 4,
        fillOpacity: 0.0
    };

    options: google.maps.MapOptions = {
        mapTypeId: 'satellite',
        zoomControl: true,
        mapId: 'DEMO_MAP_ID',
        scrollwheel: true,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        streetViewControl: false
    };

    public subscription;
    oneAction: boolean = false;
    action: any = '';

    newHistory;
    history;
    polygon;
    overlay;
    originalPolygon;
    polygons = [];
    overlayedFieldAnalysis = [];
    farmImages = [];
    fieldIndex;
    historyFieldIndex;
    fieldImagesMapTwo = [];
    fieldImagesMapOne = [];
    profitabilityPolygons: google.maps.Polygon[] = [];
    isVectorOverlay: boolean = false;
    isLoadingOverlay: boolean = false;
    opacity = 1.0;
    @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
    infoContent = '';
    profitabilityInfoWindow: google.maps.InfoWindow = null;
    profitabilitySummary: any = null;

    customUrlIcon = '';





    public iconUrl = {
        urlNewTemp: '../../assets/icons/new_pin_updated.png',
        urlMarker: '../../assets/icons/marker_pin.png',
        urlSoftVirualConsultant: '../../assets/icons/virtual_consultant_pin.png',
        urlSoftTissue: '../../assets/icons/soft_tissue_pin.png',
        urlSoil: '../../assets/icons/soil_pin.png',
        urlWater: '../../assets/icons/water_pin.png',
        urlDisease: '../../assets/icons/disease_pin.png',
        urlPest: '../../assets/icons/pest_pin.png',
        urlFertilizer: '../../assets/icons/fertilizer_pin.png',
        urlYieldEst: '../../assets/icons/yield_estimations_pin.png',
        urlNester: '../../assets/icons/Ntester_pin.png',
        urlSelected: '../../assets/icons/white_pin.png',
        urlSoilCompleted: '../../assets/icons/soil_completed.png',
        urlSoftTissueCompleted: '../../assets/icons/soft_tissue_completed.png',
        urlFieldInspection: '../../assets/icons/field_inspection_pin.png'
    }

    icon = this.iconUrl ? this.iconUrl.urlNewTemp : this.iconUrl.urlMarker;
    markerOptions: google.maps.MarkerOptions = {
        icon: this.icon
    };

    pinLabelOptions = {
        color: 'white',
        fontFamily: environment.theme.fontFamily || '',
        fontSize: '14px',
        fontWeight: 'bold',
        text: '',
    }

    pinMarker = {
        id: -1,
        position: {lat: -1, lng: -1},
        title: '',
        farmName: '',
        label: this.pinLabelOptions,
        content: this.createMarkerContent(this.icon)
    };

    marker = {
        id: -1,
        position: { lat: -1, lng: -1 },
        title: '',
        farmName: '',
        content: this.createMarkerContent(this.icon)
    };
    softSoilCount = {
        softCount: 0,
        soilCount: 0
    }

    public zoom: number = 2;

    public pinAnalysis = '';
    public removePins = '';
    public savedPins = '';
    public loadingSavedPins = '';
    public compareAnalysis = '';
    public satHistory = '';
    public capRainfall = '';
    public edit = '';
    public closeEdit = '';
    public area = '';
    public excludingArea = '';
    public editingField = '';
    public editArea = '';
    public removeArea = '';

    worker;

    selectedAnalysis = this.translate.instant('HISTORY.FILTER-ALL');

    analysisDates;

    autoChartsCheck = true;
    circle;
    loadingPins: boolean = false;
    savedPinsDataCounter = 0;
    savedPinsData: Pin[];
    newSavedPinsData: Pin[] = [];
    newSavedPins = [];
    geosysFieldId: string;
    pinsCalled: boolean = false;

    previousValue: MapsTypesAvailabilityModel;

    public isOpen: boolean = false;
    public isAnalysisEmpty: boolean = false;
    hideAnalysisLabel: boolean = false;
    hasError: any;
    snackBar: any;

    constructor(private _bottomSheet: MatBottomSheet,
        public base: Base,
        public farmManagementService: FarmManagementService,
        public analysisManagementService: AnalysisManagementService,
        public geosysManagementService: GeosysManagementService,
        public rainfallService: RainfallService,
        public mappingService: MappingService,
        public boundaryManagementService: BoundaryManagementService,
        media: MediaMatcher,
        private changeDetectorRef: ChangeDetectorRef,
        public dialog: MatDialog,
        public nav: NavBarComponent,
        public helper: HelperService,
        public _snackBar: MatSnackBar,
        public router: Router,
        private db: Database,
        public translate: TranslateService,
        private spinner: NgxSpinnerService,
        public projectTitle: Title,
        public pinManagerService: PinManagerService,
        private seasonManagerService: SeasonManagerService,
        private seasonSharedDataService: SeasonSharedDataService,
        private route: ActivatedRoute,
        private fieldDetailsService: FieldDetailsService,
        private groupService: GroupService,
        private weatherForecastService: WeatherForecastService,
        private featureFlagsService: FeatureFlagsService,
        public chemicalCompareService: ChemicalCompareService,
        private chemCompareMapSyncService: ChemicalCompareMapSyncService
    ) {

        // this.selectedFarmMapsItem = history.state.selectedFarmItem;
        // if(this.selectedFarmMapsItem !== null){
        //     this.overlayMapItemFromFarmSelection(1);
        // }

        this.nav.toggleLoading(false);
        this.showOverlay = false;

        if (typeof Worker !== 'undefined') {
            this.worker = new Worker(new URL('../web-workers/dynamic-pins.worker', import.meta.url), { type: 'module' });
            ;
            this.worker.onmessage = ({ data }) => {
                this.charts(JSON.parse(data));
                // this.worker.terminate();
            };
        } else {
            // //console.log("Web Workers are not supported by your browser");
        }

        this.pinAnalysis = this.translate.instant('FIELD.PIN-ANALYSIS');
        this.removePins = this.translate.instant('FIELD.REMOVE-PINS');
        this.loadingSavedPins = this.translate.instant('FIELD.LOADING-PINS');
        this.savedPins = this.translate.instant('FIELD.SAVED-PINS');
        this.compareAnalysis = this.translate.instant('FIELD.COMPARE-ANALYSIS');
        this.satHistory = this.translate.instant('FIELD.SATELITE-HISTORY');
        this.capRainfall = this.translate.instant('FIELD.CAPTURE-RAINFALL');
        this.edit = this.translate.instant('FIELD.EDIT-FIELD');
        this.closeEdit = this.translate.instant('FIELD.CLOSE-EDIT');
        this.area = this.translate.instant('FIELD.EXCLUDE-AREA');
        this.excludingArea = this.translate.instant('FIELD.EXCLUDING-AREA');
        this.editingField = this.translate.instant('FIELD.EDITING-FIELD');
        this.editArea = this.translate.instant('FIELD.EDITING-AREA');
        this.removeArea = this.translate.instant('FIELD.REMOVE-AREA');
        this.busyEditing = this.translate.instant("MAPPING.EDITING");
        this.drawing = this.translate.instant("MAPPING.DRAWING");
        this.analysisDates = this.startDate + ' ' + this.translate.instant('HISTORY.FILTER-TO') + ' ' + this.endDate;

        //   this.animationState = 'out';
        // this.animationState1 = 'in';

        this.chartOptions = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                }
            },
            legend: {
                data: ['Min', 'Max', 'Mean'],
                right: 10,
                top: 10
            },
            toolbox: {
                feature: {
                    dataZoom: {
                        title: {
                            zoom: 'Zoom Area',
                            back: 'Reset Zoom'
                        }
                    },
                    restore: {
                        title: 'Reset'
                    },
                    saveAsImage: {
                        title: 'Save as Image'
                    }
                },
                right: 10,
                top: 40
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '20%',
                top: '20%',
                containLabel: true
            },
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    xAxisIndex: 0,
                    start: 0,
                    end: 100,
                    height: 20,
                    bottom: 10,
                    handleSize: '80%',
                    backgroundColor: '#e2e2e2',
                    fillerColor: 'rgba(0, 150, 136, 0.2)',
                    borderColor: '#ccc'
                },
                {
                    type: 'inside',
                    xAxisIndex: 0,
                    start: 0,
                    end: 100,
                    zoomLock: false,
                    zoomOnMouseWheel: true,
                    moveOnMouseMove: true,
                    showDetail: true,
                }
            ],
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: this.ndviDate,
                axisTick: {
                    show: false
                },
                axisLabel: {
                    rotate: 90,
                    interval: 0,
                    formatter: (value, index) => {
                        const totalLabels = this.ndviDate.length;

                        let skipInterval;
                        if (totalLabels > 180) {
                            skipInterval = Math.ceil(totalLabels / 20);
                        } else if (totalLabels > 90) {
                            skipInterval = Math.ceil(totalLabels / 25);
                        } else if (totalLabels > 60) {
                            skipInterval = Math.ceil(totalLabels / 30);
                        } else if (totalLabels > 30) {
                            skipInterval = Math.ceil(totalLabels / 20);
                        } else {
                            skipInterval = 1;
                        }

                        return index % skipInterval === 0 ? value : '';
                    },
                    hideOverlap: true
                }
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: 1,
                axisLabel: {
                    formatter: '{value}'
                }
            },
            series: [
                {
                    name: 'Min',
                    type: 'line',
                    data: this.ndviMinSeries,
                    itemStyle: { color: '#663333' },
                    lineStyle: {
                        width: 2,
                        color: '#663333'
                    },
                    symbol: 'circle',
                    symbolSize: 0,
                    showSymbol: false,
                    emphasis: {
                        focus: 'series',
                        itemStyle: {
                            borderColor: '#663333',
                            borderWidth: 2
                        },
                        symbolSize: 8
                    }
                },
                {
                    name: 'Max',
                    type: 'line',
                    data: this.ndviMaxSeries,
                    itemStyle: { color: '#0000CC' },
                    lineStyle: {
                        width: 2,
                        color: '#0000CC'
                    },
                    symbol: 'circle',
                    symbolSize: 0,
                    showSymbol: false,
                    emphasis: {
                        focus: 'series',
                        itemStyle: {
                            borderColor: '#0000CC',
                            borderWidth: 2
                        },
                        symbolSize: 8
                    }
                },
                {
                    name: 'Mean',
                    type: 'line',
                    data: this.ndviMeanSeries,
                    itemStyle: { color: '#33CC00' },
                    lineStyle: {
                        width: 2,
                        color: '#33CC00'
                    },
                    symbol: 'circle',
                    symbolSize: 0,
                    showSymbol: false,
                    emphasis: {
                        focus: 'series',
                        itemStyle: {
                            borderColor: '#33CC00',
                            borderWidth: 2
                        },
                        symbolSize: 8
                    }
                }
            ]
        };

        this.pinChart = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                show: false
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                type: 'value'
            },
            series: []
        };

        let cols = document.getElementsByClassName('apexcharts-bar-area');

        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        if (this.mobileQuery.matches) {
            this.flex2 = 50;
        }

        this.base.menuIsOpen$.subscribe((menu) => {
            window.dispatchEvent(new Event('resize'));
        });

        // if(this.agmMapOne && this.agmMapTwo){
        // this.syncMaps(this.agmMapOne, this.agmMapTwo);
        // this.syncMaps(this.agmMapTwo, this.agmMapOne);
        // }

    }


    // open close map-menu-circular
    openOptions() {
        this.isOpen = !this.isOpen;
    }

    ngOnInit(): void {
        this.isWeatherForecastEnabled = this.featureFlagsService.isEnabled('weather_forecast_feature');

        setTimeout(() => {
            this.nav.toggleLoading(false);
        }, 5000);

        // Check current route on init (handles refresh)
        if (this.router.url.includes('/field/custom-sequence')) {
            this.isCustomSequenceViewActive = true;
        } else if (this.router.url.includes('/field/sequence')) {
            this.isSingleTypeSequenceViewActive = true;
        } else if (this.router.url.includes('/field/chemical-compare')) {
            this.isChemCompareViewActive = true;
        }

        // Listen to router events to detect when leaving sequence view
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.includes('/field/custom-sequence')) {
                    this.isCustomSequenceViewActive = true;
                    this.isSingleTypeSequenceViewActive = false;
                    this.isChemCompareViewActive = false;
                } else if (event.url.includes('/field/sequence')) {
                    this.isSingleTypeSequenceViewActive = true;
                    this.isCustomSequenceViewActive = false;
                    this.isChemCompareViewActive = false;
                } else if (event.url.includes('/field/chemical-compare')) {
                    this.isChemCompareViewActive = true;
                    this.isSingleTypeSequenceViewActive = false;
                    this.isCustomSequenceViewActive = false;
                } else {
                    this.isSingleTypeSequenceViewActive = false;
                    this.isCustomSequenceViewActive = false;
                    this.isChemCompareViewActive = false;
                }
            }
        });

        // Prevent navigation during field operations
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // If we're performing field operations and the navigation would take us away from field component
                if ((this.editing || this.editingArea || this.saveEditedField || this.saveEditedArea) && 
                    event.url.includes('/mapping')) {
                    // Stay on current page and refresh instead
                    setTimeout(() => {
                        this.router.navigateByUrl(this.router.url);
                    }, 0);
                }
            }
        });

        this.minDate = moment(new Date().setFullYear(this.maxDate.getFullYear() - 11)).format('YYYY-MM-DD');
        if (history.state.id != null) {
            sessionStorage.removeItem('histories');
            this.fieldId = history.state.id;
            this.farmId = history.state.farmId;
            this.farmName = history.state.farmName;
            this.selectedFarmMapsItem = JSON.parse(sessionStorage.getItem('selectedFarmMapsItem'));
            if (history.state.fieldName != '') {
                this.fieldName = history.state.fieldName;
            }
            sessionStorage.setItem('currectField', JSON.stringify({ fieldId: this.fieldId, farmName: this.farmName, farmId: this.farmId }));
            // this.loadFieldHistories(this.fieldId);
            this.getNDVIIndexChartData(this.fieldId);

            if (sessionStorage.getItem('selectedTenant') != null) {
                this.tenantIdSubject.next(+sessionStorage.getItem('selectedTenant'));

                this.tenantId$.subscribe(id => {
                    this.tenantId = id;
                });
            }
            this.navigateField = history.state.navigateField;
            this.inspectionKey = history.state.inspectionKey;
            this.description = history.state.description;
            this.lat = history.state.lat;
            this.lng = history.state.lng;
            this.selectedAnalysis = history.state.analysisTypes;
            this.analysisDates = history.state.analysisDates;
            this.selectedAnalysis = this.translate.instant('HISTORY.FILTER-ALL');
            this.analysisDates = this.startDate + ' ' + this.translate.instant('HISTORY.FILTER-TO') + ' ' + this.endDate;
        } else if (history.state.fieldId != null) {
            this.downloadFarmFields(history.state.farmId);
            // sessionStorage.removeItem('histories');
            this.fieldId = history.state.fieldId;
            this.farmName = history.state.farmName;
            this.farmId = history.state.farmId;
            sessionStorage.setItem('currectField', JSON.stringify({ fieldId: this.fieldId, farmName: this.farmName, farmId: this.farmId }));
            // this.loadFieldHistories(this.fieldId);
            this.getNDVIIndexChartData(this.fieldId);

            if (sessionStorage.getItem('selectedTenant') != null) {
                this.tenantIdSubject.next(+sessionStorage.getItem('selectedTenant'));

                this.tenantId$.subscribe(id => {
                    this.tenantId = id;
                });
            }
            let marker = {
                id: this.tmpId,
                position: { lat: Number(history.state.lat), lng: Number(history.state.lng) },
                title: history.state.description,
                content: this.createMarkerContent(this.icon)
            };

            this.tmpId--;
            this.markers.push(marker);
        } else {
            let json = JSON.parse(sessionStorage.getItem('currectField'));
            this.fieldId = json.fieldId;
            this.farmName = json.farmName;
            this.farmId = json.farmId;
            // this.loadFieldHistories(this.fieldId);
            this.getNDVIIndexChartData(this.fieldId);

            if (sessionStorage.getItem('selectedTenant') != null) {
                this.tenantIdSubject.next(+sessionStorage.getItem('selectedTenant'));

                this.tenantId$.subscribe(id => {
                    this.tenantId = id;
                });
            }
        }

        // TODO: Check this should be part of SGS Gateway Codebase as well. (Currenly this is not a part of SGS Gateway Codebase)
        this.tenantSubscription = this.nav.tenantId$.subscribe(id => {
            this.rainfallService.getRainMeters(id).subscribe((rainMeters) => {
                this.rainMeters = rainMeters;
            });

            // Only navigate to mapping when tenant actually changes to a different value
            // (not on initial load or page refresh)
            if (!this.tenantChanged) {
                this.tenantChanged = true;
                this.initialTenantId = id;
            } else if (id !== this.initialTenantId) {
                this.initialTenantId = id;
                this.base.resetFarm();
                this.router.navigate(['mapping']);
                this.nav.toggleLoading(false);
            }
        });

        setTimeout(()=>{
            if(sessionStorage.getItem('selectedFarmMapsItem') !== undefined){
                this.overlayMapItemFromFarmSelection(1);
                this.showOverlay = true;
                this.nav.toggleLoading(true);
            }
        }, 200)

        setTimeout(() => {
            this.populateDetailField();
            this.seasonSharedDataService.updateIsHiddenData(true);

        }, 200)

        let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: null, fieldId: this.fieldId }
        this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(analysisType => {

            // check if at least one item is available  else hide maps button
            const hasAvailableItem = analysisType.some((item) => item.available);
            if ((hasAvailableItem == false && this.fieldId == -1) || (hasAvailableItem == false && this.fieldId !== -1)) {
                this.isAnalysisEmpty = false;
                this.hideAnalysisLabel = true;
            } else {
                this.isAnalysisEmpty = true;
            }
        });

        this.roles = JSON.parse(sessionStorage.getItem('roles'));
        this.viewChemicalCompare = this.roles?.some(r => r.name === 'ChemicalCompareAnalysisMapView') ?? false;
        this.isVrtCreatorRole = this.roles?.some(r => r.name === 'VrtCreator') ?? false;

        this.getMapsequenceRole();
        this.getGriddingViewRole();

        this.refreshField();
    }

    populateDetailField() {
        this.nav.toggleLoading(true);

        this.seasonManagerService.getDetailsOfFieldById(Number(this.fieldId)).pipe(
            catchError(error => {
                console.error();
                this.isCallDone = true;
                this.nav.toggleLoading(false);
                return throwError(() => error);
            })
        ).subscribe((response) => {
            this.seasonFormData = response;


            sessionStorage.setItem('currentFieldInfo', JSON.stringify({fieldName: this.seasonFormData.field?.name, fieldSize: String(this.seasonFormData?.field?.fieldSize)}));

            if(!this.seasonFormData.detail) {
                this.seasonFormData.detail = {
                    fieldName: this.seasonFormData.field.name,
                    allowNotifications: this.seasonFormData.field.allowNotifications,
                    fieldSize: this.seasonFormData.field.fieldSize
                }
            }

            this.isInAnotherActiveSeason = this.seasonFormData.field.isInAnotherActiveSeason;

            this.isCallDone = true;
            this.seasonSharedDataService.updateSeasonDetailBaseData(this.seasonFormData);
            this.seasonSharedDataService.updateIsDisabledData(this.isInAnotherActiveSeason);

            setTimeout(() => {
                this.nav.toggleLoading(false);
            }, 1400)

        });

    }

    viewFieldDetails() {
      this.fieldDetailsService.viewFieldDetails(this.fieldId, this.tenantId).subscribe({
        next: (response) => {
          // Update field name and detail from dialog result immediately — no re-fetch needed
          // since the dialog already saved to the API and returned the latest state.
          const updatedName = response?.details?.[0]?.fieldName ?? response?.detail?.fieldName;
          if (updatedName && this.seasonFormData?.field) {
            this.seasonFormData.field.name = updatedName;
            sessionStorage.setItem('currentFieldInfo', JSON.stringify({fieldName: updatedName, fieldSize: String(this.seasonFormData?.field?.fieldSize)}));
          }
        }
      });
    }

    openFieldInspections(): void {
      // Resolve crop definitions from seasonFormData if available.
      // Use the detail object directly — it has resolved descriptions already.
      // If not available, pass undefined so the dialog resolves via the season API.
      const fieldTypes = this.seasonSharedDataService['typeDataSubject']?.getValue() ?? [];
      const cropTypes = this.seasonSharedDataService['cropDataSubject']?.getValue() ?? [];

      let cropDefinitions: any[] | undefined = undefined;

      if (this.seasonFormData?.details?.length > 0 && fieldTypes.length > 0 && cropTypes.length > 0) {
        const resolved = (this.seasonFormData.details).map((d: any) => {
          const fieldTypeDesc = fieldTypes.find((t: any) => t.id === d.fieldType || t.id === d.fieldTypeId)?.description ?? '';
          const cropDesc = cropTypes.find((c: any) => c.id === d.currentCrop || c.id === d.currentCropId)?.description ?? '';
          return {
            id: d.id,
            crop: cropDesc,
            fieldType: fieldTypeDesc,
            label: cropDesc && fieldTypeDesc ? `${cropDesc} (${fieldTypeDesc})` : (cropDesc || fieldTypeDesc || 'Unknown')
          };
        }).filter((d: any) => d.crop || d.fieldType);

        // Only use resolved if we actually got results — otherwise let dialog fetch via API
        if (resolved.length > 0) {
          cropDefinitions = resolved;
        }
      }

      this.dialog.open(FieldInspectionDialogComponent, {
        data: {
          pinId: 0,
          fieldId: this.fieldId,
          tenantId: this.tenantId,
          seasonId: this.seasonFormData?.season?.id ?? null,
          farm: this.farmName,
          field: this.seasonFormData?.field?.name ?? '',
          lat: 0,
          lng: 0,
          viewOnly: false,
          isNewInspection: false,
          cropDefinitions
        },
        width: '900px',
        maxWidth: '95vw',
        height: '88vh',
        maxHeight: '88vh',
        autoFocus: false
      });
    }

    ngAfterViewInit() {
        if (history.state.id != null) {
            if (history.state.lat != null) {
                this.nav.toggleLoading(false);
                let marker = {
                    id: this.tmpId,
                    position: { lat: Number(history.state.lat), lng: Number(history.state.lng) },
                    title: history.state.description,
                    content: this.createMarkerContent(this.icon)
                };

                this.tmpId--;
                // this.markers.push(marker);

                this.showGraphs = true;
                this.getDynamicPins(this.tenantId, this.fieldId, marker.position.lat, marker.position.lng, true, marker.title, null);
            }
            this.downloadFarmFields(history.state.farmId);
        } else {
            let json = JSON.parse(sessionStorage.getItem('currectField'));
            this.loadFieldBoundary(json.fieldId);
        }
    }

    downloadFarmFields(farmId) {
        this.farmManagementService.getFarmFields(farmId).subscribe((fields) => {
            let jsonFields = JSON.stringify(fields);
            sessionStorage.setItem('fields', jsonFields);

            this.loadFieldBoundary(this.fieldId);
        });
    }

    styleFunc(feature) {

        return ({
            clickable: false,
            fillColor: feature.getProperty('Colour'),
            strokeWeight: 0,
            fillOpacity: 1
        });
    }

    openWindow(id) {
        this.openedWindow = id;
    }

    isInfoWindowOpen(id) {

        return this.openedWindow == id;
    }

    openMaps(map: number): void {
        if (!this.mapsAlreadyOpen) {
            this.mapsAlreadyOpen = true;
            let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: null, fieldId: this.fieldId };
            this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(availableTypes => {

                let mapTypesData = [];
                availableTypes.forEach(availableTypeobj => {
                    let mapsTypesAvailabilityModel: MapsTypesAvailabilityModel = {
                        type: availableTypeobj.type,
                        available: availableTypeobj.type.toLowerCase().includes('profitability') ? true : availableTypeobj.available,
                        alias: availableTypeobj.alias,
                        displayOrder: 1,
                        selected: false
                    };
                    mapTypesData.push(mapsTypesAvailabilityModel);
                });
                this.analysisTypesAvailable = mapTypesData;


                const dialogRef = this.dialog.open(MapDataFieldComponent, {

                    data: {
                        farmNameHeader: this.farmName,
                        analysis: mapTypesData,
                        farmID: this.farmId,
                        fieldID: this.fieldId,
                        previousValue: this.previousValue,
                        selectedFarmMapsItem: this.selectedFarmMapsItem,
                        fieldPolygon: this.polygon,
                    },
                    autoFocus: false,
                    panelClass: 'no-padding-dialog',

                });
                dialogRef.afterClosed().subscribe(result => {

                    if (result !== undefined) {
                        this.selectedMapsItem = result.selectedItem;
                        this.previousValue = result.lastSelectedType;

                        if (result.selectedItem.type != null) {
                            this.selectedAnalysis = result.selectedItem.type;
                            this.analysisDates = result.selectedItem.datePerformed;
                            if (result.selectedItem.analysisId !== null) {
                                this.activeHistoryId = result.selectedItem.analysisId;
                                this.overlayMapItem(result.selectedItem, map);

                                setTimeout(() => {
                                    this.nav.toggleLoading(false);
                                }, 4000);
                            } else {
                                this.nav.toggleLoading(false);
                            }
                        } else {
                            this.nav.toggleLoading(false);
                        }
                    } else {
                        this.nav.toggleLoading(false);
                    }
                    this.mapsAlreadyOpen = false;
                });
            });
        }
    }


    createVrtFromOverlay(map) {
        this.mapsAlreadyOpen = true;
        let mapsTypesAvailabilityDto: MapsTypesAvailabilityDto = { farmId: null, fieldId: this.fieldId };
        this.analysisManagementService.getMapsTypesAvailability(mapsTypesAvailabilityDto).subscribe(availableTypes => {
            let mapTypesData = availableTypes.map(t => ({
                type: t.type, available: t.type.toLowerCase().includes('profitability') ? true : t.available,
                alias: t.alias, displayOrder: 1, selected: false
            }));
            this.analysisTypesAvailable = mapTypesData;

            const dialogRef = this.dialog.open(MapDataFieldComponent, {
                data: {
                    farmNameHeader: this.farmName,
                    analysis: mapTypesData,
                    farmID: this.farmId,
                    fieldID: this.fieldId,
                    previousValue: this.previousValue,
                    selectedFarmMapsItem: this.selectedFarmMapsItem,
                    fieldPolygon: this.polygon,
                    vrtFromAnalysis: this.selectedMapsItem
                },
                autoFocus: false,
                panelClass: 'no-padding-dialog',
            });
            dialogRef.afterClosed().subscribe(result => {
                if (result?.selectedItem?.type != null) {
                    this.selectedMapsItem = result.selectedItem;
                    this.previousValue = result.lastSelectedType;
                    this.selectedAnalysis = result.selectedItem.type;
                    this.analysisDates = result.selectedItem.datePerformed;
                    if (result.selectedItem.analysisId !== null) {
                        this.activeHistoryId = result.selectedItem.analysisId;
                        this.overlayMapItem(result.selectedItem, 1);
                    }
                }
                this.nav.toggleLoading(false);
                this.mapsAlreadyOpen = false;
            });
        });
    }

    removeAnalysisOne() {
        this.fieldImagesMapOne.splice(0, this.fieldImagesMapOne?.length);
        this.fieldLegendsMapOne = [];
        this.titleMapOne = false;
        if (this.currentMapNumber === 1) {
            this.profitabilityPolygons.forEach(p => p.setMap(null));
            this.profitabilityPolygons = [];
        }
    }

    removeAnalysisTwo() {
        this.fieldImagesMapTwo.splice(0, this.fieldImagesMapTwo?.length);
        this.fieldLegendsMapTwo = [];
        this.titleMapTwo = false;
        if (this.currentMapNumber === 2) {
            this.profitabilityPolygons.forEach(p => p.setMap(null));
            this.profitabilityPolygons = [];
        }
    }    

    clearPins(){
        if(this.isPinMarkersVisible){
                for (let i = 0; i < this.markers.length; i++) {
                if (this.markers[i].type == 'pin' || this.markers[i].type !== 'labelPin') {
                    this.markers.splice(i, 1);
                    i--;
                }
            }
        this.newSavedPins = [];
        this.isPinMarkersVisible = false;
        this.pinsCalled = false;
    }       
   }

    getAnalysisStats(analysisId: number, shapePropertyTypeId: number) {

                if (this.currentMapNumber == 1) {
                   if (this.selectedMapsItem?.type.toLowerCase() === 'SOIL'.toLowerCase() || this.selectedMapsItem?.type.toLowerCase() === 'SOIL'.toLowerCase()) {   
                        this.isMapTypeSoilMapOne = false;
                    } else {
                        this.analysisManagementService.getLegendMinMaxAverageStats(analysisId, shapePropertyTypeId).subscribe(stats => { 
                           
                            this.isMapTypeSoilMapOne = true;   

                                this.legendStatsMapOne = {
                                analysisId: stats.analysisId,
                                shapePropertyTypeId: stats.shapePropertyTypeId,
                                max: Number(stats.max).toFixed(3),
                                avg: Number(stats.avg).toFixed(3),
                                min: Number(stats.min).toFixed(3),
                            };
                        })
                }
           }

                else if (this.currentMapNumber == 2) {
                   if (this.selectedMapsItem?.type.toLowerCase() === 'SOIL'.toLowerCase() || this.selectedMapsItem?.type.toLowerCase() === 'SOIL'.toLowerCase()) {   
                        this.isMapTypeSoilMapTwo = false;
                    } else {
                        this.analysisManagementService.getLegendMinMaxAverageStats(analysisId, shapePropertyTypeId).subscribe(stats => { 
                            
                            this.isMapTypeSoilMapTwo = true;

                            this.legendStatsMapTwo = {
                                analysisId: stats.analysisId,
                                shapePropertyTypeId: stats.shapePropertyTypeId,
                                max: Number(stats.max).toFixed(3),
                                avg: Number(stats.avg).toFixed(3),
                                min: Number(stats.min).toFixed(3),
                            };
                        })
                }
           }
    }


    public overlayMapItem(selectedItem, map: number) {
        this.currentMapNumber = map;

        this.nav.toggleLoading(true);
        
        if (this.selectedMapsItem.mapUrl !== null && this.selectedMapsItem.mapUrl !== undefined) {
            // Clear any VRT polygons
            this.profitabilityPolygons.forEach(p => p.setMap(null));
            this.profitabilityPolygons = [];
            let fieldImageryLegendDto: FieldImageryLegendDto = {
                analysisId: selectedItem.analysisId,
                propertyTypeId: selectedItem.propertyTypeId
            };

            // this.fieldLegends = [];
            // this.fieldLegends1 = [];

            this.analysisManagementService.getFieldImageryLegend(fieldImageryLegendDto).subscribe(fieldLegendObj => {

                if (map == 1) {
                    this.fieldLegendsMapOne = [];
                    if (this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && (!this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()))) {
                        this.historySubTitleMapOne = null;
                        this.historyTitleMapOne = this.selectedMapsItem.type;
                        this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY-MM-DD');
                        this.titleMapOne = true;

                    } else if (this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
                        this.historyTitleMapOne = this.selectedMapsItem.type;
                         this.historySubTitleMapOne = null;
                        this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapOne = true;

                    } else if (this.selectedMapsItem.type.toLowerCase().includes('PROFITABILITY'.toLowerCase())) {
                        this.historyTitleMapOne = 'PROFITABILITY';
                        this.historySubTitleMapOne = null;
                        this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapOne = true;
                    } else {
                        this.historyTitleMapOne = this.selectedMapsItem.type;
                        this.historySubTitleMapOne = this.selectedMapsItem.propertyTypeName;
                        this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapOne = true;
                    }
                }


                if (map == 2) {
                    this.fieldLegendsMapTwo = [];
                    if (this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && (!this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()))) {
                        this.historyTitleMapTwo = this.selectedMapsItem.type;
                        this.historySubTitleMapTwo = null;
                        this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY-MM-DD');
                        this.titleMapTwo = true;

                    } else if (this.selectedMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
                        this.historyTitleMapTwo = this.selectedMapsItem.type;
                        this.historySubTitleMapTwo = null;
                        this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapTwo = true;

                    } else if (this.selectedMapsItem.type.toLowerCase().includes('PROFITABILITY'.toLowerCase())) {
                        this.historyTitleMapTwo = 'PROFITABILITY';
                        this.historySubTitleMapTwo = null;
                        this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapTwo = true;
                    } else {
                        this.historyTitleMapTwo = this.selectedMapsItem.type;
                        this.historySubTitleMapTwo = this.selectedMapsItem.propertyTypeName;
                        this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY');
                        this.titleMapTwo = true;
                    }
                }

                fieldLegendObj.forEach(item => {
                  
                    let fieldLegend: FieldLegend = { value: '', color: '', area: '' };
                    if (item.textValue == null || item.textValue == 'null') {

                        if (item.maxValue != 1000000 && this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                            fieldLegend.value = parseFloat(item.minValue.toFixed(3)) + ' - ' + parseFloat(item.maxValue.toFixed(3));

                        } else if (this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                            fieldLegend.value = '> ' + parseFloat(item.minValue.toFixed(3));

                        } else if (this.selectedMapsItem.type.toLowerCase().includes('PROFITABILITY'.toLowerCase())) {
                            const formatRand = (val: number) => (val < 0 ? '-R' : 'R') + Math.abs(val).toFixed(0);
                            fieldLegend.value = item.maxValue != 1000000
                                ? formatRand(item.minValue) + ' - ' + formatRand(item.maxValue)
                                : '> ' + formatRand(item.minValue);

                        } else if (item.maxValue != 1000000 && !this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                            fieldLegend.value = parseFloat(item.minValue.toFixed(2)) + ' - ' + parseFloat(item.maxValue.toFixed(2));

                        } else if (!this.selectedMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                            fieldLegend.value = '> ' + parseFloat(item.minValue.toFixed(2));

                        }
                    } else {
                        fieldLegend.value = item.textValue;
                    }

                    fieldLegend.color = item.color;
                    fieldLegend.area = item.area;

                    if (map == 1) {
                        this.fieldLegendsMapOne.push(fieldLegend);
                    } else {
                        this.fieldLegendsMapTwo.push(fieldLegend);
                    }
                });

                this.showOverlay = true;
            });

            // New Boundry Implementeation TO DO
            // // this.analysisManagementService.getBoundingBox(this.selectedMapsItem.analysisId, this.selectedMapsItem.propertyTypeId).subscribe(boundingBox => {
            //
            //     let bounds = new google.maps.LatLngBounds();
            //     bounds.extend(new google.maps.LatLng(this.selectedMapsItem.latMax, this.selectedMapsItem.lngMax));
            //     bounds.extend(new google.maps.LatLng(this.selectedMapsItem.latMin, this.selectedMapsItem.lngMin));
            //
            //     //
            //     //
            //
            //     //@ts-ignore
            //     // let url = this.selectedAnalysis.items[0].mapUrl;
            //     this.analysisManagementService.getImageAsBlob(this.selectedMapsItem.mapUrl).subscribe(response => {
            //         let typedArray = new Uint8Array(response);
            //         let base64String = this.arrayBufferToBase64(typedArray);
            //         let image = 'data:image/jpg;base64, ' + base64String;
            //         if (map == 1) {
            //             this.fieldImagesMapTwo = [];
            //             let object = {image: image, bounds: bounds, fieldId: this.fieldId};
            //             this.fieldImagesMapTwo.push(object);
            //             this.agmMapOne.fitBounds(this.bounds);
            //             this.overlayedFieldAnalysis.splice(this.historyFieldIndex, 1);
            //             this.newHistory = {
            //                 id: this.selectedMapsItem.analysisId,
            //                 type: this.selectedMapsItem.type,
            //                 fieldId: this.fieldId,
            //                 lastModified: this.selectedMapsItem.datePerformed,
            //                 fieldLegends: this.fieldLegends
            //             };
            //         } else {
            //             this.fieldImagesMapOne = [];
            //             let object = {image: image, bounds: bounds, fieldId: this.fieldId};
            //             this.fieldImagesMapOne.push(object);
            //             this.agmMapTwo.fitBounds(this.bounds);
            //         }
            //
            //         setTimeout(() => {
            //             this.nav.toggleLoading(false);
            //         }, 2500);
            //     });
            // });

            this.analysisManagementService.getBoundingBox(this.selectedMapsItem.analysisId, this.selectedMapsItem.propertyTypeId).subscribe(boundingBox => {

                let bounds = new google.maps.LatLngBounds();
                bounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                bounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));

                //@ts-ignore
                // let url = this.selectedAnalysis.items[0].mapUrl;
                // this.analysisManagementService.getImageAsBlob(this.selectedMapsItem.mapUrl).subscribe(response => {
                //     let typedArray = new Uint8Array(response);
                //     let base64String = this.arrayBufferToBase64(typedArray);
                //     let image = 'data:image/jpg;base64, ' + base64String;
                    
                // });

                if (map == 1) {
                    this.fieldImagesMapOne = [];
                    let object = { image: this.selectedMapsItem?.mapUrl, bounds: bounds, fieldId: this.fieldId };
                    this.fieldImagesMapOne.push(object);
                    this.agmMapOne.fitBounds(this.bounds);
                    this.overlayedFieldAnalysis.splice(this.historyFieldIndex, 1);
                    this.newHistory = {
                        id: this.selectedMapsItem.analysisId,
                        type: this.selectedMapsItem.type,
                        fieldId: this.fieldId,
                        lastModified: this.selectedMapsItem.datePerformed,
                        fieldLegends: this.fieldLegendsMapOne
                    };
                } 
                else {
                    this.fieldImagesMapTwo = [];
                    let object = { image: this.selectedMapsItem?.mapUrl, bounds: bounds, fieldId: this.fieldId };
                    this.fieldImagesMapTwo.push(object);
                    this.agmMapTwo.fitBounds(this.bounds);
                }
                    this.getAnalysisStats(selectedItem.analysisId, selectedItem.propertyTypeId);

                if (this.selectedMapsItem.type.toLowerCase().includes('profitability')) {
                    this.profitabilitySummary = null;
                    this.analysisManagementService.getProfitabilitySummary(selectedItem.analysisId).subscribe(summary => {
                        this.profitabilitySummary = summary;
                    });
                }

                setTimeout(() => {
                    this.nav.toggleLoading(false);
                }, 2500);
            });
        } else {
            // VRT maps don't have pre-rendered images — render polygons directly
            if (this.selectedMapsItem.type === 'GENERATED_VRT') {
                this.renderVrtPolygons(selectedItem, map);
            } else {
                this.nav.toggleLoading(false);
            }
        }
    }

    renderVrtPolygons(selectedItem, map: number) {
        this.nav.toggleLoading(true);
        this.analysisManagementService.getVrtPolygons(selectedItem.analysisId).subscribe(response => {
            this.profitabilityPolygons.forEach(p => p.setMap(null));
            this.profitabilityPolygons = [];
            // Clear image overlays
            this.fieldImagesMapOne = [];
            this.fieldImagesMapTwo = [];

            // Clear legend first
            if (map === 1) { this.fieldLegendsMapOne = []; }
            else { this.fieldLegendsMapTwo = []; }

            const targetMap = map === 1 ? this.agmMapOne : this.agmMapTwo;

            if (map === 1) {
                this.historyTitleMapOne = selectedItem.vrtProduct ? `${selectedItem.vrtProduct} (${selectedItem.vrtUnit})` : 'Generated VRT';
                this.historySubTitleMapOne = null;
                this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY-MM-DD');
                this.titleMapOne = true;
                this.isMapTypeSoilMapOne = false;
            } else {
                this.historyTitleMapTwo = selectedItem.vrtProduct ? `${selectedItem.vrtProduct} (${selectedItem.vrtUnit})` : 'Generated VRT';
                this.historySubTitleMapTwo = null;
                this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY-MM-DD');
                this.titleMapTwo = true;
                this.isMapTypeSoilMapTwo = false;
            }

            // Load legend
            const propertyTypeId = response.propertyTypeId || selectedItem.propertyTypeId;
            if (propertyTypeId) {
                this.analysisManagementService.getFieldImageryLegend({ analysisId: selectedItem.analysisId, propertyTypeId }).subscribe(fieldLegendObj => {
                    const legends: FieldLegend[] = fieldLegendObj.map(item => ({
                        value: (item.textValue == null || item.textValue == 'null') ? (item.minValue != null ? String(parseFloat(item.minValue.toFixed(2))) : '') : item.textValue,
                        color: item.color,
                        area: item.area
                    }));
                    const deduplicated = legends.filter((v, i, a) => a.findIndex(l => l.value === v.value) === i);
                    if (map === 1) { this.fieldLegendsMapOne = deduplicated; }
                    else { this.fieldLegendsMapTwo = deduplicated; }
                    this.nav.toggleLoading(false);
                }, () => { this.nav.toggleLoading(false); });
            } else {
                this.nav.toggleLoading(false);
            }

            // Render polygons
            response.polygons.forEach(polyData => {
                let polygonSets = [];
                if (polyData.geometry.type === 'MultiPolygon') {
                    // Each element in coordinates is a polygon (with possible holes)
                    polyData.geometry.coordinates.forEach(poly => {
                        const paths = poly.map(ring => ring.map(coord => ({ lat: coord[1], lng: coord[0] })));
                        polygonSets.push(paths);
                    });
                } else {
                    const paths = polyData.geometry.coordinates.map(ring => ring.map(coord => ({ lat: coord[1], lng: coord[0] })));
                    polygonSets.push(paths);
                }

                polygonSets.forEach(paths => {
                    const polygon = new google.maps.Polygon({
                        paths: paths,
                        strokeOpacity: 0,
                        strokeWeight: 0,
                        fillColor: polyData.color,
                        fillOpacity: 1,
                        map: targetMap.googleMap
                    });

                    this.profitabilityPolygons.push(polygon);
                });
            });

        }, () => {
            this.nav.toggleLoading(false);
        });
    }

    renderProfitabilityPolygons(selectedItem, map: number) {
        let fieldImageryLegendDto: FieldImageryLegendDto = {
            analysisId: selectedItem.analysisId,
            propertyTypeId: selectedItem.propertyTypeId
        };

        this.analysisManagementService.getFieldImageryLegend(fieldImageryLegendDto).subscribe(fieldLegendObj => {
            const legends: FieldLegend[] = [];
            fieldLegendObj.forEach(item => {
                let fieldLegend: FieldLegend = { value: '', color: '', area: '' };
                if (item.textValue == null || item.textValue == 'null') {
                    if (item.maxValue != 1000000) {
                        fieldLegend.value = parseFloat(item.minValue.toFixed(2)) + ' - ' + parseFloat(item.maxValue.toFixed(2));
                    } else {
                        fieldLegend.value = '> ' + parseFloat(item.minValue.toFixed(2));
                    }
                } else {
                    fieldLegend.value = item.textValue;
                }
                fieldLegend.color = item.color;
                fieldLegend.area = item.area;
                legends.push(fieldLegend);
            });

            this.analysisManagementService.getProfitabilityPolygons(selectedItem.analysisId).subscribe(response => {
                this.profitabilityPolygons.forEach(p => p.setMap(null));
                this.profitabilityPolygons = [];
                this.profitabilitySummary = null;

                this.analysisManagementService.getProfitabilitySummary(selectedItem.analysisId).subscribe(summary => {
                    this.profitabilitySummary = summary;
                });

                const targetMap = map === 1 ? this.agmMapOne : this.agmMapTwo;
                
                if (map === 1) {
                    this.historyTitleMapOne = 'PROFITABILITY';
                    this.historySubTitleMapOne = null;
                    this.historyDateMapOne = dayjs(selectedItem.datePerformed).format('YYYY');
                    this.titleMapOne = true;
                    this.fieldLegendsMapOne = legends;
                } else {
                    this.historyTitleMapTwo = 'PROFITABILITY';
                    this.historySubTitleMapTwo = null;
                    this.historyDateMapTwo = dayjs(selectedItem.datePerformed).format('YYYY');
                    this.titleMapTwo = true;
                    this.fieldLegendsMapTwo = legends;
                }

                if (!this.profitabilityInfoWindow) {
                    this.profitabilityInfoWindow = new google.maps.InfoWindow();
                }

                response.polygons.forEach(polyData => {
                    const paths = polyData.geometry.coordinates[0].map(coord => ({
                        lat: coord[1],
                        lng: coord[0]
                    }));

                    const polygon = new google.maps.Polygon({
                        paths: paths,
                        strokeColor: polyData.color,
                        strokeOpacity: 0.8,
                        strokeWeight: 1,
                        fillColor: polyData.color,
                        fillOpacity: 0.5,
                        map: targetMap.googleMap
                    });

                    google.maps.event.addListener(polygon, 'mouseover', (event) => {
                        const profitValue = polyData.profitabilityValue || 0;
                        const yieldValue = polyData.yieldPerPolygon || 0;
                        const inputCost = polyData.inputCostPerPolygon || 0;
                        const areaM2 = polyData.polygonAreaM2 || 0;
                        const areaHa = areaM2 / 10000;
                        const category = profitValue >= 0 ? 'Profit' : 'Loss';
                        
                        let content = '<div style="padding: 10px; font-family: Arial, sans-serif; min-width: 180px;">';
                        content += `<strong style="color: #333; font-size: 14px;">${category}</strong><br/>`;
                        content += `<span style="color: #666; font-size: 12px;">Profit/Loss: <strong style="color: ${profitValue >= 0 ? '#4CAF50' : '#f44336'};">R ${profitValue.toFixed(2)}</strong></span><br/>`;
                        content += `<span style="color: #666; font-size: 12px;">Yield: <strong>${yieldValue.toFixed(2)} t/ha</strong></span><br/>`;
                        content += `<span style="color: #666; font-size: 12px;">Input Cost: <strong>R ${inputCost.toFixed(2)}</strong></span><br/>`;
                        content += `<span style="color: #666; font-size: 12px;">Area: <strong>${areaHa.toFixed(2)} ha</strong></span>`;
                        content += '</div>';
                        
                        this.profitabilityInfoWindow.setContent(content);
                        this.profitabilityInfoWindow.setPosition(event.latLng);
                        this.profitabilityInfoWindow.open(targetMap.googleMap);
                    });

                    google.maps.event.addListener(polygon, 'mouseout', () => {
                        this.profitabilityInfoWindow.close();
                    });

                    this.profitabilityPolygons.push(polygon);
                });

                setTimeout(() => {
                    this.isLoadingOverlay = false;
                }, 500);

                this.nav.toggleLoading(false);
            }, error => {
                this.nav.toggleLoading(false);
                this.isLoadingOverlay = false;
                this.openSnackBar('Failed to load profitability polygons', 'Dismiss');
            });
        });
    }

    toggleOverlayMode() {
        if (!this.selectedMapsItem || !this.selectedMapsItem.type.toLowerCase().includes('profitability')) {
            return;
        }
        
        this.isVectorOverlay = !this.isVectorOverlay;
        this.isLoadingOverlay = true;
        
        if (this.isVectorOverlay) {
            this.fieldImagesMapOne = [];
            this.fieldImagesMapTwo = [];
            this.renderProfitabilityPolygons(this.selectedMapsItem, this.currentMapNumber);
        } else {
            this.profitabilityPolygons.forEach(p => p.setMap(null));
            this.profitabilityPolygons = [];
            this.overlayMapItem(this.selectedMapsItem, this.currentMapNumber);
            setTimeout(() => {
                this.isLoadingOverlay = false;
            }, 1000);
        }
    }



    public overlayMapItemFromFarmSelection(map: number) {

        window.onload = () => {
            sessionStorage.removeItem('selectedFarmMapsItem');
        }

        setTimeout(() => {
            if (sessionStorage.getItem('selectedFarmMapsItem')) {

                this.currentMapNumber = map;

                this.nav.toggleLoading(true);
                if (this.selectedFarmMapsItem.mapUrl !== null) {
                    let fieldImageryLegendDto: FieldImageryLegendDto = {
                        analysisId: this.selectedFarmMapsItem.analysisId,
                        propertyTypeId: this.selectedFarmMapsItem.propertyTypeId
                    };

                    this.analysisManagementService.getFieldImageryLegend(fieldImageryLegendDto).subscribe(fieldLegendObj => {


                        if (map == 1) {
                            this.fieldLegendsMapOne = [];
                            if (this.selectedFarmMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase()) && (!this.selectedFarmMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase()))) {
                                this.historyTitleMapOne = this.selectedFarmMapsItem.type;
                                this.historyDateMapOne = dayjs(this.selectedFarmMapsItem.datePerformed).format('YYYY-MM-DD');
                                this.titleMapOne = true;

                            } else if (this.selectedFarmMapsItem.type.toLowerCase().includes('TOPOGRAPHY'.toLowerCase())) {
                                this.historyTitleMapOne = this.selectedFarmMapsItem.type;
                                this.historyDateMapOne = dayjs(this.selectedFarmMapsItem.datePerformed).format('YYYY');
                                this.titleMapOne = true;

                            } else {
                                this.historyTitleMapOne = this.selectedFarmMapsItem.type;
                                this.historySubTitleMapOne = this.selectedFarmMapsItem?.propertyTypeName;
                                this.historyDateMapOne = dayjs(this.selectedFarmMapsItem.datePerformed).format('YYYY');
                                this.titleMapOne = true;
                            }
                        }

                        fieldLegendObj.forEach(item => {
                            let fieldLegend: FieldLegend = { value: '', color: '', area: '' };
                            if (item.textValue == null || item.textValue == 'null') {

                                if (item.maxValue != 1000000 && this.selectedFarmMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                                    fieldLegend.value = parseFloat(item.minValue.toFixed(3)) + ' - ' + parseFloat(item.maxValue.toFixed(3));

                                } else if (this.selectedFarmMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                                    fieldLegend.value = '> ' + parseFloat(item.minValue.toFixed(3));

                                } else if (item.maxValue != 1000000 && !this.selectedFarmMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                                    fieldLegend.value = parseFloat(item.minValue.toFixed(1)) + ' - ' + parseFloat(item.maxValue.toFixed(1));

                                } else if (!this.selectedFarmMapsItem.type.toLowerCase().includes('SATELLITE'.toLowerCase())) {
                                    fieldLegend.value = '> ' + parseFloat(item.minValue.toFixed(1));
                                }
                            } else {
                                fieldLegend.value = item.textValue;
                            }

                            fieldLegend.color = item.color;
                            fieldLegend.area = item.area;

                            if (map == 1) {
                                this.fieldLegendsMapOne.push(fieldLegend);
                            } 
                        });


                    });

                    this.analysisManagementService.getBoundingBox(this.selectedFarmMapsItem.analysisId, this.selectedFarmMapsItem.propertyTypeId).subscribe(boundingBox => {

                        let bounds = new google.maps.LatLngBounds();
                        bounds.extend(new google.maps.LatLng(boundingBox.lat1, boundingBox.lng1));
                        bounds.extend(new google.maps.LatLng(boundingBox.lat2, boundingBox.lng2));

                        //@ts-ignore
                        // let url = this.selectedAnalysis.items[0].mapUrl;
                        // this.analysisManagementService.getImageAsBlob(this.selectedFarmMapsItem.mapUrl).subscribe(response => {
                        //     let typedArray = new Uint8Array(response);
                        //     let base64String = this.arrayBufferToBase64(typedArray);
                        //     let image = 'data:image/jpg;base64, ' + base64String;
                            
                        // });

                        if (map == 1) {
                            this.fieldImagesMapOne = [];
                            let object = { image: this.selectedFarmMapsItem?.mapUrl, bounds: bounds, fieldId: this.fieldId };
                            this.fieldImagesMapOne.push(object);
                            this.agmMapOne.fitBounds(this.bounds);
                            this.overlayedFieldAnalysis.splice(this.historyFieldIndex, 1);
                            this.newHistory = {
                                id: this.selectedFarmMapsItem.analysisId,
                                type: this.selectedFarmMapsItem.type,
                                fieldId: this.fieldId,
                                lastModified: this.selectedFarmMapsItem.datePerformed,
                                fieldLegends: this.fieldLegendsMapOne
                            };
                        } 

                        setTimeout(() => {
                        this.getAnalysisStats(this.selectedFarmMapsItem.analysisId, this.selectedFarmMapsItem.propertyTypeId);
                            this.nav.toggleLoading(false);
                        }, 2500);
                    });
                }
            }
        }, 2000);
    }

    openChemCompareView() {
        if (this.oneAction) {
            this.openSnackBar(this.translate.instant('MAPPING.FINISH-EDITING'), this.translate.instant('SNACKBAR.DISMISS'));
            return;
        }
        this.isChemCompareViewActive = true;
        this.router.navigate(['field/chemical-compare/', this.fieldId], { replaceUrl: true });
        this.openSequenceView();
    }
    closeChemCompareView() {
    this.isChemCompareViewActive = false;
    this.router.navigate(['field'], { replaceUrl: true });

        setTimeout(() => {
            if (this.bounds && this.agmMapOne) {
                this.agmMapOne.fitBounds(this.bounds);
            }
            if (this.bounds && this.agmMapTwo) {
                this.agmMapTwo.fitBounds(this.bounds, 0);
            }
        }, 100);
    }

private loadChemCompareTypes() {
    let dto: MapsTypesAvailabilityDto = { farmId: null, fieldId: this.fieldId };
    this.analysisManagementService.getMapsTypesAvailability(dto).subscribe(availableTypes => {
        const types = availableTypes
            .filter(t => t.type?.toLowerCase().includes('chemical') && t.alias !== 'CHEMICAL COMPARE')
            .map(t => ({ type: t.type, alias: t.alias }));

        this.chemCompareChemicalTypes = types;
        this.chemicalCompareService.setChemicalTypes(types);

        // Reset both sides and default to TOP_SOIL
        this.chemCompareLeft = { soilType: 'TOP_SOIL', availableYears: [], allMaps: [], selectedYear: null, entries: [] };
        this.chemCompareRight = { soilType: 'TOP_SOIL', availableYears: [], allMaps: [], selectedYear: null, entries: [] };

        this.loadChemCompareYears(this.chemCompareLeft);
        this.loadChemCompareYears(this.chemCompareRight);
    });
}




        chemCompareZoomIn(): void {
        this.chemCompareMapSyncService.zoomAll(0.5);
    }

    chemCompareZoomOut(): void {
        this.chemCompareMapSyncService.zoomAll(-0.5);
    }

    chemCompareResetMaps(): void {
        this.chemCompareMapSyncService.resetAll();
    }

    chemCompareToggleLegends(): void {
        this.chemCompareMapSyncService.toggleLegends();
    }

    onChemCompareSoilTypeChange(side: ChemicalCompareSideModel) {
            side.selectedYear = null;
            side.availableYears = [];
            side.allMaps = [];
            side.entries = [];
            this.loadChemCompareYears(side);
        }


    // onChemCompareSoilTypeChange() {
    //     this.chemCompareLeftYear = null;
    //     this.chemCompareRightYear = null;
    //     this.chemCompareAvailableYears = [];
    //     this.chemCompareAllMaps = [];
    //     this.chemCompareLeftEntries = [];
    //     this.chemCompareRightEntries = [];
    //     this.loadChemCompareYears();
    // }

    onChemCompareYearChange(side: ChemicalCompareSideModel) {
        this.buildChemCompareEntries(side);
    }


private loadChemCompareYears(side: ChemicalCompareSideModel) {
    this.nav.toggleLoading(true);
    this.chemicalCompareService.loadYearsForSoilType(this.fieldId, side.soilType).subscribe({
        next: data => {
            side.allMaps = data.allMaps;
            side.availableYears = data.availableYears;
            this.nav.toggleLoading(false);
        },
        error: () => this.nav.toggleLoading(false)
    });
}




    // private loadChemCompareYears() {
    //     const matchingType = this.chemCompareChemicalTypes.find(t => {
    //         const lower = t.alias?.toLowerCase() || t.type?.toLowerCase() || '';
    //         return this.chemCompareSoilType === 'TOP_SOIL'
    //             ? lower.includes('chemical') && !lower.includes('sub')
    //             : lower.includes('sub') && lower.includes('chemical');
    //     });
    //     if (!matchingType) return;

    //     this.nav.toggleLoading(true);
    //     this.analysisManagementService.getAvailableMapsField({
    //         period: 'all', fieldId: this.fieldId, type: matchingType.type, pageSize: 100, pageNumber: 1
    //     }).subscribe({
    //         next: itemList => {
    //             this.chemCompareAllMaps = itemList;
    //             this.chemCompareAvailableYears = [...new Set(itemList.map(item => dayjs(item.datePerformed).format('YYYY')))] as string[];
    //             this.nav.toggleLoading(false);
    //         },
    //         error: () => this.nav.toggleLoading(false)
    //     });
    // }


    private buildChemCompareEntries(side: ChemicalCompareSideModel) {
    const match = side.allMaps.find(m => dayjs(m.datePerformed).format('YYYY') === side.selectedYear);
    const items = match?.items || [];

    if (!match || items.length === 0) {
        side.entries = [];
        return;
    }

    const requests = items
        .filter(item => item.mapUrl)
        .map(item => ({
            key: `${match.analysisId}:${item.propertyTypeId}`,
            analysisId: match.analysisId,
            propertyTypeId: item.propertyTypeId
        }));

    if (requests.length === 0) {
        side.entries = items.map(item => ({
            propertyTypeName: item.propertyTypeName,
            mapUrl: item.mapUrl || null,
            analysisId: match.analysisId,
            propertyTypeId: item.propertyTypeId,
            bounds: null
        }));
        return;
    }

    this.nav.toggleLoading(true);
    forkJoin(
        requests.map(r => this.analysisManagementService.getBoundingBox(r.analysisId, r.propertyTypeId).pipe(catchError(() => of(null))))
    ).subscribe(results => {
        const boundsCache: Record<string, any> = {};
        results.forEach((bb, i) => { if (bb) boundsCache[requests[i].key] = bb; });

        side.entries = items.map(item => {
            if (!item.mapUrl) return { propertyTypeName: item.propertyTypeName, mapUrl: null, bounds: null, analysisId: null, propertyTypeId: null };
            const bb = boundsCache[`${match.analysisId}:${item.propertyTypeId}`];
            return {
                propertyTypeName: item.propertyTypeName,
                mapUrl: item.mapUrl,
                analysisId: match.analysisId,
                propertyTypeId: item.propertyTypeId,
                bounds: bb ? { lat1: bb.lat1, lng1: bb.lng1, lat2: bb.lat2, lng2: bb.lng2 } : null
            };
        });
        this.nav.toggleLoading(false);
    });
}


    // private buildChemCompareEntries() {
    //     const leftMatch = this.chemCompareAllMaps.find(m => dayjs(m.datePerformed).format('YYYY') === this.chemCompareLeftYear);
    //     const rightMatch = this.chemCompareAllMaps.find(m => dayjs(m.datePerformed).format('YYYY') === this.chemCompareRightYear);
    //     const leftItems = leftMatch?.items || [];
    //     const rightItems = rightMatch?.items || [];
    //     const allNames = [...new Set([...leftItems.map(i => i.propertyTypeName), ...rightItems.map(i => i.propertyTypeName)])];

    //     const boundsCache: Record<string, any> = {};
    //     const requests: { key: string, analysisId: number, propertyTypeId: number }[] = [];

    //     const addReq = (analysisId: number, item: any) => {
    //         if (!item?.mapUrl) return;
    //         const key = `${analysisId}:${item.propertyTypeId}`;
    //         if (!boundsCache[key] && !requests.find(r => r.key === key))
    //             requests.push({ key, analysisId, propertyTypeId: item.propertyTypeId });
    //     };
    //     if (leftMatch) leftItems.forEach(item => addReq(leftMatch.analysisId, item));
    //     if (rightMatch) rightItems.forEach(item => addReq(rightMatch.analysisId, item));

    //     const build = () => {
    //         const mapEntry = (items: any[], match: any, name: string): ChemCompareEntry => {
    //             const item = items.find(i => i.propertyTypeName === name);
    //             if (!item?.mapUrl || !match) return { propertyTypeName: name, mapUrl: null, bounds: null, analysisId: null, propertyTypeId: null };
    //             const bb = boundsCache[`${match.analysisId}:${item.propertyTypeId}`];
    //             return {
    //                 propertyTypeName: name, mapUrl: item.mapUrl, analysisId: match.analysisId, propertyTypeId: item.propertyTypeId,
    //                 bounds: bb ? { lat1: bb.lat1, lng1: bb.lng1, lat2: bb.lat2, lng2: bb.lng2 } : null
    //             };
    //         };
    //         this.chemCompareLeftEntries = allNames.map(name => mapEntry(leftItems, leftMatch, name));
    //         this.chemCompareRightEntries = allNames.map(name => mapEntry(rightItems, rightMatch, name));
    //     };

    //     if (requests.length === 0) { build(); return; }

    //     this.nav.toggleLoading(true);
    //     forkJoin(
    //         requests.map(r => this.analysisManagementService.getBoundingBox(r.analysisId, r.propertyTypeId).pipe(catchError(() => of(null))))
    //     ).subscribe(results => {
    //         results.forEach((bb, i) => { if (bb) boundsCache[requests[i].key] = bb; });
    //         build();
    //         this.nav.toggleLoading(false);
    //     });
    // }

    showCompareAnalysis() {

        if (this.oneAction) {
            this.openSnackBar(this.translate.instant('MAPPING.FINISH-EDITING'), this.translate.instant('SNACKBAR.DISMISS'));
        } else {
            if (this.flex4 == 50) {
                this.mapsClose = false;
                this.flex4 = 0;
                this.flex2 = 100;
                this.zoom = 16;
            } else if (this.flex4 == 0) {
                this.zoom = 15;
                this.mapsClose = true;
                this.flex4 = 50;
                this.flex2 = 50;
                this.flex3 = 0;
            }

            this.agmMapTwo.fitBounds(this.bounds, 0);
        }
        this.openOptions();

        this.mapTwoIsOpen = !this.mapTwoIsOpen;
        //

        if (this.mapTwoIsOpen == false) {
            //  this.title = true;
            this.titleMapTwo = false;
        }

        else if (this.mapTwoIsOpen == true && this.historyTitleMapTwo.length > 0) {
             //  this.title = true;
            this.titleMapTwo = true;
            //
        }else if(this.mapTwoIsOpen == true && this.historyTitleMapTwo.length == 0){

        } else if (this.mapTwoIsOpen == true && this.historyTitleMapTwo.length == 0) {
             //  this.title = true;
            this.titleMapTwo = true;
            //
        }

        //

    }

    arrayBufferToBase64(buffer) {

        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    loadFieldBoundary(id) {
        this.weatherForecasts = [];
        this.showWeatherCard = false;

        if (sessionStorage.getItem('fields') != null) {
            let fields: Field[] = JSON.parse(sessionStorage.getItem('fields'));
            this.fieldBounds = [];
            fields.forEach(field => {
                if (field.id == id) {

                    this.bounds = new google.maps.LatLngBounds();
                    this.bounds.extend(new google.maps.LatLng(field.lat1, field.lng1));
                    this.bounds.extend(new google.maps.LatLng(field.lat2, field.lng2));
                    this.center = new google.maps.LatLng(field.lat1, field.lng1);

                    let object = { bounds: this.bounds, fieldId: field.id };
                    this.fieldBounds.push(object);

                    this.fieldName = field.name;

                    this.mapLat = field.lat1;
                    this.mapLng = field.lng1;

                    this.map1Lat = field.lat2;
                    this.map1Lng = field.lng2;

                    let image = field.image;

                    let typedArray = new Uint8Array(image.data);
                    // const STRING_CHAR = String.fromCharCode.apply(null, typedArray);
                    // let base64String = btoa(STRING_CHAR);
                    let base64String = this.arrayBufferToBase64(typedArray);
                    image = 'data:image/jpg;base64, ' + base64String;

                    // this.images.push(object);
                    // this.fieldImagesMapOne.push(object);

                    // // //
                    // // //

                    // // //
                    // // //

                    this.agmMapOne.fitBounds(this.bounds);
                    // this.agmMapTwo.fitBounds(this.bounds);
                }

                this.base.fetchAnalysis().subscribe(analysis => {
                    if (analysis.path != null && analysis.path.length > 0) {
                        this.polygon = analysis.path;
                        this.polygons = analysis.polygons;
                        this.polygonOptions = {
                            strokeColor: this.fieldBoundaryColor,
                            strokeWeight: 4,
                            fillOpacity: 0.0
                        };
                    }
                    if (analysis.images != null && analysis.images.length > 0) {
                        this.farmImages = analysis.images;
                        var newImage;
                        for (let i = 0; i < this.farmImages.length; i++) {
                            if (this.farmImages[i].fieldId == this.fieldId) {
                                newImage = this.farmImages[i];
                                this.fieldIndex = i;
                                this.fieldImagesMapTwo = [];
                                this.fieldImagesMapOne = [];
                                this.fieldImagesMapTwo.push(newImage);
                                this.fieldImagesMapOne.push(newImage);
                            }
                        }
                        if (analysis.histories != null && analysis.histories.length > 0) {
                            this.overlayedFieldAnalysis = analysis.histories;
                            for (let i = 0; i < this.overlayedFieldAnalysis.length; i++) {
                                if (this.overlayedFieldAnalysis[i].fieldId == this.fieldId) {
                                    this.history = this.overlayedFieldAnalysis[i];
                                    this.historyFieldIndex = i;
                                }
                            }
                            if (this.history.fieldLegends != null && this.history.fieldLegends.length > 0) {
                                this.fieldLegendsMapOne = this.history.fieldLegends;
                                this.fieldLegendsMapTwo = this.history.fieldLegends1;
                                this.historyTitleMapTwo = this.history.type;
                                // this.historyDateMapTwo = this.history.lastModified;
                                // this.historyTitle = this.history.type;
                                this.historyDateMapTwo = this.history.lastModified;
                                this.titleMapTwo = true;
                                // this.title = true;
                            }
                        }
                    }
                });
                //   }
                // });
            });
        }
    }

    // loadFieldHistories(id) {

    //     if (sessionStorage.getItem('histories') != null) {
    //         let fieldHistories: History[] = JSON.parse(sessionStorage.getItem('histories'));
    //         fieldHistories.forEach(fieldHistory => {
    //             if (fieldHistory.fieldId == id) {
    //                 this.histories.push(fieldHistory);
    //             }
    //         });
    //     } else {
    //         if (this.farmId != -1) {
    //             this.farmManagementService.getFarmHistory(this.startDate, this.endDate, this.farmId).subscribe((histories) => {
    //                 let jsonHistories = JSON.stringify(histories);
    //                 sessionStorage.setItem('histories', jsonHistories);
    //                 this.loadFieldHistories(id);
    //             });
    //         }
    //     }
    // }

    filterPins() {

    }

    getNewSavedPins() {
        if(this.pinsCalled) {
          this.tmpData = [];
          this.softSoilCount = {
            softCount: 0,
            soilCount: 0
          }

          this.nav.toggleLoading(true);

          // GET -retrieve PINS by FIELD ID
          this.pinManagerService.getSavedPinsByFieldId(this.fieldId, this.tenantId, this.savedPinStartDate, this.savedPinEndDate)
            .pipe(
              catchError(error =>{
                console.error();
                this.nav.toggleLoading(false);
                return throwError(()=> error);
              })
            ).subscribe((response) =>{
            this.tmpMarkers = [];
            this.newSavedPins = response;

            if (this.newSavedPins?.length === 0) {
              this.nav.toggleLoading(false);
            }

            if(this.selectedPinType.id) {
              this.chartDataCount = this.newSavedPins.filter(p => p.pinTypeId === this.selectedPinType.id).length;
            } else {
              this.chartDataCount = this.newSavedPins.length;
            }

            this.markers = this.markers.filter(m => m.type === 'labelPin');

            //CONFIRM SELECTED PIN TYPE
            this.newSavedPins.forEach((newPin, index) => {
              if (this.selectedPinType?.id == undefined) {
                this.savedPinsDataCounter = 0;
                let id = newPin.id;
                let lat = newPin.lat;
                let lng = newPin.lng;
                let description = newPin.description;

                let tmpMarker = {
                  id: id,
                  position: {lat: lat, lng: lng},
                  title: description,
                  content: this.createMarkerContent(this.setPinTypeIcon(newPin)),
                  type: 'pin',
                  creatingUser: newPin.userName + " " + newPin.userSurname
                };
                this.tmpMarkers.push(tmpMarker);
                this.tmpPins.push(newPin);
                if(this.tmpMarkers){
                  this.isPinMarkersVisible = true;
                }
                // this.getDynamicPins(this.tenantId, this.fieldId, lat, lng, false, description, newPin);
              }

              if (newPin?.pinTypeId === this.selectedPinType?.id) {
                this.savedPinsDataCounter = 0;
                let id = newPin.id;
                let lat = newPin.lat;
                let lng = newPin.lng;
                let description = newPin.description;

                let tmpMarker = {
                  id: id,
                  position: {lat: lat, lng: lng},
                  title: description,
                  content: this.createMarkerContent(this.setPinTypeIcon(newPin)),
                  type: 'pin',
                  creatingUser: newPin.userName + " " + newPin.userSurname
                };
                this.openedWindow = id;
                this.tmpMarkers.push(tmpMarker);
                this.tmpPins.push(newPin);
                if(this.tmpMarkers){
                  this.isPinMarkersVisible = true;
                }

                // this.getDynamicPins(this.tenantId, this.fieldId, lat, lng, false, description, newPin);

              }

            })

            this.nav.toggleLoading(false);
            if(this.isPinLabelsShowing) {
              this.setPinLabels();
            }
            this.loadPins();

          })
        }
    }


    loadPins() {
        this.nav.toggleLoading(true);
        let isOnMap = false;

        for (let i = 0; i < this.tmpMarkers.length; i++) {
            if (!this.markers.includes(this.tmpMarkers[i])) {
                isOnMap = true;
                this.markers.push(this.tmpMarkers[i]);
            }
        }

        if (isOnMap) {
            if (this.tmpData?.length > 0) {
                setTimeout(() => {
                    this.getCharts();
                    this.nav.toggleLoading(false);
                }, 100);
            } else {
                this.openSnackBar(this.translate.instant('FIELD.ERR-SAVED-PINS-CHART'), this.translate.instant('SNACKBAR.DISMISS'));
                this.nav.toggleLoading(false);
            }
            // setTimeout(() => {
            //   this.getCharts();
            //   this.nav.toggleLoading(false);
            // }, 100);
        } else {
            if (this.markers.length > 0) {
                this.openSnackBar(this.translate.instant('FIELD.ERR-SAVED-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
                this.nav.toggleLoading(false);
            } else {
                this.openSnackBar(this.translate.instant('FIELD.ERR-NO-SAVED-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
                this.nav.toggleLoading(false);
            }
        }
        this.openOptions();
    }

    loadSavedPins() {

        this.openSnackBar(this.translate.instant('FIELD.LOADING-SAVED-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
        this.openOptions();
    }



    reloadMarker(response){
        let newMarker = {
            id: response?.pinId ?? response?.id ?? this.existingMarker?.id,
            position: {lat: response?.lat, lng: response?.lng},
            title: response?.pinDescription ?? response?.description ?? this.existingMarker?.description,
            creatingUser: response?.creatingUser,
            pinTypeId: response.pinTypeId,
            content: this.createMarkerContent(this.setPinTypeIcon(response)),
            type: 'pin'
        };
        this.markers.forEach((marker, index)=> {
            if(marker?.position?.lat == response?.lat && marker?.position?.lng == response?.lng){
                this.markers.splice(index,1);
            }
        })
        this.markers.push(newMarker);
        this.newSavedPins.push(newMarker);

        if(this.isPinLabelsShowing) {
            this.setPinLabels();
        }
    }



    openSequenceView() {
        this.nav.toggleLoading(true); 
        this.clearPins();
        this.removeAnalysisOne();
        this.removeAnalysisTwo();
    }

    openSingleTypeSequenceView(){
     this.isSingleTypeSequenceViewActive = true;
     this.router.navigate(['field/sequence', this.fieldId]);
     this.openSequenceView();
    }

    openCustonSequenceView(){
     this.isCustomSequenceViewActive = true;
     this.router.navigate(['field/custom-sequence/', this.fieldId]);
    this.openSequenceView();
    }

    newShowSavedPins() {
        //SHOW or CLEAR MARKERS
        const dialogRef = this.dialog.open(ViewSavedPinComponent);

        dialogRef.afterClosed().subscribe(result => {


            if (result?.option == 'clear') {
                if (this.markers.length != 0) {
                    this.showGraphs = false;
                    this.scrolled = false;
                    this.markers = [];
                    this.pinCounter = 1;
                    this.barChartData = [];
                    this.newSavedPins = [];
                    this.isPinMarkersVisible = false;
                }

                this.pinsCalled = false;

            } else if (result?.applyObj?.option == 'apply') {
                this.markers = [];
                this.showGraphs = false;
                this.scrolled = false;
                this.pinCounter = 1;
                this.barChartData = [];
                this.pinsCalled = true;

                if(result?.applyObj?.selectecPinType == null) {
                    this.selectedPinType.id = 0;
                    this.savedPinStartDate = result.applyObj.filterStartDate;
                    this.savedPinEndDate = result.applyObj.filterEndDate;

                } else {
                    this.selectedPinType = result.applyObj.selectecPinType;
                    this.savedPinStartDate = result.applyObj.filterStartDate;
                    this.savedPinEndDate = result.applyObj.filterEndDate;
                }
                this.getNewSavedPins();
            }
        });

    }

    setPinTypeIcon(pinType) {
        if (pinType?.pinTypeId == 1) {
            return this.iconUrl.urlMarker;
        }
        else if (pinType?.pinTypeId == 2) {
            return this.iconUrl.urlSoftVirualConsultant;
        }
        else if (pinType.pinTypeId == 3) {
            if(pinType?.is_completed) {
                return this.iconUrl.urlSoftTissueCompleted;
            } else {
                return this.iconUrl.urlSoftTissue;
            }
        }
        else if (pinType.pinTypeId == 4) {
            if(pinType?.is_completed) {
                return this.iconUrl.urlSoilCompleted;
            } else {
                return this.iconUrl.urlSoil;
            }
        }
        else if (pinType?.pinTypeId == 5) {
            return this.iconUrl.urlWater;
        }
        else if (pinType?.pinTypeId == 6) {
            return this.iconUrl.urlDisease;
        }
        else if (pinType?.pinTypeId == 7) {
            return this.iconUrl.urlPest;
        }
        else if (pinType?.pinTypeId == 8) {
            return this.iconUrl.urlYieldEst;
        }
        else if (pinType?.pinTypeId == 9) {
            return this.iconUrl.urlNester;
        }
        else if (pinType?.pinTypeId == 10) {
            return this.iconUrl.urlFieldInspection;
        }

    }

    // clearPins() {

    //     if (this.markers.length != 0) {
    //         this.openClearDialog();
    //     } else {
    //         this.openSnackBar(this.translate.instant('FIELD.ERR-NO-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
    //     }
    //     this.openOptions();
    // }

    // openClearDialog() {

    //     const dialogRef = this.dialog.open(PinClearComponent);

    //     dialogRef.afterClosed().subscribe(result => {
    //         let option = result.option;
    //         if (option == 'clear') {
    //             this.showGraphs = false;
    //             this.scrolled = false;
    //             this.markers = [];
    //             this.pinCounter = 1;
    //             this.barChartData = [];
    //             // this.getPinDataForField();
    //         } else if (option == 'delete') {
    //             this.openDeleteAllDialog();
    //         }
    //     });
    // }

    openDeleteAllDialog() {

        const dialogRef = this.dialog.open(AllPinsDeleteComponent);

        dialogRef.afterClosed().subscribe(result => {
            let option = result.option;
            if (option == 'delete') {
                this.showGraphs = false;
                this.scrolled = false;
                this.markers = [];
                this.pinCounter = 1;
                this.barChartData = [];
                this.deleteAllPins();
            }
        });
    }

    deleteAllPins() {

        this.markers.forEach(marker => {
            this.deletePin(marker, 1);
        });
    }

    placeMarker($event: google.maps.MapMouseEvent) {
        let latLng = $event.latLng.toJSON();

        if(!this.openGridManager) {
            let marker = {
                id: this.tmpId,
                position: { lat: latLng.lat, lng: latLng.lng },
                title: 'pin #' + this.pinCounter++,
                content: this.createMarkerContent('../../assets/icons/new_pin_updated.png'),
            };
        

            let newPin = {
                id: this.tmpId,
                description: 'string',
                fieldId: this.fieldId,
                lat: latLng.lat,
                lng: latLng.lng,
                userId: this.helper.getUserId(),
                tenantId: this.tenantId
            }

            this.newSavedPinsData.push(newPin);

            this.openedWindow = this.tmpId;

            this.tmpId--;

            this.markers.push(marker);

            this.isPinMarkersVisible = true;
            if (!this.selectedPinType) {
                this.selectedPinType = { id: null, name: 'Dropped Pins' } as PinType;
            }
            if (this.autoChartsCheck) {
                // this.nav.toggleLoading(true);
                this.nav.toggleLoading(true);
            }

            this.getDynamicPins(this.tenantId, this.fieldId, latLng.lat, latLng.lng, true, marker.title, null);
        } else {
            if(this.addNewGridPoint) {
                this.markers.push({
                    id: `SP-${this.gridPointId}`,
                    position: { lat: latLng.lat, lng: latLng.lng },
                    title: `${this.gridDialogResult?.pointName}${this.gridDialogResult?.isSequential ? this.gridPointId : ''}`,
                    type: 'sampling',
                    content: this.createMarkerContent('../../assets/icons/new_pin_updated.png'),
                    gmpDraggable: true
                });
                this.gridPointId++;
            }
        }
    }

    infoClick(marker) {
        this.nav.toggleLoading(true);

        if (this.marker?.id <= 0) {
            this.openNewSavePinDialog(marker);

        }else {
            this.openExistingPinOptions(marker);
        }
    //     this.openPinDialog(this.marker);
    }


    openSaveGridDialog() {
        this.dialog.open(NewSaveGridComponent, {
            data: {
                userId: this.helper.getUserId(),
                tenantId: this.tenantId,
                fieldId: this.fieldId,
                gridRotation: this.gridDialogResult?.gridRotation,
                gridSpacing: this.gridDialogResult.unitOfMeasurement === 'Meters' ?
                    this.gridDialogResult.gridSpacing :
                    Math.sqrt(this.gridDialogResult.gridSpacing * 10000),
                markers: this.markers,
                onSaveComplete: (result: any) => {
                    this.markers = [];
                    this.isGriddingControlVisable = false;
                    this.griddingGroupName = 'Viewing Grid: ' + (result.sampleGroup?.name ?? '');
                    this.clearGridLines();

                    result.pinResults?.forEach(pinResult => {
                        if (pinResult.success) {
                            this.reloadMarker(pinResult.pin);
                        }
                    });
                }
            }
        });
    }

    openNewSavePinDialog(marker) {


        const dialogRef = this.dialog.open(NewSavePinComponent, {

            data: {
                pinTypeId: marker.pinTypeId,
                lat: marker.position.lat,
                lng: marker.position.lng,
                date: dayjs().format(),
                farm: this.farmName,
                field: this.fieldName,
                fieldId: this.fieldId,
                userId: this.helper.getUserId(),
                creatingUser: marker?.creatingUser ?? '-',
                tenantId: this.tenantId
            }
        });

        dialogRef.afterClosed().subscribe(response => {

            // this.newSavedPin = result;
            if (response.option === 'remove') {
                    this.markers = [];
            } else if(response?.option === 'save') {
                marker.creatingUser = response.pinMarker.userName + ' ' + response.pinMarker.userSurname
            }



            if (response.option == 'save'  && response.pinMarker.pinTypeId == 1) {


                const dialogRef = this.dialog.open(MarkerPinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                })
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);
                })

            } else if (response.option == 'save' && response.pinMarker.pinTypeId == 2) {

                const dialogRef = this.dialog.open(VirtualConsultantPinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                })
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);
                })

            } else if (response.option == 'save' && response.pinMarker.pinTypeId == 3) {

                const dialogRef = this.dialog.open(SoftTissuePinSamplesComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    console.log(this.tmpMarkers)
                    this.reloadMarker(response);
                });

            }
            else if (response.option == 'save' && response.pinMarker.pinTypeId == 4) {

                const dialogRef = this.dialog.open(SoilPinSamplesComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description,
                        isGrid: this.openGridManager || !!this.griddingGroupName
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    if(!response) {
                        this.markers = this.markers.filter(m => m.id !== marker.id);
                        this.samplingPoints = this.samplingPoints.filter(m => m.id !== marker.id);
                    } else {
                        this.reloadMarker(response);
                    }
                });
            }
            else if (response.option == 'save' && response.pinMarker.pinTypeId == 5) {

                const dialogRef = this.dialog.open(WaterPinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);
                });
            }
            else if (response.option == 'save' && response.pinMarker.pinTypeId == 6) {

                const dialogRef = this.dialog.open(DiseasePinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);
                });
            }
            else if (response.option == 'save' && response.pinMarker.pinTypeId == 7) {

                const dialogRef = this.dialog.open(PestPinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);

                });
            }
            else if (response.option == 'save' && response.pinMarker.pinTypeId == 8) {

                const dialogRef = this.dialog.open(YieldEstimationPinComponent, {
                    data: {
                        pinTypeId: response.pinMarker.pinTypeId,
                        lat: response.pinMarker.lat,
                        lng: response.pinMarker.lng,
                        date: dayjs().format(),
                        farm: this.farmName,
                        field: this.fieldName,
                        fieldId: this.fieldId,
                        userId: this.helper.getUserId(),
                        creatingUser: marker?.creatingUser ?? '-',
                        tenantId: this.tenantId,
                        pinId: response.pinMarker.id,
                        pinDescription: response.pinMarker.description
                    }
                });
                dialogRef.afterClosed().subscribe(response => {
                    this.reloadMarker(response);
                    this.nav.toggleLoading(false);
                });
            }
            else if (response?.isFieldInspection || response?.pinMarker?.pinTypeId == 10) {
                // Field Inspection pin saved — update icon and open inspection dialog
                this.nav.toggleLoading(false);
                if (response?.pinMarker?.id) {
                    marker.content = this.createMarkerContent(this.iconUrl.urlFieldInspection);
                    marker.id = response.pinMarker.id;
                    marker.pinTypeId = 10;

                    const inspectionDialogRef = this.dialog.open(FieldInspectionDialogComponent, {
                        data: {
                            pinId: response.pinMarker.id,
                            fieldId: this.fieldId,
                            tenantId: this.tenantId,
                            farm: this.farmName,
                            field: this.fieldName,
                            lat: response.pinMarker.lat,
                            lng: response.pinMarker.lng,
                            viewOnly: false,
                            isNewInspection: true,
                            cropDefinitions: undefined  // let dialog resolve via season API
                        },
                        width: '900px',
                        maxWidth: '95vw',
                        height: '88vh',
                        maxHeight: '88vh',
                        autoFocus: false
                    });

                    // Reload markers after dialog closes so pin has correct server ID
                    inspectionDialogRef.afterClosed().subscribe(() => {
                        setTimeout(() => this.getNewSavedPins(), 300);
                    });
                }
            }
        });

    }

    openExistingPinOptions(marker) {

        this.existingMarker = marker;

        this.pinManagerService.getSavedPinById(marker.id)
        .pipe(
            catchError(error =>{
                console.error();
                return throwError(()=> error);
              })
          ).subscribe((response) =>{
            let markerPin = response;
            if (response?.pinTypeId == 1) {
              const dialogRef = this.dialog.open(MarkerPinComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  pinDescription: response.description
                }
              })
              dialogRef.afterClosed().subscribe(response => {
                if(response == null){
                  setTimeout(()=>{
                    this.getNewSavedPins();
                  },500)
                }

              })

            } else if (response?.pinTypeId == 2) {
              const dialogRef = this.dialog.open(VirtualConsultantPinComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  pinDescription: response.description
                }
              })
              dialogRef.afterClosed().subscribe(response => {
                if(response == null){
                  setTimeout(()=>{
                    this.getNewSavedPins();
                  },500)
                }
              })

            } else if (response?.pinTypeId == 3) {
              const dialogRef = this.dialog.open(SoftTissuePinSamplesComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id
                }
              });
              dialogRef.afterClosed().subscribe(response => {
                setTimeout(()=>{
                    if(!response) {
                        this.markers = this.markers.filter(m => m.id !== marker.id);
                        this.samplingPoints = this.samplingPoints.filter(m => m.id !== marker.id);
                    } else if(this.pinsCalled) {
                        this.getNewSavedPins();
                    } else {
                        this.reloadMarker(response);
                    }
                },500)
              });

            }
            else if (response?.pinTypeId == 4) {
              const dialogRef = this.dialog.open(SoilPinSamplesComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  isGrid: this.openGridManager || !!this.griddingGroupName
                }
              });
              dialogRef.afterClosed().subscribe(response => {
                setTimeout(()=>{
                  if(!response) {
                    // Pin was deleted — remove from grid markers
                    this.markers = this.markers.filter(m => m.id !== marker.id);
                    this.samplingPoints = this.samplingPoints.filter(m => m.id !== marker.id);
                  } else if(this.pinsCalled) {
                        this.getNewSavedPins();
                    } else {
                        this.reloadMarker(response);
                    }
                },500)
              });
            }
            else if (response?.pinTypeId == 5) {
              const dialogRef = this.dialog.open(WaterPinComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  pinDescription: response.description
                }
              });
              dialogRef.afterClosed().subscribe(response => {
                if(response == null){
                  setTimeout(()=>{
                    this.getNewSavedPins();
                  },500)
                }
              });
            }
            else if (response?.pinTypeId == 6) {
              const dialogRef = this.dialog.open(DiseasePinComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  pinDescription: response.description
                }
              });
              dialogRef.afterClosed().subscribe(response => {
                if(response == null){
                  setTimeout(()=>{
                    this.getNewSavedPins();
                  },500)
                }
              });
            }
            else if (response?.pinTypeId == 7) {
              const dialogRef = this.dialog.open(PestPinComponent, {
                data: {
                  pinTypeId: response.pinTypeId,
                  lat: response.lat,
                  lng: response.lng,
                  date: response.lastModified,
                  farm: this.farmName,
                  field: this.fieldName,
                  fieldId: this.fieldId,
                  userId: this.helper.getUserId(),
                  creatingUser: markerPin.userName + '  ' + markerPin.userSurname,
                  tenantId: this.tenantId,
                  pinId: marker.id,
                  pinDescription: response.description
                }
              });

              dialogRef.afterClosed().subscribe(response => {
                if(response == null){
                  setTimeout(() => {
                    this.getNewSavedPins();
                  }, 500)
                }
              });
            }
            else if (response?.pinTypeId == 8) {
              this.existingMarker = response;
              this.openExistingYielsEstimationPinOptions();
            }

            else if (response?.pinTypeId == 9) {
              this.existingMarker = response;
              this.openExistingNtesterPinOptions();
            }
            else if (response?.pinTypeId == 10) {
              // Field Inspection pin — open dialog in LIST mode for this pin
              this.nav.toggleLoading(false);
              this.dialog.open(FieldInspectionDialogComponent, {
                data: {
                  pinId: response.id,
                  fieldId: this.fieldId,
                  tenantId: this.tenantId,
                  farm: this.farmName,
                  field: this.fieldName,
                  lat: response.lat,
                  lng: response.lng,
                  viewOnly: false,
                  isNewInspection: false,
                  cropDefinitions: undefined  // let dialog resolve via season API when needed
                },
                width: '900px',
                maxWidth: '95vw',
                height: '88vh',
                maxHeight: '88vh',
                autoFocus: false
              });
            }

          })

    }
    // });

    openExistingYielsEstimationPinOptions() {
        this.pinManagerService.getYieldestimationPinById(this.marker?.id)
        .pipe(
            catchError(error =>{
                console.error();
                return throwError(()=> error);
              })
          ).subscribe((response) =>{

            // if pinType?.id == 8
                    const dialogRef = this.dialog.open(YieldEstimationPinComponent, {
                        data: {
                            pinTypeId: this.selectedPinType?.id,
                            selectedPinType: this.selectedPinType?.name,
                            lat: response?.pin?.lat ?? this.existingMarker?.lat,
                            lng: response?.pin?.lng ?? this.existingMarker?.lng,
                            date: response?.pin?.lastModified ?? this.existingMarker?.lastModified,
                            farm: this.farmName,
                            field: this.fieldName,
                            fieldId: this.fieldId,
                            pinId: this.marker?.id,
                            pinDescription: response?.pin?.description ?? this.existingMarker?.description,
                            unitOfMeasureId: response?.unitOfMeasureId,
                            yieldEstimation: response?.yieldEstimation,
                            yieldWeightedValue: response?.yieldWeightedValue,
                            estimationDate: response?.estimationDate,
                            dateCreated: response?.dateCreated,
                            dateModified: response?.dateModified ?? this.existingMarker.lastModified,
                            creatingUser:  this.existingMarker?.userName + '  ' +  this.existingMarker?.userSurname,
                        }
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        this.nav.toggleLoading(false);
                        if(result == null){

                        setTimeout(()=>{
                        this.getNewSavedPins();
                        },500)
                        }
                    });
        })

    }

    openExistingNtesterPinOptions() {

        this.pinManagerService.getSavedNTesterPinById(this.marker.id)
        .pipe(
            catchError(error =>{
                console.error();
                return throwError(()=> error);
              })
          ).subscribe((response) =>{

             // if pin TypeId == 9
                        const dialogRef = this.dialog.open(NTesterPinComponent, {
                            data: {
                                pinTypeId: this.selectedPinType?.id,
                                selectedPinType: this.selectedPinType?.name,
                                lat: response?.pin?.lat ?? this.existingMarker?.lat,
                                lng: response?.pin?.lng ?? this.existingMarker?.lng,
                                date: response?.pin?.lastModified ?? this.existingMarker?.lastModified,
                                farm: this.farmName,
                                field: this.fieldName,
                                fieldId: this.fieldId,
                                userId: this.helper.getUserId(),
                                tenantId: this.tenantId,
                                pinId: this.marker.id,
                                pinDescription: response?.pin?.description,
                                variety: response?.variety,
                                crop: response?.crop,
                                cultivar: response?.cultivar,
                                growthStage: response?.growthStage,
                                totalNitrogen: response?.totalNitrogen,
                                medianValue: response?.medianValue,
                                averageValue: response?.averageValue,
                                yieldTarget: response?.yieldTarget,
                                alreadyApplied: response?.alreadyApplied,
                                proteinTarget: response?.proteinTarget,
                                nRecommendation: response?.nRecommendation
                            }
                        })
                        dialogRef.afterClosed().subscribe(response => {
                            if(response == null){
                            setTimeout(()=>{
                            this.getNewSavedPins();
                            },500)
                            }

                        })

            })

    }


    openDescriptionDialog(marker) {
        this.nav.toggleLoading(true);
        const dialogRef = this.dialog.open(PinDescriptionComponent, {
            data: {
                title: marker.title,
                id: marker.id
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                let newDes = result.newDes;
                let type = result.type;
                // Set marker new description
                if (type != 'cancel') {
                    for (var i = 0; i < this.markers.length; i++) {
                        if (this.markers[i].id == marker.id) {
                            this.markers[i].title = newDes;
                            break;
                        }
                    }

                    var pin: Pin = marker;
                    pin.fieldId = this.fieldId;
                    pin.userId = this.helper.getUserId();
                    pin.tenantId = this.helper.getTenantId();
                    pin.description = marker.title;
                    pin.lat = marker.position.lat;
                    pin.lng = marker.position.lng;

                    if (marker.id > 0) {
                        // Update api code
                        this.nav.toggleLoading(false);
                        this.farmManagementService.updatePin(pin).subscribe(result => {
                            for (var i = 0; i < this.markers.length; i++) {
                                if (this.markers[i].id == marker.id) {
                                    this.markers[i].id = result.id;
                                    this.tmpMarkers.push(this.markers[i]);
                                    break;
                                }
                            }
                            this.nav.toggleLoading(false);
                            this.openSnackBar(this.translate.instant('FIELD.PIN-UPDDATED'), this.translate.instant('SNACKBAR.DISMISS'));
                        });
                    } else {
                        // Save api code
                        this.nav.toggleLoading(false);
                        this.farmManagementService.insertPin(pin).subscribe(result => {
                            for (var i = 0; i < this.markers.length; i++) {
                                if (this.markers[i].id == marker.id) {
                                    this.markers[i].id = result.id;
                                    this.tmpMarkers.push(this.markers[i]);
                                    break;
                                }
                            }

                            this.createInspection(newDes, marker);

                            this.nav.toggleLoading(false);
                            this.openSnackBar(this.translate.instant('FIELD.PIN-SAVED'), this.translate.instant('SNACKBAR.DISMISS'));
                        });
                    }
                }
            }
        });
        this.nav.toggleLoading(false);
    }

    createInspection(desc, marker) {

        const inspectionsRef = ref(this.db, 'inspections/');
        const newInspectionRef = push(inspectionsRef);
        const newKey = newInspectionRef.key;
        const firebaseTimestamp = serverTimestamp();
        const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

        const inspection = {
            description: desc,
            farmName: this.farmName,
            fieldName: this.fieldName,
            key: newKey,
            lastUpdated: firebaseTimestamp,
            latitude: String(marker.position.lat),
            longitude: String(marker.position.lng),
            sender: String(marker.userId),
            tenantId: String(marker.tenantId)
        };

        set(newInspectionRef, inspection);
    }

    openDeleteDialog(marker) {

        const dialogRef = this.dialog.open(PinDeleteComponent, {});

        dialogRef.afterClosed().subscribe(result => {
            let option = result.option;
            if (option == 'delete') {
                this.nav.toggleLoading(true);
                this.deletePin(marker, 1);
            }
        });
        this.nav.toggleLoading(false);
    }

    deletePin(marker, option) {

        this.nav.toggleLoading(true);
        if (marker.id > 0) {
            // Delete api code
            this.farmManagementService.deletePin(marker.id).subscribe(result => {
                for (var i = 0; i < this.tmpMarkers.length; i++) {
                    if (this.tmpMarkers[i].id == marker.id) {
                        this.tmpMarkers.splice(i, 1);
                        break;
                    }
                }
                for (var i = 0; i < this.markers.length; i++) {
                    if (this.markers[i].id == marker.id) {
                        this.markers.splice(i, 1);
                        break;
                    }
                }
                if (option == 1) {
                    this.nav.toggleLoading(false);
                    this.openSnackBar(this.translate.instant('FIELD.PIN-DELETED'), this.translate.instant('SNACKBAR.DISMISS'));
                    for (var i = 0; i < this.barChartData.length; i++) {
                        if (this.barChartData[i].pinName == marker.title) {
                            this.barChartData.splice(i, 1);
                            i--;
                        }
                    }
                    this.getCharts();
                } else if (option == 2) {
                    if (this.markers.length == 0) {
                        this.nav.toggleLoading(false);
                        this.openSnackBar(this.translate.instant('FIELD.PINS-DELETED'), this.translate.instant('SNACKBAR.DISMISS'));
                        this.barChartData = [];
                        this.getPinDataForField();
                    }
                }
            });
        } else {

            for (var i = 0; i < this.markers.length; i++) {
                if (this.markers[i].id === marker.id) {
                    this.markers.splice(i, 1);
                    break;
                }
            }

            // this.getDynamicPins(this.tenantId, this.fieldId, marker.position.lat, marker.position.lng, false, marker.title, null);
            if (option == 1) {
                this.nav.toggleLoading(false);
                this.openSnackBar(this.translate.instant('FIELD.PIN-DELETED'), this.translate.instant('SNACKBAR.DISMISS'));
                for (var i = 0; i < this.barChartData.length; i++) {
                    if (this.barChartData[i].pinName == marker.title) {
                        this.barChartData.splice(i, 1);
                        i--;
                    }
                }
                this.getCharts();

            } else if (option == 2) {
                if (this.markers.length == 0) {
                    this.nav.toggleLoading(false);
                    this.openSnackBar(this.translate.instant('FIELD.PINS-DELETED'), this.translate.instant('SNACKBAR.DISMISS'));
                    this.barChartData = [];
                    this.getPinDataForField();
                }
            }
        }
    }

    openSnackBar(message: string, action: string) {

        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }

    showSatelliteHistory() {

        this.getSatelliteHistory();
        this.openOptions();
    }

    getSatelliteHistory() {

        this.analysisManagementService.getSatelliteHistory(this.fieldId).subscribe(satelliteHistories => {
            if (satelliteHistories.length > 0) {

                let counter = 0;
                let unfilteredSatHistory: SatelliteHistory[] = [];
                satelliteHistories.forEach(satelliteHistory => {

                    let newDate = (moment(satelliteHistory.imageDate).format('YYYY-MM-DD')).toString();
                    if (unfilteredSatHistory.length > 0) {
                        let index = unfilteredSatHistory.length - 1;
                        let lastDate = (moment(unfilteredSatHistory[index].imageDate).format('YYYY-MM-DD')).toString();
                        if (newDate != lastDate) {
                            unfilteredSatHistory.push(satelliteHistory);
                        } else {
                            if (satelliteHistory.coverageType == 'CLEAR') {
                                unfilteredSatHistory.splice(index, 1);
                                unfilteredSatHistory.push(satelliteHistory);
                            } else if (satelliteHistory.coverageType == 'PARTIAL' && unfilteredSatHistory[index].coverageType == 'CLOUD') {
                                unfilteredSatHistory.splice(index, 1);
                                unfilteredSatHistory.push(satelliteHistory);
                            }
                        }
                    } else {
                        unfilteredSatHistory.push(satelliteHistory);
                    }
                    counter++;
                });

                this.satelliteHistories = unfilteredSatHistory;

                if (this.flex3 == 18) {
                    this.flex3 = 0;
                    this.flex2 = 100;
                } else if (this.flex3 == 30) {
                    this.flex3 = 0;
                    this.flex2 = 100;
                } else if (this.flex3 == 0) {
                    if (!this.mobileQuery.matches) {
                        this.flex3 = 18;
                        // this.flex2 = 0;
                        // this.flex4 = 0;
                    } else {
                        this.flex3 = 30;
                        // this.flex2 = 0;
                        // this.flex4 = 0;
                    }
                }

                // console.log(this.flex3)

                this.fieldLegendsMapTwo = [];
                this.geoJsonObject1 = [];
            } else {
                this.openSnackBar(this.translate.instant('FIELD.NO-SATELLITE'), this.translate.instant('SNACKBAR.DISMISS'));
            }
        });
    }

    overlaySatelliteHistory(satelliteHistory: satelliteHistory) {
        let date = moment(satelliteHistory.imageDate).format('YYYY-MM-DD');
        if (satelliteHistory.coverageType == 'CLEAR') {
            let foundHistory;
            this.histories.forEach(history => {
                if (history.type == 'NVDI Satellite' && history.lastModified == date) {
                    foundHistory = history;
                }
            });
            if (foundHistory != null) {
                // this.overlayAnalysis(foundHistory.id, "nvdi", 1, foundHistory.lastModified);
                 this.overlayMapItem(satelliteHistory, 1)
            }
        } else if (satelliteHistory.coverageType == 'PARTIAL') {
            this.nav.toggleLoading(false);
            // this.partialNDVI(date);
            this.partialNdviImage(date);
        } else {
            this.openSnackBar(this.translate.instant('FIELD.NO-HISTORY'), this.translate.instant('SNACKBAR.DISMISS'));
        }
    }

    partialNdviImage(date) {

        this.nav.toggleLoading(true);
        this.geosysManagementService.getGeosysFieldId(this.fieldId).subscribe(geosysFieldId => {
            if (geosysFieldId.geosysFieldId != null) {
                this.geosysFieldId = geosysFieldId.geosysFieldId;
                this.geosysManagementService.geosysPartialNdviImage(this.geosysFieldId, date).subscribe(response => {
                    if (response.type != 'error') {
                        this.overlayPartialAnalysis(response.image, response.boundingBox, response.ranges, date);
                        // this.partialNDVI(date);
                    } else if (response.error == 'No data') {
                        this.nav.toggleLoading(false);
                        this.openSnackBar(this.translate.instant('FIELD.NO-PARTIAL-HISTORY'), this.translate.instant('SNACKBAR.DISMISS'));
                    } else {
                        // //
                    }
                });
            } else {
                this.openSnackBar(this.translate.instant('DATA-SERVICE.GEOSYS-FIELD-SUBSCRIPTION'), this.translate.instant('SNACKBAR.DISMISS'));
                this.nav.toggleLoading(false);
            }
        });
    }

    overlayPartialAnalysis(img: any, boundingBox: any, ranges: any, date: string) {

        this.nav.toggleLoading(true);

        let bounds = new google.maps.LatLngBounds();
        bounds.extend(new google.maps.LatLng(boundingBox.yMin, boundingBox.xMin));
        bounds.extend(new google.maps.LatLng(boundingBox.yMax, boundingBox.xMax));

        // let image = 'data:image/jpg;base64, ' + img;
        this.fieldImagesMapTwo = [];
        let object = { image: img, bounds: bounds, fieldId: this.fieldId };
        this.fieldImagesMapTwo.push(object);
        this.agmMapOne.fitBounds(bounds);

        // // //
        this.unsortedFieldLegends = [];
        this.fieldLegendsMapOne = [];
        let fieldLegend: FieldLegend = { value: 'Cloud', color: 'grey', area: '' };
        let fieldLegend1: FieldLegend = { value: 'No Data', color: 'black', area: '' };
        this.unsortedFieldLegends.push(fieldLegend);
        this.unsortedFieldLegends.push(fieldLegend1);
        ranges.forEach(range => {
            let fieldLegend: FieldLegend = { value: '', color: '', area: '' };
            fieldLegend.value = range.minValue.toFixed(2) + ' - ' + range.maxValue.toFixed(2);
            fieldLegend.color = this.rgbToHex(range.color.r, range.color.g, range.color.b);
            this.unsortedFieldLegends.push(fieldLegend);
        });
//MIGHT NEED TO SWITCH TO MAP ONE ????
        this.historyTitleMapTwo = 'Partial NDVI';
        this.historyDateMapTwo = moment(date).format('YYYY-MM-DD');
        this.titleMapTwo = true;
        ///////////
        this.unsortedFieldLegends.sort(function (a, b) {
            return Number.parseFloat(a.value.replace(/^\W+ /, 'z')) - Number.parseFloat(b.value.replace(/^\W+/, 'z'));
        });
        for (let i = 0; i < this.unsortedFieldLegends.length; i++) {
            this.fieldLegendsMapOne.push(this.unsortedFieldLegends[i]);
        }
        this.nav.toggleLoading(false);
        // })
    }

    rgbToHex(r, g, b) {
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }

    getDynamicPins(tenantId, fieldId, lat, lng, isDropped, pinTitle, pin) {
        tenantId = tenantId ?? this.tenantId ?? +sessionStorage.getItem('selectedTenant');
        if(isDropped) {
            this.mappingService.getDynamicPinData(tenantId, fieldId, lat, lng).subscribe((dynamicPins) => {
            if (!isDropped) {
                if(pinTitle?.includes('Soft')) {
                    this.softSoilCount.softCount++;
                } else if(pinTitle?.includes('Soil')) {
                    this.softSoilCount.soilCount++;
                }

                dynamicPins.forEach(dynamicPin => {
                    dynamicPin.pinName = pinTitle + (pinTitle.includes('Soft') ? ' ' + this.softSoilCount.softCount : pinTitle.includes('Soil') ? ' ' + this.softSoilCount.soilCount : '');
                    this.tmpData.push(dynamicPin);
                });

                this.barChartData = [...this.tmpData];
                this.chartDataCount--;
            }

            let object = {
                barChartData: this.barChartData,
                tenantId: tenantId,
                fieldId: fieldId,
                lat: lat,
                lng: lng,
                isDropped: isDropped,
                pinTitle: pinTitle,
                pin: pin,
                dynamicPins: dynamicPins,
                tmpData: this.tmpData,
                tmpPins: this.tmpPins,
                chartData: this.chartData,
                muNameList: this.muNameList
            };

            this.worker.postMessage(JSON.stringify(object));

            if(!isDropped && (this.chartDataCount === 0)) {
                this.loadPins();
            }
        }, (error) => {
            this.nav.toggleLoading(false);
        });
        }
    }

    getPinDataForField() {
        this.graphIds = [];
        this.muNameList = [];

        this.barChartData.forEach(dynamicPin => {
            if (!this.graphIds.includes(dynamicPin.chartId)) {
                if (dynamicPin.name == 'CLASS_C' && !dynamicPin.isNumericProperty && dynamicPin.type == 'SOIL') {
                    this.graphIds.push(dynamicPin.chartId);
                } else if (dynamicPin.isNumericProperty) {
                    this.graphIds.push(dynamicPin.chartId);
                } else if (dynamicPin.name == 'MUNAME_C') {
                    this.muNameList.push(dynamicPin);
                }
            }
        });

        this.graphIds.sort((a, b) => a - b);
        this.getCharts();
    }

    charts(data) {
        this.chartBarLegend.push(data.chartBarLegend);
        this.barChartData = data.barChartData;
        this.graphIds = data.graphIds;
        this.muNameList = data.muNameList;

        this.savedPinsDataCounter++;
        // if (this.savedPinsDataCounter == this.savedPinsData.length) {
        if (this.savedPinsDataCounter == this.newSavedPinsData.length) {
            this.loadingPins = false;
        }

        if (data.isDropped) {
            this.getCharts();
        }
    }

    getCharts() {
        this.newChartData = [];
        if (this.autoChartsCheck) {
            this.tmpChartData = [];
            this.chartData = [];
        }

        this.graphIds.sort((a, b) => a - b);

        let pinData: DynamicPin[] = [];

        var type;
        var chartMaxValue;
        var pinName;
        var value;
        var newMax;
        var newMin;
        var chartName;

        this.graphIds.forEach(graphId => {
            pinData = [];

            pinData = this.barChartData.filter(tmpData => tmpData.chartId === graphId);
            // this.tmpData.forEach(tmpData => {
            //     if (tmpData.chartId == graphId) {
            //         pinData.push(tmpData);
            //     }
            // });

            if (pinData.length != 0) {
                if (pinData[0].isNumericProperty) {
                    var pinTmpData: ChartData[] = [];

                    var maxValue = '0.0';
                    var minValue = '0.0';
                    // var lineChartDataTmp: LineChartData[] = [];
                    var yMax = '0.0';
                    var yMin = '1000000';

                    var tmpBarPinData: any[] = [];
                    var maxData: any[] = [];
                    var minData: any[] = [];

                    pinData.forEach(data => {
                        let val = '0';
                        if (Number(data.value) > -1) {
                            val = data.value;
                        }

                        if (data.chartMaxValue != null && data.chartMaxValue != 'null' && data.chartMaxValue != '') {
                            maxValue = data.chartMaxValue;
                        }
                        if (data.chartMinValue != null && data.chartMinValue != 'null' && data.chartMinValue != '') {
                            minValue = data.chartMinValue;
                        }

                        if (Number(data.value) > Number(yMax)) {
                            yMax = data.value;
                        }
                        if (Number(data.value) < Number(yMin)) {
                            yMin = data.value;
                        }

                        if (data.type == 'YIELD') {
                            chartName = data.chartName;
                        } else {
                            chartName = (data.chartName + ' | ' + data.maxPeriod);
                        }

                        chartName = data.chartName;
                        value = Number(val);
                        newMax = Number(maxValue);
                        newMin = Number(minValue);
                        type = data.type;
                        pinName = data.pinName;
                        chartMaxValue = data.chartMaxValue;

                        tmpBarPinData.push({
                            name: pinName,
                            value: Number(val).toFixed(2)
                        });

                        minData.push({
                            name: pinName,
                            value: newMin.toFixed(2)
                        });

                        maxData.push({
                            name: pinName,
                            value: newMax.toFixed(2)
                        });

                        this.chartBarLegend.push(type);
                    });

                    if (tmpBarPinData.length > 1) {
                        if (tmpBarPinData[0].name.includes('pin #') && tmpBarPinData[1].name.includes('pin #')) {
                            tmpBarPinData.sort(function (a, b) {
                                return Number.parseFloat(a.name.replace('pin #', '')) - Number.parseFloat(b.name.replace('pin #', ''));
                            });
                            minData.sort(function (a, b) {
                                return Number.parseFloat(a.name.replace('pin #', '')) - Number.parseFloat(b.name.replace('pin #', ''));
                            });
                            maxData.sort(function (a, b) {
                                return Number.parseFloat(a.name.replace('pin #', '')) - Number.parseFloat(b.name.replace('pin #', ''));
                            });
                        } else {
                            tmpBarPinData.sort((a, b) => a.name.localeCompare(b.name));
                            minData.sort((a, b) => a.name.localeCompare(b.name));
                            maxData.sort((a, b) => a.name.localeCompare(b.name));
                        }
                    }

                    let echartsData = {
                        chartName: chartName,
                        name: pinName,
                        value: value,
                        legendTitle: type,
                        isNumericalProperty: true,
                        series: null,
                        option: {
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                }
                            },
                            legend: {
                                show: false,
                                data: ['Avg', 'Min', 'Max'],
                                bottom: 0
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '15%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                data: tmpBarPinData.map(d => d.name),
                                axisLabel: {
                                    rotate: 0,
                                    interval: 0
                                }
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                    name: 'Avg',
                                    type: 'bar',
                                    data: tmpBarPinData.map(d => d.value),
                                    itemStyle: { color: '#1D73A6' },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        formatter: '{c}',
                                        color: '#1D73A6',
                                        fontWeight: 'bold',
                                        fontSize: 12
                                    }
                                },
                                {
                                    name: 'Min',
                                    type: 'line',
                                    data: minData.map(d => d.value),
                                    itemStyle: { color: '#F58546' },
                                    lineStyle: { color: '#F58546' }
                                },
                                {
                                    name: 'Max',
                                    type: 'line',
                                    data: maxData.map(d => d.value),
                                    itemStyle: { color: '#83A13F' },
                                    lineStyle: { color: '#83A13F' }
                                }
                            ]
                        }
                    };

                    pinTmpData.push(echartsData);
                    if (type?.toLowerCase().includes('topography')) {
                        this.topographyChartData = pinTmpData;
                    } else {
                        this.newChartData.push(pinTmpData);
                    }
                } else {
                    //Non numerical
                    var pinTmpData: ChartData[] = [];
                    var chartName = '';

                    if (pinData[0].name == ('CLASS_C')) {
                        chartName = ('SOIL Classification | ' + pinData[0].maxPeriod);
                    } else {
                        chartName = (pinData[0].chartName + ' | ' + pinData[0].maxPeriod);
                    }

                    pinData.forEach(tmpTableData => {
                        var header = tmpTableData.pinName;
                        var value = tmpTableData.value;
                        var muNameC = '';

                        this.muNameList.forEach(muName => {
                            var valueMu = muName.value;
                            var pinName = muName.pinName;

                            if (tmpTableData.pinName == pinName && valueMu.startsWith(value)) {
                                muNameC = valueMu;
                            }
                        });

                        let tmpTData: ChartData = {
                            name: header,
                            value: value,
                            chartName: chartName,
                            legendTitle: muNameC,
                            // max: 0,
                            isNumericalProperty: false,
                            series: null
                        };

                        pinTmpData.push(tmpTData);
                    });

                    if (pinTmpData.length > 1) {
                        if (pinTmpData[0].name.includes('pin #') && pinTmpData[1].name.includes('pin #')) {
                            pinTmpData.sort(function (a, b) {
                                return Number.parseFloat(a.name.replace('pin #', 'a')) - Number.parseFloat(b.name.replace('pin #', 'a'));
                            });
                        } else {
                            pinTmpData.sort((a, b) => a.name.localeCompare(b.name));
                        }
                    }
                    this.newChartData.unshift(pinTmpData);
                }
            }
        });

        // Insert topography chart right after soil classification
        if (this.topographyChartData) {
            const soilIndex = this.newChartData.findIndex(d => d[0]?.chartName?.includes('SOIL Classification'));
            if (soilIndex !== -1) {
                this.newChartData.splice(soilIndex + 1, 0, this.topographyChartData);
            } else {
                this.newChartData.unshift(this.topographyChartData);
            }
            this.topographyChartData = null;
        }

        if(this.autoChartsCheck) {
            this.chartData = this.newChartData;
        }

        if (this.newChartData.length > 0) {
            this.showGraphs = true;
            if (this.autoChartsCheck) {
                if (this.animationState == 'in') {
                    this.animationState = 'out';
                    this.showField = true;
                    this.nav.toggleLoading(false);
                    // this.nav.toggleLoading(false);
                } else {
                    document.querySelector('#target').scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
                    this.scrolled = true;
                    this.nav.toggleLoading(false);
                    // this.nav.toggleLoading(false);
                }
            }
        } else {
            if (this.autoChartsCheck) {
                this.nav.toggleLoading(false);
                // this.nav.toggleLoading(false);
                this.openSnackBar(this.translate.instant('FIELD.ERR-NO-PIN-ANALYSIS'), this.translate.instant('SNACKBAR.DISMISS'));
            }
        }

        this.nav.toggleLoading(false);
    }

    autoChartsChanged(ob: MatSlideToggleChange) {
        this.autoChartsCheck = ob.checked;

        if(this.autoChartsCheck) {
            setTimeout(() => {
                this.updateCharts();
            }, 100);
        }
    }

    updateCharts() {
        if (this.newChartData.length > 0) {
            this.chartData = this.newChartData;
            if (!this.scrolled) {
                this.showGraphs = true;
                setTimeout(() => {
                    document.querySelector('#target').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    this.scrolled = true;
                }, 2500);
            }
        } else {
            this.openSnackBar(this.translate.instant('FIELD.NO-NEW-PINS'), this.translate.instant('SNACKBAR.DISMISS'));
        }
    }

    // Sampling grid methods
    generateSamplingGrid() {
        if (!this.bounds || !this.polygon || this.polygon.length === 0) {
            this.openSnackBar('Field boundary not loaded', 'Dismiss');
            return;
        }

        this.isGeneratingGrid = true;
        this.openSnackBar('Generating sampling grid...', '');

        requestAnimationFrame(() => {
            try {
                this.markers = [];
                this.samplingPoints = [];
                this.selectedGridPoints = [];

            // Update gridPointId to continue from remaining count
            const remainingSamplingPoints = this.markers.filter(m => m.type === "sampling");
            this.gridPointId = remainingSamplingPoints.length + 1;
                this.clearGridLines();

                const north = this.bounds.getNorthEast().lat();
                const south = this.bounds.getSouthWest().lat();
                const east = this.bounds.getNorthEast().lng();
                const west = this.bounds.getSouthWest().lng();

                // Calculate expanded bounds for rotation using Pythagorean theorem
                const centerLat = (north + south) / 2;
                const centerLng = (east + west) / 2;
                const maxDistance = Math.sqrt(Math.pow(north - south, 2) + Math.pow(east - west, 2)) / 2;

                const expandedNorth = centerLat + maxDistance;
                const expandedSouth = centerLat - maxDistance;
                const expandedEast = centerLng + maxDistance;
                const expandedWest = centerLng - maxDistance;

                const spacing = this.gridDialogResult.unitOfMeasurement === 'Meters' ?
                    this.gridDialogResult.gridSpacing :
                    Math.sqrt(this.gridDialogResult.gridSpacing * 10000);
                const latSpacing = spacing / 111000;
                const lngSpacing = spacing / (111000 * Math.cos(centerLat * Math.PI / 180));

                const latOffset = latSpacing / 2;
                const lngOffset = lngSpacing / 2;

                this.gridPointId = 1;

                this.originalRotation = this.gridDialogResult.gridRotation;
                this.currentRotation = this.gridDialogResult.gridRotation;

                const fieldPolygon = new google.maps.Polygon({
                    paths: this.polygon[0]
                });

                const gridCorners: {lat: number, lng: number}[][] = [];

                for (let lat = expandedSouth; lat <= expandedNorth; lat += latSpacing) {
                    const row: {lat: number, lng: number}[] = [];
                    for (let lng = expandedWest; lng <= expandedEast; lng += lngSpacing) {
                        row.push({lat, lng});
                    }
                    if (row.length > 0) {
                        gridCorners.push(row);
                    }
                }

                // Generate grid using expanded bounds
                const tempSamplingPoints = [];
                for (let lat = expandedSouth + latOffset; lat <= expandedNorth; lat += latSpacing) {
                    for (let lng = expandedWest + lngOffset; lng <= expandedEast; lng += lngSpacing) {
                        tempSamplingPoints.push({
                            id: `SP-${this.gridPointId}`,
                            position: { lat: lat, lng: lng },
                            title: `${this.gridDialogResult?.pointName}${this.gridDialogResult?.isSequential ? this.gridPointId : ''}`,
                            type: 'sampling',
                            content: this.createMarkerContent('../../assets/icons/new_pin_updated.png'),
                            gmpDraggable: true
                        });
                        this.gridPointId++;
                    }
                }

                if (this.currentRotation !== 0) {
                    this.samplingPoints = this.rotateGridPoints(tempSamplingPoints, centerLat, centerLng);

                    for (let row of gridCorners) {
                        for (let point of row) {
                            const rotated = this.rotatePoint(point.lat, point.lng, centerLat, centerLng, this.currentRotation);
                            point.lat = rotated.lat;
                            point.lng = rotated.lng;
                        }
                    }
                } else {
                    this.samplingPoints = tempSamplingPoints;
                }

                this.samplingPoints = this.samplingPoints.filter(point => {
                    const mapPoint = new google.maps.LatLng(point.position.lat, point.position.lng);
                    return google.maps.geometry.poly.containsLocation(mapPoint, fieldPolygon);
                });

                // Renumber points
                this.samplingPoints.forEach((point, index) => {
                    point.id = `SP-${index + 1}`;
                    point.title = `${this.gridDialogResult?.pointName}${this.gridDialogResult?.isSequential ? index + 1 : ''}`;
                });
                this.gridPointId = this.samplingPoints.length + 1;

                // console.log(this.samplingPoints)

                this.markers = this.markers.concat(this.samplingPoints);
                this.showSamplingPoints = true;

                setTimeout(() => {
                    this.generateGridLines(gridCorners, fieldPolygon);
                    this.isGeneratingGrid = false;
                    this.openSnackBar(`Generated ${this.samplingPoints.length} sampling points`, 'Dismiss');
                }, 50);

            } catch (error) {
                this.isGeneratingGrid = false;
                this.openSnackBar('Error generating grid. Please try again.', 'Dismiss');
                console.error('Grid generation error:', error);
            }
        });
    }

    rotatePoint(lat: number, lng: number, centerLat: number, centerLng: number, rotation: number): {lat: number, lng: number} {
        const rotationRadians = (rotation * Math.PI) / 180;

        const translatedLat = lat - centerLat;
        const translatedLng = lng - centerLng;

        const rotatedLat = translatedLat * Math.cos(rotationRadians) - translatedLng * Math.sin(rotationRadians);
        const rotatedLng = translatedLat * Math.sin(rotationRadians) + translatedLng * Math.cos(rotationRadians);

        return {
            lat: rotatedLat + centerLat,
            lng: rotatedLng + centerLng
        };
    }

    generateGridLines(gridStructure: {lat: number, lng: number}[][], fieldPolygon: google.maps.Polygon) {
        this.clearGridLines();

        if (!this.showGridLines || gridStructure.length === 0) {
            return;
        }

        const mapInstance = this.agmMapOne?.googleMap;

        if (!mapInstance) {
            console.warn('Map instance not available for grid lines');
            return;
        }

        const lineOptions = {
            strokeColor: '#000000',
            strokeOpacity: 0.85,
            strokeWeight: 2,
            map: mapInstance
        };

        // console.log('Generating grid lines with', gridStructure.length, 'rows');

        const clipLineToPolygon = (point1: google.maps.LatLng, point2: google.maps.LatLng): google.maps.LatLng[] => {
            const segments: google.maps.LatLng[] = [];
            const numSteps = 20;
            let currentSegment: google.maps.LatLng[] = [];

            for (let i = 0; i <= numSteps; i++) {
                const fraction = i / numSteps;
                const lat = point1.lat() + (point2.lat() - point1.lat()) * fraction;
                const lng = point1.lng() + (point2.lng() - point1.lng()) * fraction;
                const point = new google.maps.LatLng(lat, lng);

                const isInside = google.maps.geometry.poly.containsLocation(point, fieldPolygon);

                if (isInside) {
                    currentSegment.push(point);
                } else {
                    if (currentSegment.length > 0) {
                        segments.push(...currentSegment);
                        currentSegment = [];
                    }
                }
            }

            if (currentSegment.length > 0) {
                segments.push(...currentSegment);
            }

            return segments;
        };

        for (let row of gridStructure) {
            if (row.length < 2) continue;

            for (let i = 0; i < row.length - 1; i++) {
                const point1 = new google.maps.LatLng(row[i].lat, row[i].lng);
                const point2 = new google.maps.LatLng(row[i + 1].lat, row[i + 1].lng);

                const clippedSegments = clipLineToPolygon(point1, point2);

                if (clippedSegments.length > 1) {
                    const line = new google.maps.Polyline({
                        ...lineOptions,
                        path: clippedSegments
                    });
                    this.gridLines.push(line);
                }
            }
        }

        if (gridStructure.length > 1) {
            const numCols = gridStructure[0].length;
            for (let col = 0; col < numCols; col++) {
                for (let row = 0; row < gridStructure.length - 1; row++) {
                    const point1 = new google.maps.LatLng(gridStructure[row][col].lat, gridStructure[row][col].lng);
                    const point2 = new google.maps.LatLng(gridStructure[row + 1][col].lat, gridStructure[row + 1][col].lng);

                    const clippedSegments = clipLineToPolygon(point1, point2);

                    if (clippedSegments.length > 1) {
                        const line = new google.maps.Polyline({
                            ...lineOptions,
                            path: clippedSegments
                        });
                        this.gridLines.push(line);
                    }
                }
            }
        }

        // console.log(`Generated ${this.gridLines.length} grid line segments`);
    }

    clearGridLines() {
        for (let line of this.gridLines) {
            line.setMap(null);
        }
        this.gridLines = [];
    }


    toggleGridLines() {
        this.showGridLines = !this.showGridLines;

        if (this.showGridLines) {
            this.regenerateGridWithCurrentSettings();
        } else {
            this.clearGridLines();
        }
    }

    regenerateGridWithCurrentSettings() {
        if (!this.gridDialogResult) {
            return;
        }
        this.currentRotation = ((this.currentRotation % 360) + 360) % 360;
        this.gridDialogResult.gridRotation = this.currentRotation;

        this.generateSamplingGrid();
    }

    rotateLeft() {
        this.currentRotation = ((this.currentRotation - 10) % 360 + 360) % 360;
        this.regenerateGridWithCurrentSettings();
    }


    rotateRight() {
        this.currentRotation = (this.currentRotation + 10) % 360;
        this.regenerateGridWithCurrentSettings();
    }

    rotateGridPoints(points: any[], centerLat: number, centerLng: number): any[] {
        if (this.gridDialogResult.gridRotation === 0) return points;

        const rotationRadians = (this.gridDialogResult.gridRotation * Math.PI) / 180;

        return points.map(point => {
            const translatedLat = point.position.lat - centerLat;
            const translatedLng = point.position.lng - centerLng;

            const rotatedLat = translatedLat * Math.cos(rotationRadians) - translatedLng * Math.sin(rotationRadians);
            const rotatedLng = translatedLat * Math.sin(rotationRadians) + translatedLng * Math.cos(rotationRadians);

            return {
                ...point,
                position: {
                    lat: rotatedLat + centerLat,
                    lng: rotatedLng + centerLng
                }
            };
        });
    }

    onMarkerDragEnd(marker: any, event: google.maps.MapMouseEvent) {
        if (!event || !event.latLng) return;

        const newPosition = event.latLng.toJSON();
        const markerIndex = this.markers.findIndex(m => m.id === marker.id);

        if (markerIndex !== -1) {
            const oldPosition = this.markers[markerIndex].position;
            const latDiff = newPosition.lat - oldPosition.lat;
            const lngDiff = newPosition.lng - oldPosition.lng;

            // Check if this marker is in selectedGridPoints
            const isSelected = this.selectedGridPoints.some(m => m.id === marker.id);

            if (isSelected && this.selectedGridPoints.length > 1) {
                // Move all selected markers by the same offset
                this.selectedGridPoints.forEach(selectedMarker => {
                    const idx = this.markers.findIndex(m => m.id === selectedMarker.id);
                    if (idx !== -1) {
                        this.markers[idx] = {
                            ...this.markers[idx],
                            position: {
                                lat: this.markers[idx].position.lat + latDiff,
                                lng: this.markers[idx].position.lng + lngDiff
                            }
                        };
                    }
                });
            } else {
                // Move only this marker
                this.markers[markerIndex] = {
                    ...this.markers[markerIndex],
                    position: newPosition
                };
            }

            this.markers = [...this.markers];
        }
    }

    removeGridPoints(shouldRemove: boolean) {
        if(this.selectedGridPoints.length > 0) {
            let index = -1;
            for(let marker of this.selectedGridPoints) {
                index = this.markers.findIndex(m => m.id == marker.id);

                if(index !== -1) {
                    if(shouldRemove) {
                        this.markers.splice(index, 1);
                    } else {
                        this.markers[index] = {
                            ...this.markers[index],
                            content: this.createMarkerContent('../../assets/icons/new_pin_updated.png'),
                            gmpDraggable: true
                        }
                    }
                }
            }

            this.selectedGridPoints = [];

            // Update gridPointId to continue from remaining count
            const remainingSamplingPoints = this.markers.filter(m => m.type === "sampling");
            this.gridPointId = remainingSamplingPoints.length + 1;
        }
    }

    openGridManagerDialog(editPoints: boolean) {
        const dialog = this.dialog.open(GridManagerDialogComponent,
            {
                data: {
                    editPoint: editPoints
                }
            }
        );

        dialog.afterClosed().subscribe((result) => {
            if(result) {
                // console.log(result)
                if(!editPoints) {
                    this.gridDialogResult = result;
                    this.generateSamplingGrid();
                } else {
                    if(this.selectedGridPoints.length > 0) {
                        let index = -1;
                        for(let point of this.selectedGridPoints) {
                            index = this.markers.findIndex(m => m.id == point.id);

                            if(index !== -1) {
                                this.markers[index].title = result?.pointName;
                                this.markers[index].content = this.createMarkerContent('../../assets/icons/new_pin_updated.png');
                            }
                        }

                        this.selectedGridPoints = [];

            // Update gridPointId to continue from remaining count
            const remainingSamplingPoints = this.markers.filter(m => m.type === "sampling");
            this.gridPointId = remainingSamplingPoints.length + 1;
                    }
                }
            }
        });
    }

    confirmCloseGrid() {
        // If we're just viewing grid history (not actively creating/editing a grid), 
        // close without save dialog
        if (this.griddingGroupName && this.griddingGroupName.includes('Viewing Grid:')) {
            this.clearSamplingGrid();
            this.openGridManager = false;
            this.toggleGridManager = false;
            this.griddingGroupName = '';
            return;
        }

        const samplingPoints = this.markers.filter(m => m.type === "sampling");
        if (samplingPoints.length === 0) {
            this.clearSamplingGrid();
            this.openGridManager = false;
            this.toggleGridManager = false;
            return;
        }
        const dialogRef = this.dialog.open(ConfirmGridCloseComponent, {
            width: "400px"
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result === "save") {
                this.dialog.open(NewSaveGridComponent, {
                    data: {
                        markers: samplingPoints,
                        tenantId: this.tenantId,
                        userId: this.helper.getUserId(),
                        fieldId: this.fieldId,
                        gridRotation: this.gridDialogResult?.gridRotation,
                        gridSpacing: this.gridDialogResult?.gridSpacing,
                        onSaveComplete: () => {
                            this.clearSamplingGrid();
                            this.openGridManager = false;
                            this.toggleGridManager = false;
                        }
                    }
                });
            } else if (result === "no") {
                this.clearSamplingGrid();
                this.openGridManager = false;
                this.toggleGridManager = false;
            }
            // "cancel" - do nothing, user goes back to grid
        });
    }

    clearSamplingGrid() {
        // Remove sampling points from markers
        this.markers = [];
        this.samplingPoints = [];
        this.selectedGridPoints = [];

            // Update gridPointId to continue from remaining count
            const remainingSamplingPoints = this.markers.filter(m => m.type === "sampling");
            this.gridPointId = remainingSamplingPoints.length + 1;
        this.showSamplingPoints = false;
        this.clearGridLines();
        this.currentRotation = 0;
        this.originalRotation = 0;
        this.openSnackBar('Sampling grid cleared', 'Dismiss');
        this.isGriddingControlVisable = true;
        this.griddingGroupName = '';
        // this.openGridManager = false;
        // this.toggleGridManager = false;
    }

    captureRainfall() {
        this.openRainMeterSelection();
        this.openOptions();
    }

    showWeatherForecast() {
        this.toggleWeatherForecast();
    }

    toggleWeatherForecast() {
        this.showWeatherCard = !this.showWeatherCard;
        
        if (this.showWeatherCard && this.weatherForecasts.length === 0) {
            const centerAny = this.center as any;
            const lat = typeof centerAny.lat === 'function' ? centerAny.lat() : centerAny.lat;
            const lng = typeof centerAny.lng === 'function' ? centerAny.lng() : centerAny.lng;
            
            this.isWeatherLoading = true;
            this.weatherForecastService.getWeatherForecast(lat, lng).subscribe({
                next: (forecasts) => {
                    this.weatherForecasts = forecasts;
                    this.isWeatherLoading = false;
                },
                error: () => {
                    this.showWeatherCard = false;
                    this.isWeatherLoading = false;
                    this._snackBar.open('Failed to load weather forecast', 'Close', { duration: 3000 });
                }
            });
        }
    }

    openRainMeterSelection() {
        this.nav.toggleLoading(true);
        const dialogRef = this.dialog.open(RainMeterSelectionComponent, {
            data: {
                rainMeters: this.rainMeters
            },
            maxWidth: '100%',
            minWidth: '30%'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                let id = result.id;
                let name = result.name;
                this.rainfallService.getRainfall(id).subscribe((rainfall) => {
                    this.rainfallService.getRainfallClassifications().subscribe((rainfallClassifications) => {
                        this.openRainfallCapture(rainfall, rainfallClassifications, name, id);
                    });
                });
            }

        });
        this.nav.toggleLoading(false);
    }

    openRainfallCapture(rainfall, rainfallClassifications, name, rainMeterId) {
        const dialogRef = this.dialog.open(RainfallCaptureComponent, {
            data: {
                rainfall: rainfall,
                rainfallClassifications: rainfallClassifications,
                name: name,
                rainMeterId: rainMeterId
            },
            maxWidth: '100%',
            minWidth: '30%'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                let rainfall = result.rainfall;
                this.nav.toggleLoading(false);
                this.rainfallService.insertRainfall(rainfall).subscribe((result) => {
                    this.nav.toggleLoading(false);
                    this.openSnackBar(this.translate.instant('FIELD.RAINFALL-CAPTURED'), this.translate.instant('SNACKBAR.DISMISS'));
                });
            }
        });
    }

    getNDVIIndexChartData(fieldId) {

        // this.mappingService.getFieldHistory(fieldId).subscribe((fieldHistory) => {
        //     if (fieldHistory != null) {

        //         if (fieldHistory.cultivar == null) {
        //             this.cultivar = '';
        //         } else {
        //             this.cultivar = fieldHistory.cultivar;
        //         }

        //         if (fieldHistory.plantDate == null && fieldHistory.cropTypeId == null) {
        //             this.plantDate = '';
        //             this.cropId = 0;
        //         } else {
        //             this.plantDate = fieldHistory.plantDate;
        //             this.cropId = fieldHistory.cropTypeId;
        //         }

        //         this.notificationsCheck = fieldHistory.receiveNotifications;

        //         this.mappingService.getFieldById(fieldId).subscribe((field) => {
        //             this.yieldAvg = field.yield_avg;
        //             this.harvestedCheck = field.harvested;
        //             this.fieldS = Number(field.size);
        //             if (this.plantDate != null) {
        //                 this.fieldForm.setValue({
        //                     cropType: this.cropId,
        //                     fieldName: this.fieldName,
        //                     cultivar: this.cultivar,
        //                     plantDate: this.plantDate,
        //                     fieldSize: this.fieldS.toFixed(2),
        //                     yieldAvg: this.yieldAvg
        //                 });
        //             } else {
        //                 this.fieldForm.setValue({
        //                     cropType: 0,
        //                     fieldName: this.fieldName,
        //                     cultivar: '',
        //                     plantDate: '',
        //                     fieldSize: this.fieldS.toFixed(2),
        //                     yieldAvg: this.yieldAvg
        //                 });
        //             }
        //         });
        //     }
        // });

        // this.mappingService.getCropTypes().subscribe((cropTypes) => {
        //     cropTypes = this.helper.getTranslationByName(cropTypes, 'CROPS.');
        //     cropTypes.sort((a, b) => a.name.localeCompare(b.name));
        //     cropTypes.forEach(cropType => {
        //         var tmpCrops: CropType = {
        //             id: cropType.id,
        //             name: cropType.name
        //         };

        //         this.cropTypeList.push(tmpCrops);
        //     });
        // });

        this.mappingService.getNdviChart(this.fieldId, this.fromDate, this.toDate).subscribe((ndviTmpData) => {
            // this.ndviChartData = [];
            this.ndviDate = [];
            this.ndviMinSeries = [];
            this.ndviMaxSeries = [];
            this.ndviMeanSeries = [];
            ndviTmpData.forEach(ndviData => {
                var min = ndviData.min;
                var max = ndviData.max;
                var mean = ndviData.mean.toFixed(2);

                var date = moment(ndviData.lastModified).format('DD MMM YY');
                this.ndviDate.push(date.toString());
                this.ndviMinSeries.push(min);
                this.ndviMaxSeries.push(max);
                this.ndviMeanSeries.push(mean);

            });

            if (this.ndviMinSeries.length != 0) {
                this.chartOptions = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    legend: {
                        data: ['Min', 'Max', 'Mean'],
                        right: 10,
                        top: 10
                    },
                    toolbox: {
                        feature: {
                            dataZoom: {
                                title: {
                                    zoom: 'Zoom Area',
                                    back: 'Reset Zoom'
                                }
                            },
                            restore: {
                                title: 'Reset'
                            },
                            saveAsImage: {
                                title: 'Save as Image'
                            }
                        },
                        right: 10,
                        top: 40
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '20%',
                        top: '20%',
                        containLabel: true
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            show: true,
                            xAxisIndex: 0,
                            start: 0,
                            end: 100,
                            height: 20,
                            bottom: 10,
                            handleSize: '80%',
                            backgroundColor: '#e2e2e2',
                            fillerColor: 'rgba(0, 150, 136, 0.2)',
                            borderColor: '#ccc'
                        },
                        {
                            type: 'inside',
                            xAxisIndex: 0,
                            start: 0,
                            end: 100,
                            zoomLock: false,
                            zoomOnMouseWheel: true,
                            moveOnMouseMove: true
                        }
                    ],
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: this.ndviDate,
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            rotate: 90,
                            interval: 0,
                            formatter: (value, index) => {
                                const totalLabels = this.ndviDate.length;

                                let skipInterval;
                                if (totalLabels > 180) {
                                    skipInterval = Math.ceil(totalLabels / 20);
                                } else if (totalLabels > 90) {
                                    skipInterval = Math.ceil(totalLabels / 25);
                                } else if (totalLabels > 60) {
                                    skipInterval = Math.ceil(totalLabels / 30);
                                } else if (totalLabels > 30) {
                                    skipInterval = Math.ceil(totalLabels / 20);
                                } else {
                                    skipInterval = 1;
                                }

                                return index % skipInterval === 0 ? value : '';
                            },
                            hideOverlap: true
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: 0,
                        max: 1,
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                    series: [
                        {
                            name: 'Min',
                            type: 'line',
                            data: this.ndviMinSeries,
                            itemStyle: { color: '#663333' },
                            lineStyle: {
                                width: 2,
                                color: '#663333'
                            },
                            symbol: 'circle',
                            symbolSize: 0,
                            showSymbol: false,
                            emphasis: {
                                focus: 'series',
                                itemStyle: {
                                    borderColor: '#663333',
                                    borderWidth: 2
                                },
                                symbolSize: 8
                            }
                        },
                        {
                            name: 'Max',
                            type: 'line',
                            data: this.ndviMaxSeries,
                            itemStyle: { color: '#0000CC' },
                            lineStyle: {
                                width: 2,
                                color: '#0000CC'
                            },
                            symbol: 'circle',
                            symbolSize: 0,
                            showSymbol: false,
                            emphasis: {
                                focus: 'series',
                                itemStyle: {
                                    borderColor: '#0000CC',
                                    borderWidth: 2
                                },
                                symbolSize: 8
                            }
                        },
                        {
                            name: 'Mean',
                            type: 'line',
                            data: this.ndviMeanSeries,
                            itemStyle: { color: '#33CC00' },
                            lineStyle: {
                                width: 2,
                                color: '#33CC00'
                            },
                            symbol: 'circle',
                            symbolSize: 0,
                            showSymbol: false,
                            emphasis: {
                                focus: 'series',
                                itemStyle: {
                                    borderColor: '#33CC00',
                                    borderWidth: 2
                                },
                                symbolSize: 8
                            }
                        }
                    ]
                };
            }
        });
    }

    notificationsChanged(ob: MatSlideToggleChange) {
        this.notificationsCheck = ob.checked;
    }

    harvestedChanged(ob: MatSlideToggleChange) {
        this.harvestedCheck = ob.checked;
    }

    onSubmit() {

        this.updateValidation();
    }

    updateValidation() {

        this.newCropTypeId = Number(this.fieldForm.controls.cropType.value);
        this.newCultivar = this.fieldForm.controls.cultivar.value;
        this.newFieldName = this.fieldForm.controls.fieldName.value;
        this.newPlantDate = this.fieldForm.controls.plantDate.value;

        this.newYieldAvg = this.fieldForm.controls.yieldAvg.value;
        if (this.newYieldAvg != 0 && this.newYieldAvg != null) {
            this.newYieldAvg = this.newYieldAvg.replace(',', '.');
        }
        if (this.yieldAvg == null) {
            this.newYieldAvg = 0;
        }
        if (typeof Number(this.newYieldAvg) != 'number' || Number(this.newYieldAvg).toString() == 'NaN') {
            this.openSnackBar(this.translate.instant('FIELD-ADMIN.YIELD-AVG-NUMBER-ERR'), this.translate.instant('SNACKBAR.DISMISS'));
            this.newYieldAvg = null;
        } else if (!parseFloat(this.newYieldAvg) && this.newYieldAvg != 0) {
            this.openSnackBar(this.translate.instant('FIELD-ADMIN.YIELD-AVG-NUMBER-ERR'), this.translate.instant('SNACKBAR.DISMISS'));
            this.newYieldAvg = null;
        } else if (Number(this.newYieldAvg) > 10000) {
            this.openSnackBar(this.translate.instant('FIELD-ADMIN.YIELD-AVG-SIZE-ERR'), this.translate.instant('SNACKBAR.DISMISS'));
            this.newYieldAvg = null;
        } else {
            this.newYieldAvg = parseFloat(this.newYieldAvg);
        }

        ;
        if (this.newFieldName == '') {
            this.openSnackBar(this.translate.instant('FIELD.ERR-FIELD-NAME'), this.translate.instant('SNACKBAR.DISMISS'));
        } else {
            this.openSnackBar(this.translate.instant('FIELD.ERR-CROP-AND-PLANT-DATE'), this.translate.instant('SNACKBAR.DISMISS'));
        }

    }

    // updateCropHistory() {

    //     this.userId = this.helper.getUserId();
    //     if (this.newYieldAvg != null) {
    //         if (this.newCropTypeId == 0) {
    //             let fieldHistory = {
    //                 fieldId: this.fieldId,
    //                 cropTypeId: null,
    //                 cultivar: null,
    //                 plantDate: null,
    //                 fieldName: this.newFieldName,
    //                 receiveNotifications: this.notificationsCheck,
    //                 yieldAvg: this.newYieldAvg,
    //                 harvested: this.harvestedCheck,
    //                 userId: this.userId
    //             };

    //             this.mappingService.updateFieldHistory(fieldHistory).subscribe((value => {
    //                 this.openSnackBar(this.translate.instant('FIELD.FIELD-NAME-UPDATED'), this.translate.instant('SNACKBAR.DISMISS'));
    //             }));
    //         } else {
    //             var newpDate = moment(this.newPlantDate);
    //             var PlantDate = String(newpDate.format('YYYY-MM-DD'));

    //             let fieldHistory: FieldHistory = {
    //                 fieldId: this.fieldId,
    //                 cropTypeId: this.newCropTypeId,
    //                 cultivar: this.newCultivar,
    //                 plantDate: PlantDate,
    //                 fieldName: this.newFieldName,
    //                 receiveNotifications: this.notificationsCheck,
    //                 yieldAvg: this.newYieldAvg,
    //                 harvested: this.harvestedCheck,
    //                 userId: this.userId
    //             };

    //             this.mappingService.updateFieldHistory(fieldHistory).subscribe((value => {
    //                 this.openSnackBar(this.translate.instant('FIELD.FIELD-HISTORY-UPDATED'), this.translate.instant('SNACKBAR.DISMISS'));
    //             }));
    //         }
    //     }
    // }

    openDateRange() {
        const dialogRef = this.dialog.open(DateRangeComponent, {
            data: { 'fromDate': this.fromDate, 'toDate': this.toDate }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                this.fromDate = result.fromDate.format('YYYY-MM-DD');
                this.toDate = result.toDate.format('YYYY-MM-DD');

                this.formattedFrom = result.fromDate.format('DD MMM');
                this.formattedTo = result.toDate.format('DD MMM');

                this.getNDVIIndexChartData(this.fieldId);
            }
        });
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        if (this.oneAction) {
            this.openSnackBar(this.translate.instant('MAPPING.FINISH-EDITING'), this.translate.instant('SNACKBAR.DISMISS'));
        } else {
            this.nav.toggleLoading(false);
            if (!this.navigateField) {
                this.base.setFarm(this.farmId, this.farmName);
                if (this.farmImages.length > 0) {
                    this.farmImages[this.fieldIndex].image = this.fieldImagesMapTwo[0].image;
                    this.farmImages[this.fieldIndex].fieldId = this.fieldId;
                    this.farmImages[this.fieldIndex].bounds = this.fieldImagesMapTwo[0].bounds;
                }
                if (this.newHistory != null) {
                    this.overlayedFieldAnalysis.push(this.newHistory);
                }
                this.base.setAnalysis(this.overlayedFieldAnalysis, this.farmImages, this.polygon, this.polygons);
            } else {
                this.router.navigate(['/virtual-consultant'], {
                    state: {
                        navigateField: this.navigateField,
                        inspectionKey: this.inspectionKey,
                        lat: this.lat,
                        lng: this.lng,
                        tenantId: this.tenantId,
                        description: this.description
                    }
                });
            }
        }
    }

    createMarkerWithLabel(labelText: string): HTMLElement {
        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';
        
        // const img = document.createElement('img');
        // img.src = iconUrl;
        // img.style.width = '24px';
        // img.style.height = '29px';
        
        const label = document.createElement('span');
        label.textContent = labelText;
        label.style.fontSize = '12px';
        label.style.fontWeight = 'bold';
        label.style.color = 'white';
        
        // container.appendChild(img);
        container.appendChild(label);
        return container;
    }

    createMarkerContent(iconUrl: string): HTMLElement {
        const img = document.createElement('img');
        img.src = iconUrl;
        img.style.width = '24px';
        img.style.height = '29px';
        return img;
    }

    createCircleMarkerContent(scale = 8, fillColor = '#FF6B00', fillOpacity = 1, strokeColor = '#000000', strokeWeight = 2) {
        const size = scale * 2;
        const container = document.createElement('div');
        container.style.transform = 'translate(0%, 50%)';
        container.style.cursor = 'pointer';
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', `${size}`);
        svg.setAttribute('height', `${size}`);
        svg.setAttribute('viewBox', `0 0 ${size} ${size}`);
        const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        circle.setAttribute('cx', `${scale}`);
        circle.setAttribute('cy', `${scale}`);
        circle.setAttribute('r', `${scale - strokeWeight}`);
        circle.setAttribute('fill', fillColor);
        circle.setAttribute('fill-opacity', `${fillOpacity}`);
        circle.setAttribute('stroke', strokeColor);
        circle.setAttribute('stroke-width', `${strokeWeight}`);
        svg.appendChild(circle);
        container.appendChild(svg);
        return container;
    }

    openInfo(markerObject) {
        // this.infoWindow.open(marker);
        if(!this.openGridManager) {
            this.marker = markerObject;
            this.infoClick(markerObject);
        } else {
            // Check if marker has pinTypeId, if so show saved pin info instead of grid selection
            if (markerObject?.pinTypeId) {
                this.marker = markerObject;
                this.infoClick(markerObject);
                return;
            }

            // console.log('Grid Manager', this.openGridManager, markerObject);

            const markerIndex = this.markers.findIndex(m => m?.id === markerObject?.id);

            const gridIndex = this.selectedGridPoints.findIndex(m => m?.id === markerObject?.id);

            // console.log('Marker Index', markerIndex);

            if (markerIndex !== -1) {
                // Create a new marker object with updated icon
                this.markers[markerIndex] = {
                    ...this.markers[markerIndex],
                    content: this.createMarkerContent(gridIndex === -1 ? this.iconUrl?.urlSelected : this.iconUrl?.urlNewTemp),
                    options: {
                        ...this.markers[markerIndex].options,
                    }
                };

                if(gridIndex !== -1) {
                    this.selectedGridPoints.splice(gridIndex, 1);
                } else {
                    this.selectedGridPoints.push(this.markers[markerIndex]);
                }

                // console.log(this.markers.length)
            }
        }
    }

    toggleOverview(width) {
        if (width > 50) {
            this.fieldWidth = width;
            this.showField = false;
        } else {
            this.showField = true;
        }

        this.animationState = this.animationState === 'out' ? 'in' : 'out';
        if (this.showField) {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 1);
        }
    }

    editField(map: GoogleMap) {
        if (this.oneAction) {
            this.openSnackBar(this.translate.instant('MAPPING.FINISH-EDITING'), this.translate.instant('SNACKBAR.DISMISS'));
            return;
        }

        this.userId = this.helper.getUserId();
        this.disableBackButton();
        this.nav.enableMenu = false;
        this.action = this.editingField;
        this.oneAction = true;
        this.editing = true;
        this.originalPolygon = this.polygon;
        this._capturedClassified = classifyPolygon(this.polygon);

        this.singlePolygon = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: true,
        };

        const { outerRing, holes, multiParts } = this._capturedClassified;

        const editablePaths: google.maps.LatLngLiteral[][] = [
            outerRing,
            ...holes,
            ...multiParts,
        ];

        this.editablePolygon = new google.maps.Polygon({
            paths: editablePaths,
            map: map.googleMap,
            options: this.singlePolygon,
        });
        this.polygon = [];

        this.addedPolygons = this.polygons.filter((p) => p.id !== this.fieldId);

        this.editablePolygon.getPaths().forEach((path) => {
            google.maps.event.addListener(path, 'insert_at', (event) => {
                this.saveField = true;
            });

            google.maps.event.addListener(path, 'remove_at', (event) => {
                this.saveField = true;
            });
            google.maps.event.addListener(path, 'set_at', (event) => {
                this.saveField = true;
            });
        });

        this.nav.toggleLoading(false);
    }

    updateField() {
        this.isOpen = false;
        this.nav.toggleLoading(true);

        const edited = classifyEditedPolygon(this.editablePolygon);
        const payload = buildPolygonPayload(edited, []);

        this.enableBackButton();
        this.nav.enableMenu = true;
        this.oneAction = false;
        this.saveField = false;
        this.editing = false;


        this.editablePolygon.setMap(null);
        this.editablePolygon = null;

        const polygon: Polygon = {
            polygon: payload.polygon as any,
            interiorPolygons: payload.interiorPolygons,
            fieldId: this.fieldId,
            edit: true,
            singleField: true,
            tenantId: this.tenantId,
            farmId: this.farmId,
            loadingUser: this.userId
        };

        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe({
            next: (result) => {
                if (result.result == 1) {
                    this.openSnackBar(
                        this.translate.instant('MAPPING.FIELD-ADDED'),
                        this.translate.instant('SNACKBAR.DISMISS')
                    );
                } else {
                    this.openSnackBar(
                        this.translate.instant('MAPPING.ADD-FIELD-ERROR'),
                        this.translate.instant('SNACKBAR.DISMISS')
                    );
                }

                this.refreshField();
            },
            error: (err) => {
                console.error('Failed to update field', err);
                this.openSnackBar(
                    this.translate.instant('MAPPING.ADD-FIELD-ERROR'),
                    this.translate.instant('SNACKBAR.DISMISS')
                );
                this.polygon = this.originalPolygon;
                this.nav.toggleLoading(false);
            }
        });

        if (this.splitField) {
            this.initDrawingManager(this.map);
            this.stillDrawing = true;
            this.oneAction = true;
            this.action = this.drawing + ": " + this.splitFieldName;
        }
    }

    initDrawingManager(map) {
        this.nav.toggleLoading(true);
        this.disableBackButton();

        this.nav.enableMenu = false;
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.CIRCLE,
                    google.maps.drawing.OverlayType.POLYGON
                ],
            },
            circleOptions: {
                fillOpacity: 0.0,
                editable: true,
            },
            polygonOptions: {
                fillOpacity: 0.0,
                editable: true,
            },
        });
        this.drawingManager.setMap(map.googleMap);
        google.maps.polygonOptions = this.polygonOptions;

        google.maps.event.addListener(this.drawingManager, 'circlecomplete', (circle) => {
            let area = circle.getRadius() * circle.getRadius() * Math.PI;
            if (area < 10000000) {
                if (area > 1) {
                    this.circle = circle;
                    let radius = circle.getRadius();
                    let center = circle.getCenter();
                    let lat = center.lat();
                    let lng = center.lng();

                    const dialogRef = this.dialog.open(NewFieldComponent, {
                        data: {}
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        if (result != null) {
                            if (result.option == "add") {
                                let userId = this.helper.getUserId();
                                let addField: AddField = {
                                    name: this.splitFieldName,
                                    farmId: this.farmId,
                                    userId: userId
                                }
                                this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
                                    let polygon: CirclePolygon = {
                                        lat: lat,
                                        lng: lng,
                                        radius: Math.round(radius),
                                        fieldId: result.id,
                                        tenantId: this.tenantId,
                                        farmId: this.farmId,
                                        loadingUser: this.userId
                                    }
                                    this.boundaryManagementService.updateCircularField(polygon).subscribe((result) => {
                                        this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
                                        this.stillDrawing = false;
                                        this.splitField = false;
                                        this.oneAction = false;
                                        this.enableBackButton();
                                        this.nav.enableMenu = true;
                                        this.drawingManager.setMap(null);
                                        this.nav.toggleLoading(false);
                                        circle.setMap(null);
                                        this.drawingManager.setMap(null);
                                        this.refreshFields();
                                    });
                                    this.nav.toggleLoading(false);
                                });
                            } else if (result.option == "edit") {
                                this.stillDrawing = false;
                                this.splitField = false;
                                this.splitPolygon = circle;
                                this.editNewField(map, circle, null, true, "field");
                                this.drawingManager.setMap(null);
                                this.editing = true;
                                this.oneAction = true;
                                this.action = this.busyEditing + ": " + this.splitFieldName;
                            } else if (result.option == "redraw" || result.option == "cancel") {
                                circle.setMap(null);
                                this.splitField = false;
                            }
                        }
                    });
                } else {
                    this.openSnackBar(this.translate.instant("MAPPING.SMALL-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
                    circle.setMap(null);
                }
            }
            else {
                this.openSnackBar(this.translate.instant("MAPPING.BIG-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
                circle.setMap(null);
            }
        });

        google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event) => {
            if (event.type == 'polygon') {
                let area = google.maps.geometry.spherical.computeArea(event.overlay.getPath());
                if (area < 100000000) {
                    if (area > 1) {
                        let newPolygon = event;
                        let poly = google.maps.geometry.encoding.encodePath(event.overlay.getPath());

                        const dialogRef = this.dialog.open(NewFieldComponent, {
                            data: {}
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result != null) {
                                if (result.option == "add") {
                                    this.isOpen = false;
                                    this.oneAction = false;
                                    let userId = this.helper.getUserId();
                                    let addField: AddField = {
                                        name: this.splitFieldName,
                                        farmId: this.farmId,
                                        userId: userId
                                    }
                                    this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {
                                        this.nav.toggleLoading(false);
                                        let inside: boolean = false;
                                        let outside: boolean = false;
                                        let insidePoly = [];
                                        let outsidePoly = [];
                                        let indentInside = [];
                                        let indentOutside = [];
                                        let polyArray = event.overlay.getPath();
                                        const newPoly = new google.maps.Polygon({ paths: polyArray });
                                        for (let i = 0; i < this.polygons.length; i++) {
                                            const exixtingPoly = new google.maps.Polygon({ paths: this.polygons[i].points });
                                            var newPolyArray = event.overlay.getPath().getArray();
                                            for (let j = 0; j < newPolyArray.length; j++) {
                                                if (google.maps.geometry.poly.containsLocation(newPolyArray[j], exixtingPoly)) {
                                                    indentInside.push(true);
                                                    inside = true;
                                                    if (insidePoly.find(x => x.id == this.polygons[i].id)) {
                                                    } else {
                                                        insidePoly.push(this.polygons[i]);
                                                    }
                                                }
                                            }
                                            for (let j = 0; j < this.polygons[i].points.length; j++) {
                                                var lat = this.polygons[i].points[j].lat;
                                                var lng = this.polygons[i].points[j].lng;
                                                const latLng = new google.maps.LatLng(lat, lng);
                                                if (google.maps.geometry.poly.containsLocation(latLng, newPoly)) {
                                                    indentOutside.push(true);
                                                    outside = true;
                                                    if (outsidePoly.find(x => x == this.polygons[i].id)) {
                                                    } else {
                                                        outsidePoly.push(this.polygons[i].id);
                                                    }
                                                }
                                            }
                                        }
                                        let polygon: Polygon = {
                                            polygon: poly,
                                            interiorPolygons: null,
                                            fieldId: result.id,
                                            edit: false,
                                            singleField: true,
                                            tenantId: this.tenantId,
                                            farmId: this.farmId,
                                            loadingUser: this.userId
                                        }

                                        this.stillDrawing = false;

                                        if (inside && outside) {
                                            this.updatePolygonFieldByPosition(polygon, insidePoly, outsidePoly, "both", event, true);
                                        } else if (inside) {
                                            this.updatePolygonFieldByPosition(polygon, insidePoly, null, "inside", event, true);
                                        } else if (outside) {
                                            this.updatePolygonFieldByPosition(polygon, outsidePoly, null, "outside", event, true);
                                        } else {
                                            this.updatePolygonField(polygon, event);
                                        }
                                        this.nav.toggleLoading(false);
                                    });
                                } else if (result.option == "edit") {
                                    this.stillDrawing = false;
                                    this.splitField = false;
                                    this.splitPolygon = event;
                                    this.editNewField(map, null, event.overlay.getPath(), false, "field");
                                    this.drawingManager.setMap(null);
                                    this.oneAction = true;
                                    this.action = this.busyEditing + ": " + this.splitFieldName;
                                } else if (result.option == "redraw" || result.option == "cancel") {
                                    event.overlay.setMap(null);
                                    this.splitField = false;
                                }
                            }
                        });
                    } else {
                        this.openSnackBar(this.translate.instant("MAPPING.SMALL-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
                        event.overlay.setMap(null);
                    }
                } else {
                    this.openSnackBar(this.translate.instant("MAPPING.BIG-FIELD"), this.translate.instant("SNACKBAR.DISMISS"));
                    event.overlay.setMap(null);
                }
            }
        });
    }

    editNewField(map: GoogleMap, circlePoly, path, circle, option) {

        this.editing = true;
        this.singlePolygon = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: true,
            draggable: false
        }

        if (circle) {
            this.editableCircle = new google.maps.Circle({
                center: circlePoly.getCenter(),
                raduis: circlePoly.getRadius(),
                map: map.googleMap,
                options: this.singlePolygon
            });

            google.maps.event.addListener(circlePoly, 'radius_changed', (event) => {
                if (option == "field") {
                    this.saveEditedField = true;
                } else {
                    this.saveArea = true;
                }
                this.editableCircle.setRadius(circlePoly.getRadius());
            });

            google.maps.event.addListener(circlePoly, 'center_changed', (event) => {
                if (option == "field") {
                    this.saveEditedField = true;
                } else {
                    this.saveArea = true;
                }
                this.editableCircle.setCenter(circlePoly.getCenter());
            });
        } else {
            // this.editablePolygon = new google.maps.Polygon({
            //     paths: path,
            //     map: map.googleMap,
            //     options: this.singlePolygon
            // });

            google.maps.event.addListener(path, 'insert_at', (event) => {
                if (option == "field") {
                    this.saveEditedField = true;
                } else {
                    this.saveArea = true;
                }
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'remove_at', (event) => {
                if (option == "field") {
                    this.saveEditedField = true;
                } else {
                    this.saveArea = true;
                }
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'set_at', (event) => {
                if (option == "field") {
                    this.saveEditedField = true;
                } else {
                    this.saveArea = true;
                }
                this.editablePolygon.setPaths(path);
            });
            // });
        }
    }

    updateEditedField(map) {
        this.map = map;
        this.nav.toggleLoading(true);
        let userId = this.helper.getUserId();
        let addField: AddField = {
            name: this.splitFieldName,
            farmId: this.farmId,
            userId: userId
        }
        this.boundaryManagementService.insertFieldName(addField).subscribe((result) => {

            if (this.editableCircle != null) {
                let polygon: CirclePolygon = {
                    lat: this.editableCircle.getCenter().lat(),
                    lng: this.editableCircle.getCenter().lng(),
                    radius: Math.round(this.editableCircle.getRadius()),
                    fieldId: result.id,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                }
                this.boundaryManagementService.updateCircularField(polygon).subscribe((result) => {
                    this.openSnackBar(this.translate.instant("MAPPING.FIELD-ADDED"), this.translate.instant("SNACKBAR.DISMISS"));
                    this.stillDrawing = false;
                    this.splitField = false;
                    this.oneAction = false;
                    this.nav.toggleLoading(false);
                    this.editableCircle.setMap(null);
                    this.editableCircle.setMap(null);
                    this.circle.setMap(null);
                    this.enableBackButton();
                    this.nav.enableMenu = true;
                    this.editing = false;
                    this.saveEditedField = false;
                    this.refreshFields();
                    this.nav.toggleLoading(false);
                });
            } else if (this.editablePolygon != null) {
                var poly = google.maps.geometry.encoding.encodePath(this.editablePolygon.getPath());
                let inside: boolean = false;
                let outside: boolean = false;
                let insidePoly = [];
                let outsidePoly = [];
                let indentInside = [];
                let indentOutside = [];
                let polyArray = this.editablePolygon.getPath();
                const newPoly = new google.maps.Polygon({ paths: polyArray });
                for (let i = 0; i < this.polygons.length; i++) {
                    const exixtingPoly = new google.maps.Polygon({ paths: this.polygons[i].points });
                    var newPolyArray = this.editablePolygon.getPath().getArray();
                    for (let j = 0; j < newPolyArray.length; j++) {
                        if (google.maps.geometry.poly.containsLocation(newPolyArray[j], exixtingPoly)) {
                            indentInside.push(true);
                            inside = true;
                            if (insidePoly.find(x => x.id == this.polygons[i].id)) {
                            } else {
                                insidePoly.push(this.polygons[i]);
                            }
                        }
                    }
                    for (let j = 0; j < this.polygons[i].points.length; j++) {
                        var lat = this.polygons[i].points[j].lat;
                        var lng = this.polygons[i].points[j].lng;
                        const latLng = new google.maps.LatLng(lat, lng);
                        if (google.maps.geometry.poly.containsLocation(latLng, newPoly)) {
                            indentOutside.push(true);
                            outside = true;
                            if (outsidePoly.find(x => x == this.polygons[i].id)) {
                            } else {
                                outsidePoly.push(this.polygons[i].id);
                            }
                        }
                    }
                }
                let polygon: Polygon = {
                    polygon: poly,
                    interiorPolygons: null,
                    fieldId: result.id,
                    edit: false,
                    singleField: true,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                }
                this.editing = false;
                this.saveEditedField = false;

                this.nav.toggleLoading(false);
                if (inside && outside) {
                  this.updatePolygonFieldByPosition(polygon, insidePoly, outsidePoly, "both", null, true);
                } else if (inside) {
                  this.updatePolygonFieldByPosition(polygon, insidePoly, null, "inside", null, true);
                } else if (outside) {
                  this.updatePolygonFieldByPosition(polygon, outsidePoly, null, "outside", null, true);
                } else {
                  this.updatePolygonField(polygon, true);
                }
            }
        });
        this.nav.toggleLoading(false);
    }

    updatePolygonFieldByPosition(polygon, poly, poly1, position, original, splitField?) {
        polygon.singleField = false;
        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {
            let validAreas = result.valid;
            if (result.result == 1) {
                this.nav.toggleLoading(true);
                let counter = 0;
                let failed = false;
                validAreas.forEach(valid => {
                    if (valid == false) {
                        failed = true;
                    }
                    counter++;
                    if (counter == validAreas.length) {
                        if (failed) {
                            this.openSnackBar(this.translate.instant('FIELD.INVALID-AREA'), this.translate.instant('SNACKBAR.DISMISS'));
                        } else {
                            this.openSnackBar(this.translate.instant('MAPPING.FIELD-ADDED'), this.translate.instant('SNACKBAR.DISMISS'));
                        }
                    }
                });
                if (position == 'inside') {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.addedPolygons.length; i++) {
                        for (let j = 0; j < this.addedPolygons[i].points.length; j++) {
                            var lat = this.addedPolygons[i].points[j].lat;
                            var lng = this.addedPolygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {
                                if (existingHoles.find(x => x == this.addedPolygons[i].id)) {
                                } else {
                                    if (this.addedPolygons[i].id != poly[0].id) {
                                        existingHoles.push(this.addedPolygons[i].id);
                                    }
                                }
                            }
                        }
                    }
                    let counter = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[0].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: splitField ? null : original,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        };
                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            counter++;
                            if (poly.length == counter) {
                                this.refreshFields(splitField ? original : null);
                            }
                        });
                    }
                } else if (position == 'outside') {
                    let multiPoly: MultiPolygonField;
                    multiPoly = {
                        fieldId: polygon.fieldId,
                        smallField: poly,
                        multipleFields: true,
                        edit: polygon.edit,
                        polygon: polygon.polygon,
                        originalPolygon: splitField ? null : original,
                        tenantId: this.tenantId,
                        farmId: this.farmId,
                        loadingUser: this.userId
                    };
                    this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                        this.refreshFields(splitField ? original : null);
                    });
                } else if (position == 'both') {
                    const newBigPoly = new google.maps.Polygon({ paths: poly[0].points });
                    let existingHoles = [];
                    for (let i = 0; i < this.addedPolygons.length; i++) {
                        for (let j = 0; j < this.addedPolygons[i].points.length; j++) {
                            var lat = this.addedPolygons[i].points[j].lat;
                            var lng = this.addedPolygons[i].points[j].lng;
                            const latLng = new google.maps.LatLng(lat, lng);
                            if (google.maps.geometry.poly.containsLocation(latLng, newBigPoly)) {
                                if (existingHoles.find(x => x == this.addedPolygons[i].id)) {
                                } else {
                                    if (this.addedPolygons[i].id != poly[0].id) {
                                        existingHoles.push(this.addedPolygons[i].id);
                                    }
                                }
                            }
                        }
                    }
                    let counter = 0;
                    for (let i = 0; i < poly.length; i++) {
                        let multiPoly: MultiPolygonField;
                        multiPoly = {
                            fieldId: poly[i].id,
                            smallField: polygon.fieldId,
                            multipleFields: false,
                            edit: polygon.edit,
                            polygon: polygon.polygon,
                            originalPolygon: splitField ? null : original,
                            tenantId: this.tenantId,
                            farmId: this.farmId,
                            loadingUser: this.userId
                        };
                        this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            counter++;
                            if (poly.length == counter) {
                                this.refreshFields(splitField ? original : null);
                            }
                        });
                        if (i == poly.length) {
                            let multiPoly: MultiPolygonField;
                            multiPoly = {
                                fieldId: polygon.fieldId,
                                smallField: poly1,
                                multipleFields: true,
                                edit: polygon.edit,
                                polygon: polygon.polygon,
                                originalPolygon: splitField ? null : original,
                                tenantId: this.tenantId,
                                farmId: this.farmId,
                                loadingUser: this.userId
                            };
                            this.boundaryManagementService.updateFieldContainingFields(multiPoly).subscribe((result) => {
                            });
                        }
                    }
                }
            } else if (result.result == 0) {
                this.openSnackBar(this.translate.instant('MAPPING.ADD-FIELD-ERROR'), this.translate.instant('SNACKBAR.DISMISS'));
                this.polygon = this.originalPolygon;
                this.nav.toggleLoading(false);
            }
            // this.polygon = this.editablePolygon.getPaths().getArray();
            this.editablePolygon.setMap(null);
        });
        this.nav.toggleLoading(false);
    }

    updatePolygonField(polygon, splitField?) {
        this.nav.toggleLoading(true);
        this.boundaryManagementService.updateFieldMultiPolygonSupport(polygon).subscribe((result) => {
            let validAreas = result.valid;
            if (result.result == 1) {
                let counter = 0;
                let failed = false;
                validAreas.forEach(valid => {
                    if (valid == false) {
                        failed = true;
                    }
                    counter++;
                    if (counter == validAreas.length) {
                        if (failed) {
                            this.openSnackBar(this.translate.instant('FIELD.INVALID-AREA'), this.translate.instant('SNACKBAR.DISMISS'));
                        } else {
                            this.openSnackBar(this.translate.instant('MAPPING.FIELD-ADDED'), this.translate.instant('SNACKBAR.DISMISS'));
                        }
                    }
                });
                this.refreshFields(splitField);
            } else if (result.result == 0) {
                this.openSnackBar(this.translate.instant('MAPPING.ADD-FIELD-ERROR'), this.translate.instant('SNACKBAR.DISMISS'));
                this.refreshFields(splitField);
                this.nav.toggleLoading(false);
            }

            this.editablePolygon.setMap(null);
        });
        this.nav.toggleLoading(false);
    }

    stopEditing() {
        this.openOptions();

        if (this.saveField) {
            const dialogRef = this.dialog.open(SaveChangesComponent, {
                data: {}
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result != null) {
                    if (result.option == 'save') {
                        this.updateField();
                    } else {
                        this.enableBackButton();
                        this.nav.enableMenu = true;
                        this.editing = false;
                        this.splitField = false;
                        this.oneAction = false;
                        this.saveField = false;
                        this.editablePolygon.setMap(null);
                        this.polygon = this.originalPolygon;
                        this.polygonOptions = {
                            editable: false,
                            fillOpacity: 0.0
                        };
                    }
                }
            });
        } else {
            this.enableBackButton();
            this.nav.enableMenu = true;
            this.editing = false;
            this.splitField = false;
            this.saveField = false;
            this.oneAction = false;
            this.polygon = this.originalPolygon;
            this.editablePolygon.setMap(null);
            this.polygonOptions = {
                editable: false,
                fillOpacity: 0.0
            };
          this.splitPolygon.overlay.setMap(null);
          this.splitPolygon = null;
        }

        if(this.drawingManager) {
          this.drawingManager.setMap(null);
        }

    }

    excludeArea(map) {
        this.nav.toggleLoading(true);
        if (this.oneAction) {
            this.openSnackBar(this.translate.instant('MAPPING.FINISH-EDITING'), this.translate.instant('SNACKBAR.DISMISS'));
            this.openOptions();
            return;
        }

        this.oneAction = true;
        this.isDrawingMode = true;
        this.drawingType = 'polygon';
        this.drawnPoints = [];
        this.userId = this.helper.getUserId();
        this.disableBackButton();
        this.nav.enableMenu = false;
        this.action = this.excludingArea;

        this.fieldMap = map.googleMap;
        this.fieldGoogleMap = map;
        map.googleMap.setOptions({
            draggableCursor: 'crosshair',
            disableDoubleClickZoom: true
        });
        this.openOptions();
        this.nav.toggleLoading(false);
    }

    switchDrawingType(type: 'polygon' | 'circle' | null, map) {
        if (this.drawingType === type) return;

        this.clearDrawnMarkers();
        if (this.previewPolyline) {
            this.previewPolyline.setMap(null);
            this.previewPolyline = null;
        }
        if (this.previewPolygon) {
            this.previewPolygon.setMap(null);
            this.previewPolygon = null;
        }
        this.clearCircleDrawing(map);
        this.drawnPoints = [];
        this.drawingType = type;

        if (type === null) {
            map.googleMap.setOptions({ draggableCursor: 'grab' });
        } else {
            map.googleMap.setOptions({ draggableCursor: 'crosshair' });
        }
    }

    updatePreviewLine(latLng: google.maps.LatLngLiteral) {
        if (this.drawnPoints.length === 0) return;
        const lastPoint = this.drawnPoints[this.drawnPoints.length - 1];
        if (this.previewLine) {
            this.previewLine.setPath([lastPoint, latLng]);
        } else {
            this.previewLine = new google.maps.Polyline({
                path: [lastPoint, latLng],
                map: this.fieldMap,
                strokeColor: '#000000',
                strokeOpacity: 0.6,
                strokeWeight: 2,
                clickable: false,
                zIndex: -1
            });
        }
    }

    addDrawingPoint(latLng: google.maps.LatLngLiteral) {
        if (!isPointInsideField(latLng, this.polygon)) {
            this.openSnackBar(
                this.translate.instant('FIELD.DOES-NOT-CONTAIN'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            return;
        }

        const SNAP_TOLERANCE = 0.00001;
        const snappedPoint   = this.drawnPoints.find((p) =>
            Math.abs(p.lat - latLng.lat) < SNAP_TOLERANCE &&
            Math.abs(p.lng - latLng.lng) < SNAP_TOLERANCE
        );
        const pointToAdd = snappedPoint ?? latLng;
        this.drawnPoints.push(pointToAdd);

        const isFirstPoint = this.drawnPoints.length === 1;
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: pointToAdd,
            map: this.fieldMap,
            content: this.createCircleMarkerContent(
                isFirstPoint ? 8 : 6,
                isFirstPoint ? '#FF6B00' : '#ffffff',
                1,
                '#000000',
                2
            ),
            zIndex: 9999
        });

        if (isFirstPoint) {
            marker.content.addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.drawnPoints.length >= 3) {
                    this.finishCustomDrawing({ googleMap: this.fieldMap });
                }
            });
        }
        this.drawnMarkers.push(marker);
        this.updatePreview();
    }

    updatePreview() {
        if (this.previewPolygon) {
            this.previewPolygon.setMap(null);
            this.previewPolygon = null;
        }
        if (this.drawnPoints.length >= 2) {
            const path = this.drawnPoints.map(p => new google.maps.LatLng(p.lat, p.lng));
            if (this.previewPolyline) {
                this.previewPolyline.setPath(path);
            } else {
                this.previewPolyline = new google.maps.Polyline({
                    path: path,
                    strokeColor: this.fieldBoundaryEditColor,
                    strokeWeight: 3,
                    geodesic: true,
                    map: this.fieldMap
                });
            }
        } else {
            if (this.previewPolyline) {
                this.previewPolyline.setMap(null);
                this.previewPolyline = null;
            }
        }
    }


    clearDrawnMarkers() {
        this.drawnMarkers.forEach(m => m.map = null);
        this.drawnMarkers = [];
        if (this.previewLine) {
            this.previewLine.setMap(null);
            this.previewLine = null;
        }
    }

    undoLastPoint(map) {
        if (this.drawnPoints.length > 0) {
            this.drawnPoints = this.drawnPoints.slice(0, -1);
            const lastMarker = this.drawnMarkers.pop();
            if (lastMarker) lastMarker.map = null;
            if (this.drawnPoints.length < 3 && this.previewPolygon) {
                this.previewPolygon.setMap(null);
                this.previewPolygon = null;
            }
            this.updatePreview();
        }
    }

    startCircleDrawing(latLng: google.maps.LatLngLiteral) {
        if (this.circleCenter) return;
        let fieldPoly: google.maps.Polygon;
        if (this.polygon[0].length == 1) {
            fieldPoly = new google.maps.Polygon({ paths: this.polygon });
        } else {
            fieldPoly = new google.maps.Polygon({ paths: this.polygon[0] });
        }

        const point = new google.maps.LatLng(latLng.lat, latLng.lng);
        if (!google.maps.geometry.poly.containsLocation(point, fieldPoly)) {
            this.openSnackBar(
                this.translate.instant('FIELD.DOES-NOT-CONTAIN'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            return;
        }



        this.circleCenter = latLng;
        this.previewCircle = new google.maps.Circle({
            center: latLng,
            radius: 50,
            strokeColor: this.fieldBoundaryEditColor,
            strokeWeight: 3,
            fillOpacity: 0.2,
            fillColor: this.fieldBoundaryEditColor,
            map: this.fieldMap,
            editable: true
        });
    }

    finishCustomDrawing(map?) {
        const googleMap = map?.googleMap ?? this.fieldMap;

        if (this.drawingType === 'circle') {
            this.finishCircleDrawing({ googleMap });
            return;
        }

        if (this.drawnPoints.length < 3) {
            this.openSnackBar(
                this.translate.instant('MAPPING.MIN-POINTS'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            return;
        }

        const overlayPath = this.drawnPoints.map((p) => new google.maps.LatLng(p.lat, p.lng));

        const anyInside = this.drawnPoints.some((p) => isPointInsideField(p, this.polygon));

        if (!anyInside) {
            this.openSnackBar(
                this.translate.instant('FIELD.DOES-NOT-CONTAIN'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            this.resetDrawingState(googleMap);
            return;
        }

        this.isDrawingMode = false;
        googleMap.setOptions({ draggableCursor: null, disableDoubleClickZoom: true });

        this.clearDrawnMarkers();
        if (this.previewPolyline) { this.previewPolyline.setMap(null); this.previewPolyline = null; }
        if (this.previewPolygon)  { this.previewPolygon.setMap(null);  this.previewPolygon  = null; }

        const dialogRef = this.dialog.open(NewAreaComponent, { data: {} });

        dialogRef.afterClosed().subscribe((result) => {
            if (result?.option === 'add') {
                this.nav.toggleLoading(true);
                const encodedPath = google.maps.geometry.encoding.encodePath(overlayPath);

                const fieldArea: FieldArea = {
                    fieldId: this.fieldId,
                    smallField: encodedPath,
                    circle: false,
                    lat: null,
                    lng: null,
                    radius: null,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                };
                this.boundaryManagementService.updateFieldContainingArea(fieldArea).subscribe(() => {
                    this.refreshField();
                    this.mappingService.getFieldSize(this.fieldId).subscribe(fieldsize => {
                        this.fieldS = Number(fieldsize.size);
                        this.nav.toggleLoading(false);
                    });
                });
                this.oneAction = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
                this.drawnPoints = [];

            } else if (result?.option === 'edit') {
                this.editNewArea(this.fieldGoogleMap, this.drawnPoints, false);
                this.oneAction = true;
                this.action    = this.editArea;

            } else if (result?.option === 'redraw') {
                this.resetDrawingState(googleMap, true);

            } else {
                this.isDrawingMode = true;
                this.drawnPoints   = [];
                googleMap.setOptions({ draggableCursor: 'crosshair', disableDoubleClickZoom: true });
            }
        });
    }

    finishCircleDrawing(map?) {
        const googleMap = map?.googleMap ?? this.fieldMap;

        if (!this.previewCircle || this.previewCircle.getRadius() < 1) {
            this.openSnackBar(
                this.translate.instant('MAPPING.DRAW-CIRCLE'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            return;
        }

        const radius = Math.round(this.previewCircle.getRadius());
        const center = this.previewCircle.getCenter();
        const lat = center.lat();
        const lng = center.lng();
        let inside = false;
        let center_inside = false;

        for (let i = 0; i < this.fieldBounds.length; i++) {
            if (this.previewCircle.getBounds().intersects(this.fieldBounds[i].bounds)) {
                inside = true;
                break;
            }
        }

        const outerRing = Array.isArray(this.polygon[0][0])
            ? this.polygon[0][0]
            : this.polygon[0];
        const exixtingPoly = new google.maps.Polygon({ paths: outerRing });

        if (google.maps.geometry.poly.containsLocation(center, exixtingPoly)) {
            center_inside = true;
        }

        if (!inside || !center_inside) {
            this.openSnackBar(
                this.translate.instant('FIELD.DOES-NOT-CONTAIN'),
                this.translate.instant('SNACKBAR.DISMISS')
            );
            return;
        }

        const dialogRef = this.dialog.open(NewAreaComponent, { data: {} });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.option === 'add') {
                this.nav.toggleLoading(true);
                const fieldArea: FieldArea = {
                    fieldId: this.fieldId,
                    smallField: null,
                    circle: true,
                    lat: lat,
                    lng: lng,
                    radius: radius,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                };
                this.boundaryManagementService.updateFieldContainingArea(fieldArea).subscribe(() => {
                    this.refreshField();
                    this.mappingService.getFieldSize(this.fieldId).subscribe(fieldsize => {
                        this.fieldS = Number(fieldsize.size);
                        this.nav.toggleLoading(false);
                    });
                });
                this.clearCircleDrawing({ googleMap: googleMap });
                this.oneAction = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
            } else if (result?.option === 'edit') {
                this.isDrawingMode = false;
                this.clearCircleDrawing({ googleMap: googleMap });

                this.editNewArea(this.fieldGoogleMap, { center: center, radius: radius }, true);

                this.oneAction = true;
                this.action = this.editArea;
                return;

            } else if (result?.option === 'redraw') {
                this.clearCircleDrawing({ googleMap: googleMap });
                this.isDrawingMode = true;
                this.drawingType = 'circle';
                this.oneAction = true;
                this.action = this.excludingArea;
                googleMap.setOptions({
                    draggableCursor: 'crosshair',
                    disableDoubleClickZoom: true
                });
                return;

            } else {
                // redraw or cancel
                this.clearCircleDrawing({ googleMap: googleMap });
                this.isDrawingMode = true;
                googleMap.setOptions({
                    draggableCursor: 'crosshair',
                    disableDoubleClickZoom: true
                });
            }
        });
    }

    clearCircleDrawing(map?) {
        if (this.circleListeners) {
            this.circleListeners.forEach(l => google.maps.event.removeListener(l));
            this.circleListeners = [];
        }
        if (this.previewCircle) {
            this.previewCircle.setMap(null);
            this.previewCircle = null;
        }
        this.circleCenter = null;
        this.isDraggingCircle = false;
        this.clearDrawnMarkers();
    }

    stopAddingField(map?) {
        const googleMap = map?.googleMap ?? this.fieldMap;

        const dialogRef = this.dialog.open(StopDrawingComponent, { data: {} });

        dialogRef.afterClosed().subscribe(result => {
        if (result?.option === 'ok') {
            this.clearDrawnMarkers();
            this.clearCircleDrawing({ googleMap: googleMap });
            if (this.previewPolyline) {
                this.previewPolyline.setMap(null);
                this.previewPolyline = null;
            }
            if (this.previewPolygon) {
                this.previewPolygon.setMap(null);
                this.previewPolygon = null;
            }
            this.isDrawingMode = false;
            this.drawnPoints = [];
            this.drawingType = null;
            this.oneAction = false;
            this.enableBackButton();
            this.nav.enableMenu = true;
            googleMap.setOptions({
                draggableCursor: null,
                disableDoubleClickZoom: true
            });
            this.openOptions();
            }
        });
    }

    openSplitFieldDialog(map) {
      const dialogRef = this.dialog.open(EditFieldComponent, {
        data: {},
        maxWidth: "100%",
        minWidth: "23%"
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          if (result.option == "change") {
            this.editing = true;
            this.editField(map);
            this.oneAction = true;
            this.action = this.busyEditing + ": " + this.fieldName;
            this.splitField = true;
            this.splitFieldName = result.fieldName;
            this.map = map;
          }
        }
      });
    }

    editNewArea(map: GoogleMap, shapeData: any, isCircle: boolean = false) {
        this.editingArea = true;
        this.saveEditedArea = true;
        this.isDrawingMode = false;

        this.singlePolygon = {
            strokeColor: this.fieldBoundaryColor,
            strokeWeight: 4,
            fillOpacity: 0.0,
            editable: true,
            draggable: false
        };

        if (isCircle) {
            const center = shapeData.center;
            const radius = shapeData.radius;

            this.editableCircle = new google.maps.Circle({
                center: center,
                radius: radius,
                map: map.googleMap,
                ...this.singlePolygon
            });

            this.originalCircleCenter = { lat: center.lat(), lng: center.lng() };
            this.originalCircleRadius = radius;

            google.maps.event.addListener(this.editableCircle, 'radius_changed', () => {
                this.saveEditedArea = true;
            });

            google.maps.event.addListener(this.editableCircle, 'center_changed', () => {
                this.saveEditedArea = true;
            });
        } else {
            this.originalAreaPoints = [...shapeData];
            this.editablePolygon = new google.maps.Polygon({
                paths: shapeData.map(p => new google.maps.LatLng(p.lat, p.lng)),
                map: map.googleMap,
                options: this.singlePolygon
            });

            const path = this.editablePolygon.getPath();

            google.maps.event.addListener(path, 'insert_at', (event) => {
                this.saveEditedArea = true;
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'remove_at', (event) => {
                this.saveEditedArea = true;
                this.editablePolygon.setPaths(path);
            });

            google.maps.event.addListener(path, 'set_at', (event) => {
                this.saveEditedArea = true;
                this.editablePolygon.setPaths(path);
            });
        }

        this.oneAction = true;
        this.action = this.editArea;
        this.disableBackButton();
        this.nav.enableMenu = false;
    }

    updateArea() {
        this.nav.toggleLoading(true);
        if (this.editableCircle != null) {
            var radius = this.editableCircle.getRadius();
            var lat = this.editableCircle.getCenter().lat();
            var lng = this.editableCircle.getCenter().lng();

            let fieldArea: FieldArea = {
                fieldId: this.fieldId,
                smallField: null,
                circle: true,
                lat: lat,
                lng: lng,
                radius: radius,
                tenantId: this.tenantId,
                farmId: this.farmId,
                loadingUser: this.userId,
            };

            this.boundaryManagementService.updateFieldContainingArea(fieldArea).subscribe((result) => {
                this.refreshField();
                this.editableCircle.setMap(null);
                this.editableCircle = null;
                this.circleCenter = null;
                this.originalCircleCenter = null;
                this.originalCircleRadius = null;
                this.previewCircle = null;
                this.drawingType = null;
                this.oneAction = false;
                this.saveEditedArea = false;
                this.editingArea = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
                this.nav.toggleLoading(false);
            });

        } else if (this.editablePolygon != null) {
            var encoded = google.maps.geometry.encoding.encodePath(this.editablePolygon.getPath());

            let fieldArea: FieldArea = {
                fieldId: this.fieldId,
                smallField: encoded,
                circle: false,
                lat: null,
                lng: null,
                radius: null,
                tenantId: this.tenantId,
                farmId: this.farmId,
                loadingUser: this.userId,
            };

            this.boundaryManagementService.updateFieldContainingArea(fieldArea).subscribe((result) => {
                this.refreshField();
                this.editablePolygon.setMap(null);
                this.editablePolygon = null;
                this.originalAreaPoints = [];
                this.previewPolyline = null;
                this.drawingType = null;

                this.oneAction = false;
                this.saveEditedArea = false;
                this.editingArea = false;

                this.enableBackButton();
                this.nav.enableMenu = true;
                this.nav.toggleLoading(false);
            });
        }
    }

    cancelEditArea(map: GoogleMap) {
        const dialogRef = this.dialog.open(StopDrawingComponent, { data: {} });

        dialogRef.afterClosed().subscribe(result => {
            if (result?.option === 'ok') {
        if (this.editablePolygon) {
            this.editablePolygon.setMap(null);
            this.editablePolygon = null;
        }

        if (this.editableCircle) {
            this.editableCircle.setMap(null);
            this.editableCircle = null;
        }
                this.clearDrawnMarkers();
                this.clearCircleDrawing(map);

                if (this.previewPolyline) {
                    this.previewPolyline.setMap(null);
                    this.previewPolyline = null;
                }

                if (this.previewPolygon) {
                this.previewPolygon.setMap(null);
                    this.previewPolygon = null;
                }

                this.drawnPoints = [];
                this.originalAreaPoints = [];
                this.originalCircleCenter = null;
                this.originalCircleRadius = null;
                this.circleCenter = null;
                this.drawingType = null;
                this.isDrawingMode = false;
                this.editingArea = false;
                this.saveEditedArea = false;
                this.oneAction = false;
                this.enableBackButton();
                this.nav.enableMenu = true;
                if (map?.googleMap) {
                    map.googleMap.setOptions({ draggableCursor: null });
                }
                this.refreshField();
            }
        });
    }

    disableBackButton() {
        history.pushState(null, null, location.href);

        this.subscription = fromEvent(window, 'popstate').subscribe(_ => {
            history.pushState(null, null, location.href);
        });
    }

    enableBackButton() {
        this.subscription.unsubscribe();
        // Don't navigate away from field component after field operations
        // Just refresh the current field view instead
        this.refreshField();
    }

    refreshField() {
        this.nav.toggleLoading(true);
        this.unsortedPolygons = [];

        this.farmManagementService.getFarmPolygon(this.farmId).subscribe({
            next: (fields) => {
                const field = fields.find((f) => f.id === this.fieldId);
                if (!field) {
                    this.nav.toggleLoading(false);
                    return;
                }
            // console.log(field)
            // @ts-ignore
                const coordinates = field.boundry.features[0].geometry.coordinates;
                const parsed = this.parseFieldCoordinates(
                    field.id, field.name, field.size, coordinates
                );

                this.polygon = [parsed.points];

                this.polygonOptions = {
                    strokeColor:  this.fieldBoundaryColor,
                    strokeWeight: 4,
                    fillOpacity:  0.0,
                };

                this.nav.toggleLoading(false);
            },
            error: (err) => {
                console.error('Failed to refresh field', err);
                this.nav.toggleLoading(false);
            }
        });
    }

    refreshFields(splitField?) {
        this.nav.toggleLoading(true);
      if (this.drawingManager != null && splitField) {
        this.drawingManager.setMap(null);
        splitField?.overlay?.setMap(null);
        this.enableBackButton();
        this.nav.enableMenu = true;

        if(this.splitPolygon) {
          this.splitPolygon.overlay.setMap(null);
          this.splitPolygon = null;
          this.oneAction = false;
        }
            if (this.editableCircle)  { this.editableCircle.setMap(null); }
            if (this.editablePolygon) { this.editablePolygon.setMap(null); }
        }

        this.farmManagementService.getFarmPolygon(this.farmId).subscribe((fields) => {
            this.polygons = [];
            let fieldCounter = 0;

            fields.forEach((field) => {
                this.mappingService.getFieldSize(field.id).subscribe((fieldsize) => {
                    // @ts-ignore
                    const coordinates = field.boundry.features[0].geometry.coordinates;
                    const parsed = this.parseFieldCoordinates(field.id, field.name, fieldsize.size, coordinates);
                    this.polygons.push(parsed);

                    fieldCounter++;
                    if (fieldCounter === fields.length) {
                        this.editing = false;
                        const currentPoly = this.polygons.find((p) => p.id === this.fieldId);
                        if (currentPoly) {
                            this.polygon = [currentPoly.points] as any;
                        }
                        this.nav.toggleLoading(false);
                        // Force staying on current page instead of navigating away
                        window.history.replaceState(null, '', window.location.href);
                        
                        // Ensure we stay on the field component instead of navigating to mapping
                        if (this.router.url.includes('/mapping')) {
                            this.router.navigate(['/field'], { 
                                state: { 
                                    id: this.fieldId, 
                                    farmId: this.farmId, 
                                    farmName: this.farmName 
                                },
                                replaceUrl: true 
                            });
                        }
                    }
                });
            });
        });
    }

    private parseFieldCoordinates(
        id: number,
        name: string,
        size: any,
        coordinates: any[]
    ): { id: number; points: google.maps.LatLngLiteral[][]; size: any; fieldName: string; changed: boolean } {

        const parseRing = (ringCoords: any[]): google.maps.LatLngLiteral[] => {
            const ring: google.maps.LatLngLiteral[] = [];
            for (const coord of ringCoords) {
                if (Array.isArray(coord[0])) {
                    for (const latLng of coord) {
                        ring.push({ lat: Number(latLng[1]), lng: Number(latLng[0]) });
                    }
                } else if (coord.length >= 2) {
                    ring.push({ lat: Number(coord[1]), lng: Number(coord[0]) });
                }
            }
            return ring;
        };

        const rings: google.maps.LatLngLiteral[][] = [];

        for (const coordinate of coordinates) {
            if (!coordinate || coordinate.length === 0) continue;

            const firstItem = coordinate[0];

            if (Array.isArray(firstItem) && Array.isArray(firstItem[0])) {
                for (const subRing of coordinate) {
                    const parsed = parseRing(subRing);
                    if (parsed.length > 0) rings.push(parsed);
                }
            } else {
                const parsed = parseRing(coordinate);
                if (parsed.length > 0) rings.push(parsed);
            }
        }

        return { id, points: rings, size, fieldName: name, changed: false };
    }

    private resetDrawingState(googleMap: google.maps.Map, keepDrawing = false) {
        this.clearDrawnMarkers();
        if (this.previewPolyline) { this.previewPolyline.setMap(null); this.previewPolyline = null; }
        if (this.previewPolygon)  { this.previewPolygon.setMap(null);  this.previewPolygon  = null; }
        this.drawnPoints   = [];

        if (keepDrawing) {
            this.isDrawingMode = true;
            this.oneAction     = true;
            this.action        = this.excludingArea;
            googleMap.setOptions({ draggableCursor: 'crosshair', disableDoubleClickZoom: true });
        } else {
            this.isDrawingMode = false;
            googleMap.setOptions({ draggableCursor: 'crosshair', disableDoubleClickZoom: true });
        }
    }

    removeAreas() {
        this.nav.toggleLoading(true);
        this.openOptions();

        if (this.polygon[0][0].length > 2) {

            this.userId = this.helper.getUserId();
            this.addedPolygons = this.polygons;
            let outsidePoly = [];
            let insideArray = [];

            for (let x = 1; x < this.polygon[0].length; x++) {
                let inside = false;
                this.editablePolygon = new google.maps.Polygon({
                    paths: this.polygon[0][x],
                    map: null,
                    options: this.singlePolygon
                });
                for (let i = 0; i < this.addedPolygons.length; i++) {
                    for (let j = 0; j < this.addedPolygons[i].points.length; j++) {
                        var lat = this.addedPolygons[i].points[j].lat;
                        var lng = this.addedPolygons[i].points[j].lng;
                        const latLng = new google.maps.LatLng(lat, lng);
                        if (google.maps.geometry.poly.containsLocation(latLng, this.editablePolygon)) {
                            if (outsidePoly.find(x => x == this.addedPolygons[i].id)) {
                            } else {

                                outsidePoly.push(this.addedPolygons[i].id);
                                inside = true;

                            }
                        }
                    }
                }
                if (inside) {
                    insideArray.push(true);
                }
            }

            if (insideArray.length < this.polygon[0].length - 1) {
                this.nav.toggleLoading(false);
                let removeArea: RemoveArea = {
                    fieldId: this.fieldId,
                    insideIds: outsidePoly,
                    tenantId: this.tenantId,
                    farmId: this.farmId,
                    loadingUser: this.userId
                };
                this.boundaryManagementService.removeArea(removeArea).subscribe((result) => {
                    this.refreshField();
                    this.mappingService.getFieldSize(this.fieldId).subscribe((fieldsize) => {
                        this.fieldS = Number(fieldsize.size);
                        if (this.plantDate != null) {
                            this.fieldForm.setValue({
                                cropType: this.cropId,
                                fieldName: this.fieldName,
                                cultivar: this.cultivar,
                                plantDate: this.plantDate,
                                fieldSize: this.fieldS.toFixed(2)
                            });
                        } else {
                            this.fieldForm.setValue({
                                cropType: 0,
                                fieldName: this.fieldName,
                                cultivar: '',
                                plantDate: '',
                                fieldSize: this.fieldS.toFixed(2)
                            });
                        }
                    });
                });
            } else {
                this.openSnackBar(this.translate.instant('FIELD.NO-AREA-INSIDE'), this.translate.instant('SNACKBAR.DISMISS'));
            }
        } else {
            this.openSnackBar(this.translate.instant('FIELD.NO-AREA-INSIDE'), this.translate.instant('SNACKBAR.DISMISS'));
        }
        this.nav.toggleLoading(false);
    }


    getMapsequenceRole() {

        if (sessionStorage.getItem("roles") != null) {
            this.roles = JSON.parse(sessionStorage.getItem('roles'));
            this.roles.forEach(role => {

                if (role.name == 'MapSequenceView') {
                    this.isSequenceViewRoleActive = true;
                }
            });
        }
    }

    getGriddingViewRole() {

        if (sessionStorage.getItem("roles") != null) {
            this.roles = JSON.parse(sessionStorage.getItem('roles'));
            this.roles.forEach(role => {

                if (role.name == 'FieldGriddingView') {
                    this.isGriddingViewRoleActive = true;
                }
            });
        }
    }


    togglePinLabels() {
      this.isPinLabelsShowing = !this.isPinLabelsShowing;
                     
      this.setPinLabels();
      this.openOptions();
    }
    
        setPinLabels() {


            this.newSavedPins.forEach(newPin => {
                if ((this.selectedPinType?.id == undefined || newPin?.pinTypeId === this.selectedPinType?.id) && this.isPinLabelsShowing) {

                    let defaultPinDescription = "Unknown Pin";
                    this.savedPinsDataCounter = 0;
                    let description = newPin?.title ?? newPin.description;

                    let position = null;
                    let lat = null, lng = null;

                    if(newPin?.position) {
                        position = newPin.position;
                    } else {
                        lat = newPin.lat;
                        lng = newPin.lng;
                    }

                    let tmpMarker = {
                        id: newPin.id,
                        position: position ?? { lat: lat, lng: lng },
                        title: description ? description : defaultPinDescription,
                        label: {
                            color: 'white',
                            fontFamily: environment.theme.fontFamily || '',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            text: description ? description : defaultPinDescription,
                        },
                        options: google.maps.MarkerOptions = {
                            icon: google.maps.Icon = {
                                url: this.setPinTypeIcon(newPin),
                                scaledSize: new google.maps.Size(0, 0),
                            }
                        },
                        type: 'pinLabel',
                        creatingUser: newPin.userName + " " + newPin.userSurname
                    };

                    this.markers.push(tmpMarker);
                }
                else if(!this.isPinLabelsShowing){

                    for (let i = 0; i < this.markers.length; i++) {
                        if (this.markers[i].type == 'pinLabel' && this.markers[i].type !== 'pin') {
                            this.markers.splice(i, 1);
                            i--;
                        }
                    }
                }
            });
        }



    showGriddingHistory(){

    const dialogConfig = new MatDialogConfig();
          dialogConfig.height = '96vh';
          dialogConfig.disableClose = false; // Allow closing without restriction
          dialogConfig.hasBackdrop = true;
          dialogConfig.panelClass = 'gridding-history-dialog'; // Custom class for styling
    dialogConfig.data = {
      tenantId: this.tenantId,
      fieldId: this.fieldId,
    };

        // Clear any editing states that might interfere with dialog closing
        this.editing = false;
        this.saveField = false;
        this.saveEditedField = false;
        this.saveEditedArea = false;

        const dialogRef = this.dialog.open(RetrievePinGriddingComponent, dialogConfig);

        dialogRef.afterClosed().subscribe(response => {
             this.isOpen = false;

             // If user cancelled, just close without any prompts
             if(!response || response.action === 'cancel'){
                return;
             }

             // this.griddingGroupName = ('Viewing Grid: ' + response.groupName);
            //  console.log(this.griddingGroupName, 'response after dialog close');

             if(!response?.isGrid){
                return;
             }

            this.griddingGroupName = ('Viewing Grid: ' + response.groupName);
            this.isGriddingControlVisable = false;

             let gridConfig = {
                gridSpacing: response?.gridConfig?.gridSpacing,
                gridRotation: response?.gridConfig?.gridRotation
                };

            //  this.loadHistoricalGrid(gridConfig);
             this.setGridPinDetails(response?.groupId, gridConfig.gridSpacing, gridConfig.gridRotation);
      

        });
       
    }


    setGridPinDetails(smapleGroupId: number, gridSpacing?: number, gridRotation?: number) {
        this.nav.toggleLoading(true);

        this.groupService.getHistoricPinDetailsForGriidingBySampleGroupId(smapleGroupId).pipe(
            catchError(error => {
                console.error();
                return throwError(() => error);
            })
        ).subscribe((response) => {
             console.log(response, 'sample group pin info');

              console.log(response, 'response');
            //   this.newSavedPins.push(response);
              console.log(this.newSavedPins, 'new saved pin');

            this.loadHistoricalGrid(gridSpacing, gridRotation, response);
           
            this.nav.toggleLoading(false);
            
        });

    }



// USE historical data available to regenerate a historical grid
loadHistoricalGrid(gridSpacing: number, gridRotation: number, pinDetails: any[]) {
    if (!this.bounds || !this.polygon || this.polygon.length === 0) {
        this.openSnackBar('Field boundary not loaded', 'Dismiss');
        return;
    }

    this.isGeneratingGrid = true;
    this.openSnackBar('Loading historical grid...', '');

    requestAnimationFrame(() => {
        try {
            this.markers = [];
            this.samplingPoints = [];
            this.selectedGridPoints = [];

            // Update gridPointId to continue from remaining count
            const remainingSamplingPoints = this.markers.filter(m => m.type === "sampling");
            this.gridPointId = remainingSamplingPoints.length + 1;
            this.clearGridLines();

            // Create markers from saved pin coordinates
            pinDetails.forEach((pin, index) => {
                const lat = Number(pin.lat);
                const lng = Number(pin.lng);
                
                if (isNaN(lat) || isNaN(lng)) return;
                
                this.samplingPoints.push({
                    id: pin.id || `HP-${index + 1}`,
                    position: { lat, lng },
                    title: pin.description || `Historical Point ${index + 1}`,
                    type: 'sampling',
                    pinTypeId: pin.pinTypeId,
                    content: this.createMarkerContent(this.setPinTypeIcon({ pinTypeId: pin?.pinTypeId, is_completed: pin?.isCompleted }) || 'assets/icons/new_pin_updated.png')
                    // options: {
                    //     icon: {
                    //         url: this.setPinTypeIcon({ pinTypeId: pin?.pinTypeId }) || 'assets/icons/new_pin_updated.png',
                    //         scaledSize: new google.maps.Size(16, 20)
                    //     },
                    //     draggable: false
                    // }
                });
            });

            this.markers = this.markers.concat(this.samplingPoints);
            this.showSamplingPoints = true;

            // Generate grid lines
            if (this.showGridLines) {
                // this.generateHistoricalGridLines(gridSpacing, gridRotation);
            }

            this.isGeneratingGrid = false;
            this.openSnackBar(`Loaded ${this.samplingPoints.length} historical points`, 'Dismiss');

        } catch (error) {
            this.isGeneratingGrid = false;
            this.openSnackBar('Error loading historical grid', 'Dismiss');
            console.error('Historical grid error:', error);
        }
    });
}

// generateHistoricalGridLines(spacing: number, rotation: number) {
    // const north = this.bounds.getNorthEast().lat();
    // const south = this.bounds.getSouthWest().lat();
    // const east = this.bounds.getNorthEast().lng();
    // const west = this.bounds.getSouthWest().lng();

    // const centerLat = (north + south) / 2;
    // const centerLng = (east + west) / 2;
    // const maxDistance = Math.sqrt(Math.pow(north - south, 2) + Math.pow(east - west, 2)) / 2;

    // const expandedNorth = centerLat + maxDistance;
    // const expandedSouth = centerLat - maxDistance;
    // const expandedEast = centerLng + maxDistance;
    // const expandedWest = centerLng - maxDistance;

    // const latSpacing = spacing / 111000;
    // const lngSpacing = spacing / (111000 * Math.cos(centerLat * Math.PI / 180));

    // const fieldPolygon = new google.maps.Polygon({
    //     paths: this.polygon[0]
    // });

    // // Generate grid corners
    // const gridCorners: {lat: number, lng: number}[][] = [];
    // for (let lat = expandedSouth; lat <= expandedNorth; lat += latSpacing) {
    //     const row: {lat: number, lng: number}[] = [];
    //     for (let lng = expandedWest; lng <= expandedEast; lng += lngSpacing) {
    //         row.push({lat, lng});
    //     }
    //     if (row.length > 0) {
    //         gridCorners.push(row);
        // }
    // }

    // Apply rotation if needed
    // if (rotation !== 0) {
    //     for (let row of gridCorners) {
    //         for (let point of row) {
    //             const rotated = this.rotatePoint(point.lat, point.lng, centerLat, centerLng, rotation);
    //             point.lat = rotated.lat;
    //             point.lng = rotated.lng;
    //         }
    //     }
    // }

    // Use existing generateGridLines method
    // this.generateGridLines(gridCorners, fieldPolygon);
// }




 // Function to synchronize map movements -requires split.js library
//  syncMaps(sourceMap, targetMap) {
//         sourceMap.addListener('drag', () => {
//         targetMap.setCenter(sourceMap.getCenter());
//     });
// }

    ngOnDestroy(): void {
        if (this.tenantSubscription) {
            this.tenantSubscription.unsubscribe();
        }
    }

}


